import AdminContext from './context'
import { adminValidationSource } from './validation-source'
import moment from 'moment'

export function workflowLabel(value) {
  if (value && typeof value === 'object' && value.workflowCustomer) return this.workflowCustomerLabel(value.workflowCustomer, value.params)
  if (value && typeof value === 'object' && Array.isArray(value.workflowParts)) return value.workflowParts.map(part => this.workflowLabel(part)).join('')
  switch (value) {
  case 'integrationCorvus.revolutRefundAccepted':
    return this.adminText('integrationCorvus.revolutRefundAccepted', 'Refund request was accepted and is awaiting Revolut confirmation.')
  case 'integrationCorvus.refundPending':
    return this.adminText('integrationCorvus.refundPending', 'Refund requested. Waiting for payment provider confirmation.')
  case 'workflowsAll.add_field_039c631':
    return this.adminText('workflowsAll.add_field_039c631', 'Add field')
  case 'workflowsAll.create_new_attendee_fields_choose_the_order_i_7392218':
    return this.adminText('workflowsAll.create_new_attendee_fields_choose_the_order_i_7392218', 'Create new attendee fields. Choose the order in which they will appear. Fields can be of different types and you can name it like you want.')
  case 'workflowsAll.rearrange_c0d659b':
    return this.adminText('workflowsAll.rearrange_c0d659b', 'REARRANGE')
  case 'workflowsAll.done_e782e77':
    return this.adminText('workflowsAll.done_e782e77', 'DONE')
  case 'workflowsAll.labels_for_first_name_last_name_and_email_are_e997380':
    return this.adminText('workflowsAll.labels_for_first_name_last_name_and_email_are_e997380', 'Labels for First name, Last name and Email are editable on the Translate page.')
  case 'workflowsAll.lock_icon_b0bda83':
    return this.adminText('workflowsAll.lock_icon_b0bda83', 'lock-icon')
  case 'workflowsAll.entry_from_2ea1c29':
    return this.adminText('workflowsAll.entry_from_2ea1c29', 'Entry from*')
  case 'workflowsAll.entry_to_f6ccf63':
    return this.adminText('workflowsAll.entry_to_f6ccf63', 'Entry to*')
  case 'workflowsAll.select_ticket_eee0c42':
    return this.adminText('workflowsAll.select_ticket_eee0c42', 'Select ticket')
  case 'workflowsAll.select_the_ticket_type_to_assign_to_the_atten_f8090c8':
    return this.adminText('workflowsAll.select_the_ticket_type_to_assign_to_the_atten_f8090c8', 'Select the ticket type to assign to the attendee with a full (100%) discount. This will be reflected in the statistics as a free ticket.')
  case 'workflowsAll.cancel_77dfd21':
    return this.adminText('workflowsAll.cancel_77dfd21', 'Cancel')
  case 'workflowsAll.create_print_09e9252':
    return this.adminText('workflowsAll.create_print_09e9252', 'Create & Print')
  case 'workflowsAll.before_printing_the_accreditations_you_need_t_794b347':
    return this.adminText('workflowsAll.before_printing_the_accreditations_you_need_t_794b347', 'Before printing the accreditations, you need to create a template for them in Design Tool.')
  case 'workflowsAll.create_6e157c5':
    return this.adminText('workflowsAll.create_6e157c5', 'Create')
  case 'workflowsAll.open_create_actions_6538f2e':
    return this.adminText('workflowsAll.open_create_actions_6538f2e', 'Open create actions')
  case 'workflowsAll.create_and_send_ticket_92387d0':
    return this.adminText('workflowsAll.create_and_send_ticket_92387d0', 'Create and send ticket')
  case 'workflowsAll.order_details_1a89794':
    return this.adminText('workflowsAll.order_details_1a89794', 'Order details')
  case 'workflowsAll.accreditation_details_b95ff7d':
    return this.adminText('workflowsAll.accreditation_details_b95ff7d', 'Accreditation details')
  case 'workflowsAll.loading_b04ba49':
    return this.adminText('workflowsAll.loading_b04ba49', 'Loading...')
  case 'workflowsAll.order_100_ed40022':
    return this.adminText('workflowsAll.order_100_ed40022', 'Order #100')
  case 'workflowsAll.bought_online_b15ee82':
    return this.adminText('workflowsAll.bought_online_b15ee82', 'Bought online')
  case 'workflowsAll.ticket_buyer_a81c2f5':
    return this.adminText('workflowsAll.ticket_buyer_a81c2f5', 'Ticket Buyer')
  case 'workflowsAll.buyer_email_1a764f2':
    return this.adminText('workflowsAll.buyer_email_1a764f2', 'Buyer Email')
  case 'workflowsAll.resend_0f4f469':
    return this.adminText('workflowsAll.resend_0f4f469', 'Resend')
  case 'workflowsAll.ticket_owners_8b115f2':
    return this.adminText('workflowsAll.ticket_owners_8b115f2', 'Ticket owners')
  case 'workflowsAll.edit_owners_info_61fdf92':
    return this.adminText('workflowsAll.edit_owners_info_61fdf92', 'Edit owners info')
  case 'workflowsAll.the_owner_s_information_is_the_same_as_the_bu_0cff0c8':
    return this.adminText('workflowsAll.the_owner_s_information_is_the_same_as_the_bu_0cff0c8', 'The owner’s information is the same as the buyer’s information')
  case 'workflowsAll.update_fb91e24':
    return this.adminText('workflowsAll.update_fb91e24', 'Update')
  case 'workflowsAll.ticket_owner_0899669':
    return this.adminText('workflowsAll.ticket_owner_0899669', 'Ticket owner #')
  case 'workflowsAll.download_ticket_5974d30':
    return this.adminText('workflowsAll.download_ticket_5974d30', 'Download ticket')
  case 'workflowsAll.print_accreditation_cf80d0e':
    return this.adminText('workflowsAll.print_accreditation_cf80d0e', 'Print accreditation')
  case 'workflowsAll.accreditation_info_5adbd71':
    return this.adminText('workflowsAll.accreditation_info_5adbd71', 'Accreditation info')
  case 'workflowsAll.subtotal_97f7359':
    return this.adminText('workflowsAll.subtotal_97f7359', 'Subtotal')
  case 'workflowsAll.total_b25928c':
    return this.adminText('workflowsAll.total_b25928c', 'Total')
  case 'workflowsAll.vat_included_in_the_price_32ef420':
    return this.adminText('workflowsAll.vat_included_in_the_price_32ef420', 'VAT included in the price')
  case 'workflowsAll.download_tickets_a7e03fc':
    return this.adminText('workflowsAll.download_tickets_a7e03fc', 'Download tickets (')
  case 'workflowsAll.print_accreditations_d690894':
    return this.adminText('workflowsAll.print_accreditations_d690894', 'Print accreditations (')
  case 'workflowsAll.cancel_order_5ae39c4':
    return this.adminText('workflowsAll.cancel_order_5ae39c4', 'Cancel order')
  case 'workflowsAll.print_history_c67fc1a':
    return this.adminText('workflowsAll.print_history_c67fc1a', 'Print history')
  case 'workflowsAll.no_prints_yet_ed9b462':
    return this.adminText('workflowsAll.no_prints_yet_ed9b462', 'No prints yet.')
  case 'workflowsAll.delete_accreditation_2da0b1b':
    return this.adminText('workflowsAll.delete_accreditation_2da0b1b', 'Delete accreditation')
  case 'workflowsAll.are_you_sure_you_want_to_delete_accreditation_bedaf86':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_accreditation_bedaf86', 'Are you sure you want to delete accreditation? This operation cannot be undone.')
  case 'workflowsAll.refund_warning_587b421':
    return this.adminText('workflowsAll.refund_warning_587b421', 'Refund warning')
  case 'workflowsAll.cancellation_fees_may_apply_for_paid_tickets_e53fc57':
    return this.adminText('workflowsAll.cancellation_fees_may_apply_for_paid_tickets_e53fc57', 'Cancellation fees may apply for paid tickets.')
  case 'workflowsAll.no_fees_apply_for_free_tickets_6d3802b':
    return this.adminText('workflowsAll.no_fees_apply_for_free_tickets_6d3802b', 'No fees apply for free tickets.')
  case 'workflowsAll.proceed_02ed4a4':
    return this.adminText('workflowsAll.proceed_02ed4a4', 'Proceed')
  case 'workflowsAll.add_attendee_dd630f2':
    return this.adminText('workflowsAll.add_attendee_dd630f2', 'Add attendee')
  case 'workflowsAll.attendee_list_87ae776':
    return this.adminText('workflowsAll.attendee_list_87ae776', 'Attendee list')
  case 'workflowsAll.here_you_can_create_manage_and_search_attende_60e0cd3':
    return this.adminText('workflowsAll.here_you_can_create_manage_and_search_attende_60e0cd3', 'Here you can create, manage and search attendees. Also, you can print accreditations for one, more or all of them. You can customize the list by choosing which columns to display - up to 10 of them.')
  case 'workflowsAll.you_can_create_up_to_20_accreditations_in_tri_0b2a5bd':
    return this.adminText('workflowsAll.you_can_create_up_to_20_accreditations_in_tri_0b2a5bd', 'You can create up to 20 accreditations in trial version')
  case 'workflowsAll.add_attendee_d1b4b9c':
    return this.adminText('workflowsAll.add_attendee_d1b4b9c', 'Add Attendee')
  case 'workflowsAll.print_icon_2378e41':
    return this.adminText('workflowsAll.print_icon_2378e41', 'Print icon')
  case 'workflowsAll.print_all_e2be7c1':
    return this.adminText('workflowsAll.print_all_e2be7c1', 'Print all')
  case 'workflowsAll.no_matching_records_found_0c7f0a6':
    return this.adminText('workflowsAll.no_matching_records_found_0c7f0a6', 'No matching records found.')
  case 'workflowsAll.are_you_sure_you_want_to_delete_selected_accr_260853d':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_accr_260853d', 'Are you sure you want to delete selected accreditations? This operation cannot be undone.')
  case 'workflowsAll.delete_accreditations_b25367f':
    return this.adminText('workflowsAll.delete_accreditations_b25367f', 'Delete accreditations')
  case 'workflowsAll.create_e_mail_invitation_a089321':
    return this.adminText('workflowsAll.create_e_mail_invitation_a089321', 'Create e-mail invitation')
  case 'workflowsAll.cancel_1507c40':
    return this.adminText('workflowsAll.cancel_1507c40', 'CANCEL')
  case 'workflowsAll.send_test_email_0d478c0':
    return this.adminText('workflowsAll.send_test_email_0d478c0', 'SEND TEST EMAIL')
  case 'workflowsAll.send_a2469c4':
    return this.adminText('workflowsAll.send_a2469c4', 'SEND')
  case 'workflowsAll.success_42a8f65':
    return this.adminText('workflowsAll.success_42a8f65', 'Success')
  case 'workflowsAll.your_test_email_was_sent_successfully_to_the__96f4428':
    return this.adminText('workflowsAll.your_test_email_was_sent_successfully_to_the__96f4428', 'Your test email was sent successfully to the organizer!')
  case 'workflowsAll.oops_c8e633f':
    return this.adminText('workflowsAll.oops_c8e633f', 'Oops')
  case 'workflowsAll.an_error_occurred_while_trying_to_send_your_e_adbb9de':
    return this.adminText('workflowsAll.an_error_occurred_while_trying_to_send_your_e_adbb9de', 'An error occurred while trying to send your email.')
  case 'workflowsAll.curated_invitations_e5c06ad':
    return this.adminText('workflowsAll.curated_invitations_e5c06ad', 'Curated invitations')
  case 'workflowsAll.add_invitee_0ab0731':
    return this.adminText('workflowsAll.add_invitee_0ab0731', 'Add invitee')
  case 'workflowsAll.import_d6fbc9d':
    return this.adminText('workflowsAll.import_d6fbc9d', 'Import')
  case 'workflowsAll.export_f3e4fad':
    return this.adminText('workflowsAll.export_f3e4fad', 'Export')
  case 'workflowsAll.create_email_cf6523e':
    return this.adminText('workflowsAll.create_email_cf6523e', 'Create email')
  case 'workflowsAll.e_mails_to_invitees_a560441':
    return this.adminText('workflowsAll.e_mails_to_invitees_a560441', 'E-mails to invitees')
  case 'workflowsAll.rows_per_page_79df325':
    return this.adminText('workflowsAll.rows_per_page_79df325', 'Rows per page:')
  case 'workflowsAll.sent_35f49dc':
    return this.adminText('workflowsAll.sent_35f49dc', 'Sent')
  case 'workflowsAll.create_your_first_referral_3d73968':
    return this.adminText('workflowsAll.create_your_first_referral_3d73968', 'Create your first referral')
  case 'workflowsAll.are_you_sure_you_want_to_delete_selected_emai_23aa06b':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_emai_23aa06b', 'Are you sure you want to delete selected email? This operation cannot be undone.')
  case 'workflowsAll.delete_email_12b2a4e':
    return this.adminText('workflowsAll.delete_email_12b2a4e', 'Delete email')
  case 'workflowsAll.your_email_was_sent_successfully_d225ae7':
    return this.adminText('workflowsAll.your_email_was_sent_successfully_d225ae7', 'Your email was sent successfully!')
  case 'workflowsAll.status_bae7d5b':
    return this.adminText('workflowsAll.status_bae7d5b', 'Status')
  case 'workflowsAll.type_3deb745':
    return this.adminText('workflowsAll.type_3deb745', 'Type')
  case 'workflowsAll.subject_8d183db':
    return this.adminText('workflowsAll.subject_8d183db', 'Subject')
  case 'workflowsAll.recipients_78cbf8e':
    return this.adminText('workflowsAll.recipients_78cbf8e', 'Recipients')
  case 'workflowsAll.attendance_requests_8c87c6d':
    return this.adminText('workflowsAll.attendance_requests_8c87c6d', 'Attendance requests')
  case 'workflowsAll.below_you_can_see_the_list_of_event_attendanc_8665076':
    return this.adminText('workflowsAll.below_you_can_see_the_list_of_event_attendanc_8665076', 'Below you can see the list of event attendance requests, which you can approve or deny. If the setting is on, corresponding mail will be sent to approved or denied attendees.')
  case 'workflowsAll.are_you_sure_you_want_to_deny_selected_reques_9537f4e':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_deny_selected_reques_9537f4e', 'Are you sure you want to deny selected requests? This operation cannot be undone.')
  case 'workflowsAll.deny_attendees_56c00e2':
    return this.adminText('workflowsAll.deny_attendees_56c00e2', 'Deny attendees')
  case 'workflowsAll.deny_53577bb':
    return this.adminText('workflowsAll.deny_53577bb', 'Deny')
  case 'workflowsAll.invite_attendees_9c2ffd6':
    return this.adminText('workflowsAll.invite_attendees_9c2ffd6', 'Invite attendees')
  case 'workflowsAll.close_event_applications_9eca4ec':
    return this.adminText('workflowsAll.close_event_applications_9eca4ec', 'Close event applications')
  case 'workflowsAll.open_event_applications_552442a':
    return this.adminText('workflowsAll.open_event_applications_552442a', 'Open event applications')
  case 'workflowsAll.closing_applications_includes_rejecting_all_p_8de0f31':
    return this.adminText('workflowsAll.closing_applications_includes_rejecting_all_p_8de0f31', 'Closing applications includes rejecting all pending requests and disables further registrations. Are you sure you want to close applications for this event?')
  case 'workflowsAll.close_bbfa773':
    return this.adminText('workflowsAll.close_bbfa773', 'Close')
  case 'workflowsAll.oops_something_went_wrong_74c86ae':
    return this.adminText('workflowsAll.oops_something_went_wrong_74c86ae', 'Oops, Something went wrong!')
  case 'workflowsAll.ticket_types_b974d11':
    return this.adminText('workflowsAll.ticket_types_b974d11', 'Ticket types')
  case 'workflowsAll.search_attendees_7e5743e':
    return this.adminText('workflowsAll.search_attendees_7e5743e', 'Search Attendees')
  case 'workflowsAll.performance_63c9045':
    return this.adminText('workflowsAll.performance_63c9045', 'Performance')
  case 'workflowsAll.loading_subscription_pass_details_6ec77ca':
    return this.adminText('workflowsAll.loading_subscription_pass_details_6ec77ca', 'Loading subscription pass details')
  case 'workflowsAll.subscriber_16b20e6':
    return this.adminText('workflowsAll.subscriber_16b20e6', 'Subscriber')
  case 'workflowsAll.email_84add5b':
    return this.adminText('workflowsAll.email_84add5b', 'Email')
  case 'workflowsAll.user_details_5082f10':
    return this.adminText('workflowsAll.user_details_5082f10', 'User details')
  case 'workflowsAll.qr_barcode_eb83f6c':
    return this.adminText('workflowsAll.qr_barcode_eb83f6c', 'QR / barcode')
  case 'workflowsAll.venue_67cd406':
    return this.adminText('workflowsAll.venue_67cd406', 'Venue')
  case 'workflowsAll.seat_b90b325':
    return this.adminText('workflowsAll.seat_b90b325', 'Seat')
  case 'workflowsAll.access_status_4238215':
    return this.adminText('workflowsAll.access_status_4238215', 'Access status')
  case 'workflowsAll.valid_from_5c6bcf9':
    return this.adminText('workflowsAll.valid_from_5c6bcf9', 'Valid From:')
  case 'workflowsAll.valid_to_d3fe90f':
    return this.adminText('workflowsAll.valid_to_d3fe90f', 'Valid To:')
  case 'workflowsAll.payment_status_9dfea40':
    return this.adminText('workflowsAll.payment_status_9dfea40', 'Payment status')
  case 'workflowsAll.subscription_pass_ec57207':
    return this.adminText('workflowsAll.subscription_pass_ec57207', 'Subscription pass')
  case 'workflowsAll.access_2f81a22':
    return this.adminText('workflowsAll.access_2f81a22', 'Access')
  case 'workflowsAll.this_access_applies_only_to_the_selected_perf_1586f06':
    return this.adminText('workflowsAll.this_access_applies_only_to_the_selected_perf_1586f06', 'This access applies only to the selected performance.')
  case 'workflowsAll.toggle_print_history_cea4bd9':
    return this.adminText('workflowsAll.toggle_print_history_cea4bd9', 'Toggle print history')
  case 'workflowsAll.remove_access_to_7121597':
    return this.adminText('workflowsAll.remove_access_to_7121597', 'Remove access to')
  case 'workflowsAll.close_dialog_7b29020':
    return this.adminText('workflowsAll.close_dialog_7b29020', 'Close dialog')
  case 'workflowsAll.this_seat_will_be_released_3695ea3':
    return this.adminText('workflowsAll.this_seat_will_be_released_3695ea3', 'This seat will be released')
  case 'workflowsAll.your_subscription_and_access_to_all_other_per_a11e2e4':
    return this.adminText('workflowsAll.your_subscription_and_access_to_all_other_per_a11e2e4', 'Your subscription and access to all other performances will remain unchanged.')
  case 'workflowsAll.revoke_access_094386f':
    return this.adminText('workflowsAll.revoke_access_094386f', 'Revoke access')
  case 'workflowsAll.category_a3c686e':
    return this.adminText('workflowsAll.category_a3c686e', 'Category')
  case 'workflowsAll.zones_182e2eb':
    return this.adminText('workflowsAll.zones_182e2eb', 'Zones')
  case 'workflowsAll.download_d41afcd':
    return this.adminText('workflowsAll.download_d41afcd', 'Download:')
  case 'workflowsAll.najvise_32_znaka_ukljucujuci_razmake_molimo_s_5e9369e':
    return this.adminText('workflowsAll.najvise_32_znaka_ukljucujuci_razmake_molimo_s_5e9369e', 'Najviše 32 znaka (uključujući razmake). Molimo skratite naziv — primjer: Ministarstvo regionalnog razvoja i fondova Europske unije: MRRFEU.')
  case 'workflowsAll.english_649df08':
    return this.adminText('workflowsAll.english_649df08', 'English')
  case 'workflowsAll.croatian_3e5488a':
    return this.adminText('workflowsAll.croatian_3e5488a', 'Croatian')
  case 'workflowsAll.copy_aecf029':
    return this.adminText('workflowsAll.copy_aecf029', 'COPY')
  case 'workflowsAll.qr_code_4474218':
    return this.adminText('workflowsAll.qr_code_4474218', 'QR Code')
  case 'workflowsAll.light_a36ef8a':
    return this.adminText('workflowsAll.light_a36ef8a', 'Light')
  case 'workflowsAll.dark_ae1ef01':
    return this.adminText('workflowsAll.dark_ae1ef01', 'Dark')
  case 'workflowsAll.download_qr_code_2112d52':
    return this.adminText('workflowsAll.download_qr_code_2112d52', 'Download QR Code')
  case 'workflowsAll.copied_to_clipboard_0e73834':
    return this.adminText('workflowsAll.copied_to_clipboard_0e73834', 'Copied to clipboard')
  case 'workflowsAll.customize_239dce6':
    return this.adminText('workflowsAll.customize_239dce6', 'Customize')
  case 'workflowsAll.customize_table_display_35285bc':
    return this.adminText('workflowsAll.customize_table_display_35285bc', 'Customize table display')
  case 'workflowsAll.select_up_to_10_columns_to_display_in_the_att_394ab09':
    return this.adminText('workflowsAll.select_up_to_10_columns_to_display_in_the_att_394ab09', 'Select up to 10 columns to display in the Attendee list table.')
  case 'workflowsAll.drag_above_the_line_to_display_3072f28':
    return this.adminText('workflowsAll.drag_above_the_line_to_display_3072f28', 'Drag above the line to display')
  case 'workflowsAll.apply_cfea419':
    return this.adminText('workflowsAll.apply_cfea419', 'Apply')
  case 'workflowsAll.display_filters_356c0ed':
    return this.adminText('workflowsAll.display_filters_356c0ed', 'Display filters')
  case 'workflowsAll.apply_filters_to_narrow_the_amount_of_diplaye_f34a406':
    return this.adminText('workflowsAll.apply_filters_to_narrow_the_amount_of_diplaye_f34a406', 'Apply filters to narrow the amount of diplayed attendees.')
  case 'workflowsAll.remove_filters_1fa0c6e':
    return this.adminText('workflowsAll.remove_filters_1fa0c6e', 'Remove filters')
  case 'workflowsAll.quick_search_3c4cdb3':
    return this.adminText('workflowsAll.quick_search_3c4cdb3', 'Quick search')
  case 'workflowsAll.sale_status_a3c9514':
    return this.adminText('workflowsAll.sale_status_a3c9514', 'Sale Status')
  case 'workflowsAll.info_icon_0a6b333':
    return this.adminText('workflowsAll.info_icon_0a6b333', 'info icon')
  case 'workflowsAll.loading_attendees_78e3f8b':
    return this.adminText('workflowsAll.loading_attendees_78e3f8b', 'Loading attendees')
  case 'workflowsAll.email_copied_47a1583':
    return this.adminText('workflowsAll.email_copied_47a1583', 'Email copied')
  case 'workflowsAll.click_to_copy_8ef0779':
    return this.adminText('workflowsAll.click_to_copy_8ef0779', 'Click to copy')
  case 'workflowsAll.send_email_619a901':
    return this.adminText('workflowsAll.send_email_619a901', 'Send email')
  case 'workflowsAll.rows_per_page_6644eda':
    return this.adminText('workflowsAll.rows_per_page_6644eda', 'rows per page')
  case 'workflowsAll.attendee_selected_c7ed79d':
    return this.adminText('workflowsAll.attendee_selected_c7ed79d', 'attendee selected')
  case 'workflowsAll.attendees_selected_e31aafb':
    return this.adminText('workflowsAll.attendees_selected_e31aafb', 'attendees selected')
  case 'workflowsAll.send_email_a5ad5ff':
    return this.adminText('workflowsAll.send_email_a5ad5ff', 'send email')
  case 'workflowsAll.print_6d0d587':
    return this.adminText('workflowsAll.print_6d0d587', 'print')
  case 'workflowsAll.accept_5fb801f':
    return this.adminText('workflowsAll.accept_5fb801f', 'accept')
  case 'workflowsAll.delete_9485989':
    return this.adminText('workflowsAll.delete_9485989', 'delete')
  case 'workflowsAll.accept_bb54db5':
    return this.adminText('workflowsAll.accept_bb54db5', 'Accept')
  case 'workflowsAll.deny_1d16dc2':
    return this.adminText('workflowsAll.deny_1d16dc2', 'deny')
  case 'workflowsAll.send_invitation_with_a_pre_defined_attendee_c_4c4f14b':
    return this.adminText('workflowsAll.send_invitation_with_a_pre_defined_attendee_c_4c4f14b', 'Send invitation with a pre-defined attendee category')
  case 'workflowsAll.when_enabled_the_invitation_is_sent_with_a_ca_337a324':
    return this.adminText('workflowsAll.when_enabled_the_invitation_is_sent_with_a_ca_337a324', 'When enabled, the invitation is sent with a category pre-selected by the organizer. When disabled, attendees choose their own category during registration.')
  case 'workflowsAll.edit_invite_information_1e86564':
    return this.adminText('workflowsAll.edit_invite_information_1e86564', 'Edit invite information')
  case 'workflowsAll.rename_fields_change_titles_and_description_f_1869789':
    return this.adminText('workflowsAll.rename_fields_change_titles_and_description_f_1869789', 'Rename fields. Change titles and description for every step in registration form.')
  case 'workflowsAll.register_0391d22':
    return this.adminText('workflowsAll.register_0391d22', 'REGISTER')
  case 'workflowsAll.workshops_e12c846':
    return this.adminText('workflowsAll.workshops_e12c846', 'WORKSHOPS')
  case 'workflowsAll.registered_5d1c39f':
    return this.adminText('workflowsAll.registered_5d1c39f', 'REGISTERED')
  case 'workflowsAll.closed_be3e73b':
    return this.adminText('workflowsAll.closed_be3e73b', 'CLOSED')
  case 'workflowsAll.event_closed_0a46550':
    return this.adminText('workflowsAll.event_closed_0a46550', 'Event closed')
  case 'workflowsAll.title_768e0c1':
    return this.adminText('workflowsAll.title_768e0c1', 'Title')
  case 'workflowsAll.description_55f8ebc':
    return this.adminText('workflowsAll.description_55f8ebc', 'Description')
  case 'workflowsAll.submit_note_947bc8a':
    return this.adminText('workflowsAll.submit_note_947bc8a', 'Submit note')
  case 'workflowsAll.submit_info_5b11aaa':
    return this.adminText('workflowsAll.submit_info_5b11aaa', 'Submit info')
  case 'workflowsAll.workshops_are_required_0210488':
    return this.adminText('workflowsAll.workshops_are_required_0210488', 'Workshops are required')
  case 'workflowsAll.snackbar_validation_text_622dad3':
    return this.adminText('workflowsAll.snackbar_validation_text_622dad3', 'Snackbar validation text')
  case 'workflowsAll.odaberi_jos_min_0096fdc':
    return this.adminText('workflowsAll.odaberi_jos_min_0096fdc', '*Odaberi još min.')
  case 'workflowsAll.ulaznica_be99fe0':
    return this.adminText('workflowsAll.ulaznica_be99fe0', 'ulaznica')
  case 'workflowsAll.izbrisi_0cadab4':
    return this.adminText('workflowsAll.izbrisi_0cadab4', 'Izbriši')
  case 'workflowsAll.back_button_4e9e2cc':
    return this.adminText('workflowsAll.back_button_4e9e2cc', 'Back Button')
  case 'workflowsAll.no_tickets_d399337':
    return this.adminText('workflowsAll.no_tickets_d399337', 'no tickets')
  case 'workflowsAll.tickets_5c622a5':
    return this.adminText('workflowsAll.tickets_5c622a5', 'Tickets')
  case 'workflowsAll.gratis_92fc95b':
    return this.adminText('workflowsAll.gratis_92fc95b', 'gratis')
  case 'workflowsAll.vase_clanstvo_ukljucuje_ulaznice_po_povlasten_58e2771':
    return this.adminText('workflowsAll.vase_clanstvo_ukljucuje_ulaznice_po_povlasten_58e2771', 'Vaše članstvo uključuje ulaznice po povlaštenoj cijeni.')
  case 'workflowsAll.red_cc9db3a':
    return this.adminText('workflowsAll.red_cc9db3a', 'Red')
  case 'workflowsAll.sjedalo_2023ccc':
    return this.adminText('workflowsAll.sjedalo_2023ccc', 'Sjedalo')
  case 'workflowsAll.download_subscription_9662775':
    return this.adminText('workflowsAll.download_subscription_9662775', 'Download subscription')
  case 'workflowsAll.announcements_06b01c4':
    return this.adminText('workflowsAll.announcements_06b01c4', 'Announcements')
  case 'workflowsAll.make_an_announcement_to_the_attendees_of_your_4a9fb1a':
    return this.adminText('workflowsAll.make_an_announcement_to_the_attendees_of_your_4a9fb1a', 'Make an announcement to the attendees of your event through the mobile app to keep them updated on everything related to the event. Here you can add or edit the announcements.')
  case 'workflowsAll.create_announcement_dd8f115':
    return this.adminText('workflowsAll.create_announcement_dd8f115', 'Create announcement')
  case 'workflowsAll.date_eb9a4bc':
    return this.adminText('workflowsAll.date_eb9a4bc', 'Date')
  case 'workflowsAll.send_notification_6140a68':
    return this.adminText('workflowsAll.send_notification_6140a68', 'Send notification')
  case 'workflowsAll.announcement_cf84a98':
    return this.adminText('workflowsAll.announcement_cf84a98', 'Announcement')
  case 'workflowsAll.delete_f6fdbe4':
    return this.adminText('workflowsAll.delete_f6fdbe4', 'Delete')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_announce_1f1f244':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_announce_1f1f244', 'Are you sure you want to delete this announcement? This operation cannot be undone.')
  case 'workflowsAll.remove_announcement_793fe6e':
    return this.adminText('workflowsAll.remove_announcement_793fe6e', 'Remove announcement')
  case 'workflowsAll.create_announcement_ab68a44':
    return this.adminText('workflowsAll.create_announcement_ab68a44', 'Create Announcement')
  case 'workflowsAll.you_need_to_provide_information_about_your_ne_bb502bf':
    return this.adminText('workflowsAll.you_need_to_provide_information_about_your_ne_bb502bf', 'You need to provide information about your new announcement.')
  case 'workflowsAll.something_went_wrong_ccbbe60':
    return this.adminText('workflowsAll.something_went_wrong_ccbbe60', 'Something went wrong...')
  case 'workflowsAll.announcement_title_d5521a2':
    return this.adminText('workflowsAll.announcement_title_d5521a2', 'Announcement title')
  case 'workflowsAll.announcement_text_0179106':
    return this.adminText('workflowsAll.announcement_text_0179106', 'Announcement text')
  case 'workflowsAll.sorry_design_tool_is_currently_only_available_4e5077c':
    return this.adminText('workflowsAll.sorry_design_tool_is_currently_only_available_4e5077c', 'Sorry, Design Tool is currently only available for Desktop.')
  case 'workflowsAll.design_library_9ddf9ca':
    return this.adminText('workflowsAll.design_library_9ddf9ca', 'Design library')
  case 'workflowsAll.components_9289473':
    return this.adminText('workflowsAll.components_9289473', 'Components')
  case 'workflowsAll.drag_a_component_onto_the_badge_to_add_it_b930eff':
    return this.adminText('workflowsAll.drag_a_component_onto_the_badge_to_add_it_b930eff', 'Drag a component onto the badge to add it.')
  case 'workflowsAll.accreditation_designer_f74b807':
    return this.adminText('workflowsAll.accreditation_designer_f74b807', 'Accreditation designer')
  case 'workflowsAll.front_side_9512dc8':
    return this.adminText('workflowsAll.front_side_9512dc8', 'Front side')
  case 'workflowsAll.back_side_a2c84b7':
    return this.adminText('workflowsAll.back_side_a2c84b7', 'Back side')
  case 'workflowsAll.format_041a5de':
    return this.adminText('workflowsAll.format_041a5de', 'Format')
  case 'workflowsAll.build_the_primary_accreditation_layout_759609b':
    return this.adminText('workflowsAll.build_the_primary_accreditation_layout_759609b', 'Build the primary accreditation layout.')
  case 'workflowsAll.design_what_is_printed_on_the_reverse_side_7a458bd':
    return this.adminText('workflowsAll.design_what_is_printed_on_the_reverse_side_7a458bd', 'Design what is printed on the reverse side.')
  case 'workflowsAll.select_accreditation_side_cb6bddb':
    return this.adminText('workflowsAll.select_accreditation_side_cb6bddb', 'Select accreditation side')
  case 'workflowsAll.front_dd19f98':
    return this.adminText('workflowsAll.front_dd19f98', 'Front')
  case 'workflowsAll.back_b52b36b':
    return this.adminText('workflowsAll.back_b52b36b', 'Back')
  case 'workflowsAll.disable_back_side_2bd2656':
    return this.adminText('workflowsAll.disable_back_side_2bd2656', 'Disable back side')
  case 'workflowsAll.edit_selected_component_1394f0c':
    return this.adminText('workflowsAll.edit_selected_component_1394f0c', 'Edit selected component')
  case 'workflowsAll.select_a_component_to_adjust_its_style_66e8d9f':
    return this.adminText('workflowsAll.select_a_component_to_adjust_its_style_66e8d9f', 'Select a component to adjust its style')
  case 'workflowsAll.add_background_7644fe6':
    return this.adminText('workflowsAll.add_background_7644fe6', 'Add background')
  case 'workflowsAll.remove_background_e194638':
    return this.adminText('workflowsAll.remove_background_e194638', 'Remove background')
  case 'workflowsAll.continue_editing_b101465':
    return this.adminText('workflowsAll.continue_editing_b101465', 'Continue editing')
  case 'workflowsAll.preview_f1fbb2b':
    return this.adminText('workflowsAll.preview_f1fbb2b', 'Preview')
  case 'workflowsAll.save_changes_179359b':
    return this.adminText('workflowsAll.save_changes_179359b', 'Save changes')
  case 'workflowsAll.design_saved_d72fbe5':
    return this.adminText('workflowsAll.design_saved_d72fbe5', 'Design saved')
  case 'workflowsAll.use_category_color_c24e42c':
    return this.adminText('workflowsAll.use_category_color_c24e42c', 'Use category color')
  case 'workflowsAll.upload_image_159031e':
    return this.adminText('workflowsAll.upload_image_159031e', 'Upload Image')
  case 'workflowsAll.full_name_eeb6920':
    return this.adminText('workflowsAll.full_name_eeb6920', 'Full name')
  case 'workflowsAll.country_name_e0c9676':
    return this.adminText('workflowsAll.country_name_e0c9676', 'Country name')
  case 'workflowsAll.country_flag_3dbe3ba':
    return this.adminText('workflowsAll.country_flag_3dbe3ba', 'Country flag')
  case 'workflowsAll.country_code_2eb6c4c':
    return this.adminText('workflowsAll.country_code_2eb6c4c', 'Country code')
  case 'workflowsAll.attendee_image_220ddc6':
    return this.adminText('workflowsAll.attendee_image_220ddc6', 'Attendee image')
  case 'workflowsAll.rectangle_c158695':
    return this.adminText('workflowsAll.rectangle_c158695', 'Rectangle')
  case 'workflowsAll.rounded_rectangle_1ac087b':
    return this.adminText('workflowsAll.rounded_rectangle_1ac087b', 'Rounded rectangle')
  case 'workflowsAll.qr_code_abba02f':
    return this.adminText('workflowsAll.qr_code_abba02f', 'QR code')
  case 'workflowsAll.text_c3328c3':
    return this.adminText('workflowsAll.text_c3328c3', 'Text')
  case 'workflowsAll.id_474ae52':
    return this.adminText('workflowsAll.id_474ae52', 'Id')
  case 'workflowsAll.image_50e19fd':
    return this.adminText('workflowsAll.image_50e19fd', 'Image')
  case 'workflowsAll.oval_a4db0b5':
    return this.adminText('workflowsAll.oval_a4db0b5', 'Oval')
  case 'workflowsAll.barcode_8e54dc5':
    return this.adminText('workflowsAll.barcode_8e54dc5', 'Barcode')
  case 'workflowsAll.print_count_55b3e6a':
    return this.adminText('workflowsAll.print_count_55b3e6a', 'Print count')
  case 'workflowsAll.enter_text_9c05f58':
    return this.adminText('workflowsAll.enter_text_9c05f58', 'Enter text')
  case 'workflowsAll.accreditation_options_0248987':
    return this.adminText('workflowsAll.accreditation_options_0248987', 'Accreditation options')
  case 'workflowsAll.choose_format_6e8e57b':
    return this.adminText('workflowsAll.choose_format_6e8e57b', 'Choose format')
  case 'workflowsAll.portrait_92b6b1b':
    return this.adminText('workflowsAll.portrait_92b6b1b', 'Portrait')
  case 'workflowsAll.landscape_7dc4bea':
    return this.adminText('workflowsAll.landscape_7dc4bea', 'Landscape')
  case 'workflowsAll.save_efc007a':
    return this.adminText('workflowsAll.save_efc007a', 'Save')
  case 'workflowsAll.warning_e9c4556':
    return this.adminText('workflowsAll.warning_e9c4556', 'Warning')
  case 'workflowsAll.this_action_could_potentially_be_destructive__065ba39':
    return this.adminText('workflowsAll.this_action_could_potentially_be_destructive__065ba39', 'This action could potentially be destructive and it is irreversible. Are you sure you want to continue?')
  case 'workflowsAll.change_format_339ec0e':
    return this.adminText('workflowsAll.change_format_339ec0e', 'Change format')
  case 'workflowsAll.font_b97c4d4':
    return this.adminText('workflowsAll.font_b97c4d4', 'Font')
  case 'workflowsAll.size_b715234':
    return this.adminText('workflowsAll.size_b715234', 'Size')
  case 'workflowsAll.reply_to_e_mail_a8e268a':
    return this.adminText('workflowsAll.reply_to_e_mail_a8e268a', 'Reply-to e-mail')
  case 'workflowsAll.subscription_plans_e72b057':
    return this.adminText('workflowsAll.subscription_plans_e72b057', 'Subscription plans*')
  case 'workflowsAll.event_ad8919a':
    return this.adminText('workflowsAll.event_ad8919a', 'Event')
  case 'workflowsAll.recipients_faf993d':
    return this.adminText('workflowsAll.recipients_faf993d', 'Recipients*')
  case 'workflowsAll.subscribers_75ecd90':
    return this.adminText('workflowsAll.subscribers_75ecd90', 'Subscribers*')
  case 'workflowsAll.subject_54fc0ac':
    return this.adminText('workflowsAll.subject_54fc0ac', 'Subject*')
  case 'workflowsAll.content_4f9be05':
    return this.adminText('workflowsAll.content_4f9be05', 'Content')
  case 'workflowsAll.loading_subscribers_0ff2de6':
    return this.adminText('workflowsAll.loading_subscribers_0ff2de6', 'Loading subscribers…')
  case 'workflowsAll.reply_to_e_mail_aed12b6':
    return this.adminText('workflowsAll.reply_to_e_mail_aed12b6', 'Reply to e-mail*')
  case 'workflowsAll.subscription_plans_96663a3':
    return this.adminText('workflowsAll.subscription_plans_96663a3', 'Subscription plans')
  case 'workflowsAll.season_62255f5':
    return this.adminText('workflowsAll.season_62255f5', 'Season')
  case 'workflowsAll.subscriber_s_have_no_e_mail_address_and_canno_d531c6d':
    return this.adminText('workflowsAll.subscriber_s_have_no_e_mail_address_and_canno_d531c6d', 'subscriber(s) have no e-mail address and cannot be messaged.')
  case 'workflowsAll.all_seasons_5666605':
    return this.adminText('workflowsAll.all_seasons_5666605', 'All seasons')
  case 'workflowsAll.email_details_f9c3a37':
    return this.adminText('workflowsAll.email_details_f9c3a37', 'Email details')
  case 'workflowsAll.no_subject_7b4e803':
    return this.adminText('workflowsAll.no_subject_7b4e803', 'No subject')
  case 'workflowsAll.go_back_502bbc9':
    return this.adminText('workflowsAll.go_back_502bbc9', 'GO BACK')
  case 'workflowsAll.delete_d6f5636':
    return this.adminText('workflowsAll.delete_d6f5636', 'DELETE')
  case 'workflowsAll.update_automated_e_mail_17c4828':
    return this.adminText('workflowsAll.update_automated_e_mail_17c4828', 'Update automated e-mail')
  case 'workflowsAll.update_52c6c18':
    return this.adminText('workflowsAll.update_52c6c18', 'UPDATE')
  case 'workflowsAll.e_mails_to_attendees_475b4df':
    return this.adminText('workflowsAll.e_mails_to_attendees_475b4df', 'E-mails to attendees')
  case 'workflowsAll.create_e_mail_b558083':
    return this.adminText('workflowsAll.create_e_mail_b558083', 'Create e-mail')
  case 'workflowsAll.type_of_ticket_3968f24':
    return this.adminText('workflowsAll.type_of_ticket_3968f24', 'Type of ticket')
  case 'workflowsAll.categories_6ccb600':
    return this.adminText('workflowsAll.categories_6ccb600', 'Categories')
  case 'workflowsAll.attendees_47d7867':
    return this.adminText('workflowsAll.attendees_47d7867', 'Attendees*')
  case 'workflowsAll.performance_e4aee88':
    return this.adminText('workflowsAll.performance_e4aee88', 'Performance*')
  case 'workflowsAll.date_and_time_07c9c3a':
    return this.adminText('workflowsAll.date_and_time_07c9c3a', 'Date and time')
  case 'workflowsAll.recepients_c593a82':
    return this.adminText('workflowsAll.recepients_c593a82', 'Recepients')
  case 'workflowsAll.see_more_c510d6c':
    return this.adminText('workflowsAll.see_more_c510d6c', 'See more')
  case 'workflowsAll.see_less_47c77bf':
    return this.adminText('workflowsAll.see_less_47c77bf', 'See less')
  case 'workflowsAll.didn_t_receive_d3769bc':
    return this.adminText('workflowsAll.didn_t_receive_d3769bc', 'Didn\'t Receive')
  case 'workflowsAll.add_shortcodes_to_your_e_mail_ddc453d':
    return this.adminText('workflowsAll.add_shortcodes_to_your_e_mail_ddc453d', 'Add shortcodes to your e-mail')
  case 'workflowsAll.membership_plans_23f59c2':
    return this.adminText('workflowsAll.membership_plans_23f59c2', 'Membership plans*')
  case 'workflowsAll.people_b37554f':
    return this.adminText('workflowsAll.people_b37554f', 'People')
  case 'workflowsAll.documentation_9e9cf32':
    return this.adminText('workflowsAll.documentation_9e9cf32', 'Documentation')
  case 'workflowsAll.summary_12b71c3':
    return this.adminText('workflowsAll.summary_12b71c3', 'Summary')
  case 'workflowsAll.from_date_3b5d11a':
    return this.adminText('workflowsAll.from_date_3b5d11a', 'From date')
  case 'workflowsAll.to_date_af244da':
    return this.adminText('workflowsAll.to_date_af244da', 'To date')
  case 'workflowsAll.generate_fc45f9b':
    return this.adminText('workflowsAll.generate_fc45f9b', 'Generate')
  case 'workflowsAll.payout_bundle_7edee42':
    return this.adminText('workflowsAll.payout_bundle_7edee42', 'Payout bundle')
  case 'workflowsAll.organizer_payout_bundle_6dffe16':
    return this.adminText('workflowsAll.organizer_payout_bundle_6dffe16', 'Organizer Payout Bundle')
  case 'workflowsAll.from_date_optional_6371895':
    return this.adminText('workflowsAll.from_date_optional_6371895', 'From date (optional)')
  case 'workflowsAll.to_date_optional_30c7a52':
    return this.adminText('workflowsAll.to_date_optional_30c7a52', 'To date (optional)')
  case 'workflowsAll.generate_fiscalized_invoice_calculation_summa_74b9cba':
    return this.adminText('workflowsAll.generate_fiscalized_invoice_calculation_summa_74b9cba', 'Generate fiscalized invoice + calculation & summary PDFs as a single ZIP archive.')
  case 'workflowsAll.create_invoice_now_a87b84f':
    return this.adminText('workflowsAll.create_invoice_now_a87b84f', 'Create invoice now')
  case 'workflowsAll.skip_invoice_preview_only_d80be7c':
    return this.adminText('workflowsAll.skip_invoice_preview_only_d80be7c', 'Skip invoice (preview only)')
  case 'workflowsAll.download_zip_7bd0e4b':
    return this.adminText('workflowsAll.download_zip_7bd0e4b', 'Download ZIP')
  case 'workflowsAll.r1_invoices_8bf2e93':
    return this.adminText('workflowsAll.r1_invoices_8bf2e93', 'R1 Invoices')
  case 'workflowsAll.invoice_count_7df6a04':
    return this.adminText('workflowsAll.invoice_count_7df6a04', 'Invoice count:')
  case 'workflowsAll.open_cf9b770':
    return this.adminText('workflowsAll.open_cf9b770', 'Open')
  case 'workflowsAll.not_available_d1a17af':
    return this.adminText('workflowsAll.not_available_d1a17af', 'Not available')
  case 'workflowsAll.search_invoices_0e6f44a':
    return this.adminText('workflowsAll.search_invoices_0e6f44a', 'Search invoices')
  case 'workflowsAll.selected_835f3b5':
    return this.adminText('workflowsAll.selected_835f3b5', 'selected')
  case 'workflowsAll.download_pdfs_d30b169':
    return this.adminText('workflowsAll.download_pdfs_d30b169', 'Download PDFs')
  case 'workflowsAll.view_69bd4ef':
    return this.adminText('workflowsAll.view_69bd4ef', 'View')
  case 'workflowsAll.download_pdf_98e5ef0':
    return this.adminText('workflowsAll.download_pdf_98e5ef0', 'Download PDF')
  case 'workflowsAll.all_6a72085':
    return this.adminText('workflowsAll.all_6a72085', 'All')
  case 'workflowsAll.invoice_number_254500c':
    return this.adminText('workflowsAll.invoice_number_254500c', 'Invoice number')
  case 'workflowsAll.payment_date_33ab083':
    return this.adminText('workflowsAll.payment_date_33ab083', 'Payment date')
  case 'workflowsAll.customer_0e85749':
    return this.adminText('workflowsAll.customer_0e85749', 'Customer')
  case 'workflowsAll.actions_c3cd636':
    return this.adminText('workflowsAll.actions_c3cd636', 'Actions')
  case 'workflowsAll.performances_c5453c0':
    return this.adminText('workflowsAll.performances_c5453c0', 'Performances')
  case 'workflowsAll.attendee_fields_73ce4ce':
    return this.adminText('workflowsAll.attendee_fields_73ce4ce', 'Attendee fields')
  case 'workflowsAll.event_conference_info_0f6852d':
    return this.adminText('workflowsAll.event_conference_info_0f6852d', 'Event conference info')
  case 'workflowsAll.conference_details_saved_f6fba16':
    return this.adminText('workflowsAll.conference_details_saved_f6fba16', 'Conference details saved')
  case 'workflowsAll.at_least_one_performance_is_required_fb83b93':
    return this.adminText('workflowsAll.at_least_one_performance_is_required_fb83b93', 'At least one performance is required.')
  case 'workflowsAll.fill_in_the_required_information_a32c330':
    return this.adminText('workflowsAll.fill_in_the_required_information_a32c330', 'Fill in the required information')
  case 'workflowsAll.event_info_8f142f7':
    return this.adminText('workflowsAll.event_info_8f142f7', 'Event info')
  case 'workflowsAll.number_of_zones_b7e410b':
    return this.adminText('workflowsAll.number_of_zones_b7e410b', 'Number of zones')
  case 'workflowsAll.save_your_progress_without_publishing_the_cha_0cd1bdd':
    return this.adminText('workflowsAll.save_your_progress_without_publishing_the_cha_0cd1bdd', 'Save your progress without publishing the changes.')
  case 'workflowsAll.save_draft_4f25637':
    return this.adminText('workflowsAll.save_draft_4f25637', 'Save draft')
  case 'workflowsAll.apply_and_make_the_changes_visible_to_users_031e1b9':
    return this.adminText('workflowsAll.apply_and_make_the_changes_visible_to_users_031e1b9', 'Apply and make the changes visible to users.')
  case 'workflowsAll.publish_changes_45d2840':
    return this.adminText('workflowsAll.publish_changes_45d2840', 'Publish changes')
  case 'workflowsAll.event_details_saved_d38700f':
    return this.adminText('workflowsAll.event_details_saved_d38700f', 'Event details saved')
  case 'workflowsAll.new_message_1ed2e7b':
    return this.adminText('workflowsAll.new_message_1ed2e7b', 'New message')
  case 'workflowsAll.message_68f4145':
    return this.adminText('workflowsAll.message_68f4145', 'Message')
  case 'workflowsAll.send_message_to_subscribers_ab87215':
    return this.adminText('workflowsAll.send_message_to_subscribers_ab87215', 'Send message to subscribers')
  case 'workflowsAll.icon_716f63b':
    return this.adminText('workflowsAll.icon_716f63b', 'Icon')
  case 'workflowsAll.sent_5ad0cd6':
    return this.adminText('workflowsAll.sent_5ad0cd6', 'SENT')
  case 'workflowsAll.use_this_event_for_skidata_arena_access_contr_ba17d04':
    return this.adminText('workflowsAll.use_this_event_for_skidata_arena_access_contr_ba17d04', 'Use this event for SKIDATA Arena access control. Enabling it validates the integration configuration and starts an initial resync.')
  case 'workflowsAll.only_super_admins_can_change_this_setting_e32492f':
    return this.adminText('workflowsAll.only_super_admins_can_change_this_setting_e32492f', 'Only super admins can change this setting.')
  case 'workflowsAll.skidata_arena_c003bd0':
    return this.adminText('workflowsAll.skidata_arena_c003bd0', 'SKIDATA Arena ')
  case 'workflowsAll.for_this_event_f0bf53d':
    return this.adminText('workflowsAll.for_this_event_f0bf53d', ' for this event.')
  case 'workflowsAll.event_details_saved_and_will_be_live_in_20_mi_70961ff':
    return this.adminText('workflowsAll.event_details_saved_and_will_be_live_in_20_mi_70961ff', 'Event details saved and will be live in 20 minutes.')
  case 'workflowsAll.event_details_saved_034f903':
    return this.adminText('workflowsAll.event_details_saved_034f903', 'Event details saved.')
  case 'workflowsAll.something_went_wrong_please_try_again_9a3ea05':
    return this.adminText('workflowsAll.something_went_wrong_please_try_again_9a3ea05', 'Something went wrong. Please try again.')
  case 'workflowsAll.choose_type_of_attendee_field_d00389a':
    return this.adminText('workflowsAll.choose_type_of_attendee_field_d00389a', 'Choose type of attendee field')
  case 'workflowsAll.type_label_and_options_are_locked_because_att_fc8bffa':
    return this.adminText('workflowsAll.type_label_and_options_are_locked_because_att_fc8bffa', 'Type, label and options are locked because attendees already exist.')
  case 'workflowsAll.label_74341e3':
    return this.adminText('workflowsAll.label_74341e3', 'Label')
  case 'workflowsAll.option_e31d972':
    return this.adminText('workflowsAll.option_e31d972', 'Option')
  case 'workflowsAll.add_another_option_c6f492f':
    return this.adminText('workflowsAll.add_another_option_c6f492f', 'Add another option')
  case 'workflowsAll.text_fields_f916814':
    return this.adminText('workflowsAll.text_fields_f916814', 'Text fields')
  case 'workflowsAll.minimum_date_9baedb2':
    return this.adminText('workflowsAll.minimum_date_9baedb2', 'Minimum date')
  case 'workflowsAll.maximum_date_20cc6d4':
    return this.adminText('workflowsAll.maximum_date_20cc6d4', 'Maximum date')
  case 'workflowsAll.required_eed6bfb':
    return this.adminText('workflowsAll.required_eed6bfb', 'Required')
  case 'workflowsAll.cannot_set_field_as_required_if_attendees_exi_6280f33':
    return this.adminText('workflowsAll.cannot_set_field_as_required_if_attendees_exi_6280f33', 'Cannot set field as required if attendees exist.')
  case 'workflowsAll.cannot_make_a_field_required_once_attendees_e_06ad86c':
    return this.adminText('workflowsAll.cannot_make_a_field_required_once_attendees_e_06ad86c', 'Cannot make a field required once attendees exist.')
  case 'workflowsAll.hidden_from_attendees_135bdcf':
    return this.adminText('workflowsAll.hidden_from_attendees_135bdcf', 'Hidden from attendees')
  case 'workflowsAll.a_required_field_cannot_be_hidden_turn_off_re_b9fefe3':
    return this.adminText('workflowsAll.a_required_field_cannot_be_hidden_turn_off_re_b9fefe3', 'A required field cannot be hidden. Turn off Required first.')
  case 'workflowsAll.multiselect_b122c26':
    return this.adminText('workflowsAll.multiselect_b122c26', 'Multiselect')
  case 'workflowsAll.new_category_f41ff0d':
    return this.adminText('workflowsAll.new_category_f41ff0d', 'New category')
  case 'workflowsAll.update_category_54d466b':
    return this.adminText('workflowsAll.update_category_54d466b', 'Update category')
  case 'workflowsAll.edit_message_96116a5':
    return this.adminText('workflowsAll.edit_message_96116a5', 'Edit message')
  case 'workflowsAll.edit_attendee_field_translation_988bdc9':
    return this.adminText('workflowsAll.edit_attendee_field_translation_988bdc9', 'Edit attendee field translation')
  case 'workflowsAll.edit_icon_d1541cf':
    return this.adminText('workflowsAll.edit_icon_d1541cf', 'Edit icon')
  case 'workflowsAll.edit_17865bd':
    return this.adminText('workflowsAll.edit_17865bd', 'EDIT')
  case 'workflowsAll.select_language_daea52c':
    return this.adminText('workflowsAll.select_language_daea52c', 'Select language')
  case 'workflowsAll.select_a_language_for_which_you_are_creating__a9cf79e':
    return this.adminText('workflowsAll.select_a_language_for_which_you_are_creating__a9cf79e', 'Select a language for which you are creating a translation. You can choose your preferred language in your account settings.')
  case 'workflowsAll.language_89b86ab':
    return this.adminText('workflowsAll.language_89b86ab', 'Language')
  case 'workflowsAll.add_your_translations_f18f1c7':
    return this.adminText('workflowsAll.add_your_translations_f18f1c7', 'Add your translations')
  case 'workflowsAll.translate_your_event_title_and_attendee_field_be557ef':
    return this.adminText('workflowsAll.translate_your_event_title_and_attendee_field_be557ef', 'Translate your event title and attendee fields labels')
  case 'workflowsAll.save_508156a':
    return this.adminText('workflowsAll.save_508156a', 'SAVE')
  case 'workflowsAll.event_cover_image_ecdd425':
    return this.adminText('workflowsAll.event_cover_image_ecdd425', 'Event cover image')
  case 'workflowsAll.image_with_a_portrait_9_16_aspect_ratio_and_n_9ed0591':
    return this.adminText('workflowsAll.image_with_a_portrait_9_16_aspect_ratio_and_n_9ed0591', 'Image with a portrait (9:16) aspect ratio and not larger than 10 MB is recommended.')
  case 'workflowsAll.cover_preview_a6cc4d4':
    return this.adminText('workflowsAll.cover_preview_a6cc4d4', 'Cover preview')
  case 'workflowsAll.title_db83dc1':
    return this.adminText('workflowsAll.title_db83dc1', 'Title*')
  case 'workflowsAll.subtitle_2b907f1':
    return this.adminText('workflowsAll.subtitle_2b907f1', 'Subtitle*')
  case 'workflowsAll.interests_3fc5473':
    return this.adminText('workflowsAll.interests_3fc5473', 'Interests')
  case 'workflowsAll.type_an_interest_and_press_enter_90fb34d':
    return this.adminText('workflowsAll.type_an_interest_and_press_enter_90fb34d', 'Type an interest and press Enter')
  case 'workflowsAll.add_venue_map_3b3edff':
    return this.adminText('workflowsAll.add_venue_map_3b3edff', 'Add Venue Map')
  case 'workflowsAll.color_selection_3a85951':
    return this.adminText('workflowsAll.color_selection_3a85951', 'Color Selection')
  case 'workflowsAll.select_page_for_preview_890167e':
    return this.adminText('workflowsAll.select_page_for_preview_890167e', 'Select page for preview')
  case 'workflowsAll.page_fb06270':
    return this.adminText('workflowsAll.page_fb06270', 'Page')
  case 'workflowsAll.primary_color_a1055f1':
    return this.adminText('workflowsAll.primary_color_a1055f1', 'Primary color')
  case 'workflowsAll.primary_brand_color_used_on_the_majority_of_e_ffc0852':
    return this.adminText('workflowsAll.primary_brand_color_used_on_the_majority_of_e_ffc0852', 'Primary brand color, used on the majority of elements including buttons, headings, subheadings, links, and illustrations.')
  case 'workflowsAll.light_dark_theme_preview_adfd772':
    return this.adminText('workflowsAll.light_dark_theme_preview_adfd772', 'Light & dark theme preview')
  case 'workflowsAll.app_preview_9edb618':
    return this.adminText('workflowsAll.app_preview_9edb618', 'App preview')
  case 'workflowsAll.home_70f8bb9':
    return this.adminText('workflowsAll.home_70f8bb9', 'Home')
  case 'workflowsAll.agenda_891e9d6':
    return this.adminText('workflowsAll.agenda_891e9d6', 'Agenda')
  case 'workflowsAll.chat_2ced57f':
    return this.adminText('workflowsAll.chat_2ced57f', 'Chat')
  case 'workflowsAll.more_4bab2d8':
    return this.adminText('workflowsAll.more_4bab2d8', 'More')
  case 'workflowsAll.modules_04e9462':
    return this.adminText('workflowsAll.modules_04e9462', 'Modules')
  case 'workflowsAll.once_a_ticket_for_the_event_is_sold_or_someon_64eb4db':
    return this.adminText('workflowsAll.once_a_ticket_for_the_event_is_sold_or_someon_64eb4db', 'Once a ticket for the event is sold or someone registers, changes to the module will no longer be possible. Additionally, modifying the module will permanently delete certain settings, and this action cannot be undone.')
  case 'workflowsAll.cannot_update_modules_abecf88':
    return this.adminText('workflowsAll.cannot_update_modules_abecf88', 'Cannot update modules.')
  case 'workflowsAll.create_an_event_with_a_basic_registration_for_e7c22d5':
    return this.adminText('workflowsAll.create_an_event_with_a_basic_registration_for_e7c22d5', 'Create an event with a basic registration form')
  case 'workflowsAll.the_form_allows_participants_to_fill_in_their_1e9b080':
    return this.adminText('workflowsAll.the_form_allows_participants_to_fill_in_their_1e9b080', 'The form allows participants to fill in their name, email address, and phone number. Additional fields can be added based on the organizer\'s preferences, offering flexibility to customize the form according to specific needs.')
  case 'workflowsAll.optional_modules_e5305c3':
    return this.adminText('workflowsAll.optional_modules_e5305c3', 'Optional modules')
  case 'workflowsAll.or_choose_optional_modules_4b5e9a2':
    return this.adminText('workflowsAll.or_choose_optional_modules_4b5e9a2', 'Or choose optional modules')
  case 'workflowsAll.enabling_tickets_gives_you_the_opportunity_to_e9a759f':
    return this.adminText('workflowsAll.enabling_tickets_gives_you_the_opportunity_to_e9a759f', 'Enabling tickets gives you the opportunity to sell tickets to your attendees.')
  case 'workflowsAll.add_tax_class_07bffcb':
    return this.adminText('workflowsAll.add_tax_class_07bffcb', 'Add tax class')
  case 'workflowsAll.assign_a_tax_class_that_will_apply_to_tickets_5bf052d':
    return this.adminText('workflowsAll.assign_a_tax_class_that_will_apply_to_tickets_5bf052d', 'Assign a tax class that will apply to tickets for this event.')
  case 'workflowsAll.the_tax_class_cannot_be_changed_after_tickets_367ddbb':
    return this.adminText('workflowsAll.the_tax_class_cannot_be_changed_after_tickets_367ddbb', 'The tax class cannot be changed after tickets have been sold.')
  case 'workflowsAll.floor_plan_7bfda3b':
    return this.adminText('workflowsAll.floor_plan_7bfda3b', 'FLOOR PLAN')
  case 'workflowsAll.enabling_the_floor_plan_allows_you_to_have_mu_3a5611c':
    return this.adminText('workflowsAll.enabling_the_floor_plan_allows_you_to_have_mu_3a5611c', 'Enabling the floor plan allows you to have multiple sections in your venue for multiple ticket types.')
  case 'workflowsAll.ticket_personalization_80b4600':
    return this.adminText('workflowsAll.ticket_personalization_80b4600', 'TICKET PERSONALIZATION')
  case 'workflowsAll.process_of_assigning_each_ticket_to_a_specifi_8432ec0':
    return this.adminText('workflowsAll.process_of_assigning_each_ticket_to_a_specifi_8432ec0', 'Process of assigning each ticket to a specific individual, often requiring personal details like name or ID, to ensure security and prevent unauthorized transfers — for example, festivals often mandate that each ticket displays the attendee\'s name for entry.')
  case 'workflowsAll.categories_zones_a96a88f':
    return this.adminText('workflowsAll.categories_zones_a96a88f', 'Categories & zones')
  case 'workflowsAll.if_you_re_managing_a_major_event_you_can_enab_cf0a879':
    return this.adminText('workflowsAll.if_you_re_managing_a_major_event_you_can_enab_cf0a879', 'If you\'re managing a major event, you can enable accreditation categories and zones to control venue access privileges.')
  case 'workflowsAll.workshops_e28088b':
    return this.adminText('workflowsAll.workshops_e28088b', 'Workshops')
  case 'workflowsAll.enable_this_module_to_empower_your_attendees__539f5f3':
    return this.adminText('workflowsAll.enable_this_module_to_empower_your_attendees__539f5f3', 'Enable this module to empower your attendees by registering to multiple workshops hosted at your event.')
  case 'workflowsAll.mobile_app_7620a2b':
    return this.adminText('workflowsAll.mobile_app_7620a2b', 'Mobile app')
  case 'workflowsAll.by_enabling_mobile_app_your_attendees_can_eas_d7b3ce1':
    return this.adminText('workflowsAll.by_enabling_mobile_app_your_attendees_can_eas_d7b3ce1', 'By enabling mobile app, your attendees can easily access info about your event and find new connections at site.')
  case 'workflowsAll.conference_mobile_app_c95c49e':
    return this.adminText('workflowsAll.conference_mobile_app_c95c49e', 'CONFERENCE MOBILE APP')
  case 'workflowsAll.by_enabling_this_app_your_attendees_can_easil_f003462':
    return this.adminText('workflowsAll.by_enabling_this_app_your_attendees_can_easil_f003462', 'By enabling this app, your attendees can easily access info about your event, find new connections at the site, and arrange meetings.')
  case 'workflowsAll.expo_mobile_app_d95d2d4':
    return this.adminText('workflowsAll.expo_mobile_app_d95d2d4', 'EXPO MOBILE APP')
  case 'workflowsAll.designed_for_exhibitors_at_trade_shows_to_eas_d031267':
    return this.adminText('workflowsAll.designed_for_exhibitors_at_trade_shows_to_eas_d031267', 'Designed for exhibitors at trade shows to easily track visitors to their booths. By scanning a visitor\'s QR code with a mobile device, exhibitors can quickly record attendance and gather essential contact information.')
  case 'workflowsAll.back_61bb8d2':
    return this.adminText('workflowsAll.back_61bb8d2', 'back')
  case 'workflowsAll.create_event_6f1d19d':
    return this.adminText('workflowsAll.create_event_6f1d19d', 'CREATE EVENT')
  case 'workflowsAll.please_select_at_least_one_mobile_app_c1b8ad0':
    return this.adminText('workflowsAll.please_select_at_least_one_mobile_app_c1b8ad0', 'Please select at least one mobile app')
  case 'workflowsAll.general_info_b0fe391':
    return this.adminText('workflowsAll.general_info_b0fe391', 'General info')
  case 'workflowsAll.additional_info_e173235':
    return this.adminText('workflowsAll.additional_info_e173235', 'Additional info')
  case 'workflowsAll.this_information_is_optional_if_you_decide_to_b2f854e':
    return this.adminText('workflowsAll.this_information_is_optional_if_you_decide_to_b2f854e', 'This information is optional. If you decide to skip it, you can edit at any moment under your event settings.')
  case 'workflowsAll.facebook_link_197bd42':
    return this.adminText('workflowsAll.facebook_link_197bd42', 'Facebook link')
  case 'workflowsAll.website_2e8a57c':
    return this.adminText('workflowsAll.website_2e8a57c', 'Website')
  case 'workflowsAll.description_will_be_visible_on_the_event_page_0464b88':
    return this.adminText('workflowsAll.description_will_be_visible_on_the_event_page_0464b88', 'Description will be visible on the event page')
  case 'workflowsAll.highlighted_information_optional_331b68a':
    return this.adminText('workflowsAll.highlighted_information_optional_331b68a', 'Highlighted information (optional)')
  case 'workflowsAll.add_useful_information_about_your_event_like__5524d77':
    return this.adminText('workflowsAll.add_useful_information_about_your_event_like__5524d77', 'Add useful information about your event (like age limit, table reservation, etc.)')
  case 'workflowsAll.frequently_asked_questions_optional_c238d97':
    return this.adminText('workflowsAll.frequently_asked_questions_optional_c238d97', 'Frequently Asked Questions (optional)')
  case 'workflowsAll.add_frequently_asked_questions_about_your_eve_c07d372':
    return this.adminText('workflowsAll.add_frequently_asked_questions_about_your_eve_c07d372', 'Add frequently asked questions about your event. This will be displayed on the landing page of your event.')
  case 'workflowsAll.continue_eee0bbb':
    return this.adminText('workflowsAll.continue_eee0bbb', 'continue')
  case 'workflowsAll.are_you_sure_you_want_to_delete_2cba56b':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_2cba56b', 'Are you sure you want to delete “')
  case 'workflowsAll.password_ca47450':
    return this.adminText('workflowsAll.password_ca47450', '” password?')
  case 'workflowsAll.users_will_not_be_able_to_use_this_password_a_df6dd59':
    return this.adminText('workflowsAll.users_will_not_be_able_to_use_this_password_a_df6dd59', 'Users will not be able to use this password anymore.')
  case 'workflowsAll.password_required_to_access_link_49a97bc':
    return this.adminText('workflowsAll.password_required_to_access_link_49a97bc', 'Password required to access link')
  case 'workflowsAll.if_enabled_attendees_will_have_to_enter_a_pas_e4be1b0':
    return this.adminText('workflowsAll.if_enabled_attendees_will_have_to_enter_a_pas_e4be1b0', 'If enabled attendees will have to enter a password you set up before being able to enter the registration page.')
  case 'workflowsAll.expired_45a6f9a':
    return this.adminText('workflowsAll.expired_45a6f9a', 'expired')
  case 'workflowsAll.add_new_password_810afff':
    return this.adminText('workflowsAll.add_new_password_810afff', 'Add new password')
  case 'workflowsAll.attendee_field_translations_e3bdaa4':
    return this.adminText('workflowsAll.attendee_field_translations_e3bdaa4', 'Attendee field translations')
  case 'workflowsAll.add_icon_42b71d9':
    return this.adminText('workflowsAll.add_icon_42b71d9', 'add icon')
  case 'workflowsAll.add_translations_09271f9':
    return this.adminText('workflowsAll.add_translations_09271f9', 'ADD TRANSLATIONS')
  case 'workflowsAll.edit_question_3968005':
    return this.adminText('workflowsAll.edit_question_3968005', 'Edit question')
  case 'workflowsAll.question_title_69205d0':
    return this.adminText('workflowsAll.question_title_69205d0', 'Question title:')
  case 'workflowsAll.question_answer_4297f17':
    return this.adminText('workflowsAll.question_answer_4297f17', 'Question answer:')
  case 'workflowsAll.q_8f2a08a':
    return this.adminText('workflowsAll.q_8f2a08a', 'Q:')
  case 'workflowsAll.a_8f1f060':
    return this.adminText('workflowsAll.a_8f1f060', 'A:')
  case 'workflowsAll.edit_5301648':
    return this.adminText('workflowsAll.edit_5301648', 'Edit')
  case 'workflowsAll.add_question_3f81565':
    return this.adminText('workflowsAll.add_question_3f81565', 'ADD QUESTION')
  case 'workflowsAll.category_2f46df4':
    return this.adminText('workflowsAll.category_2f46df4', 'Category*')
  case 'workflowsAll.subcategory_e1d9ef4':
    return this.adminText('workflowsAll.subcategory_e1d9ef4', 'Subcategory*')
  case 'workflowsAll.event_title_f33a025':
    return this.adminText('workflowsAll.event_title_f33a025', 'Event title*')
  case 'workflowsAll.starts_4edb2ec':
    return this.adminText('workflowsAll.starts_4edb2ec', 'Starts*')
  case 'workflowsAll.ends_65bb821':
    return this.adminText('workflowsAll.ends_65bb821', 'Ends*')
  case 'workflowsAll.age_restriction_9feccd7':
    return this.adminText('workflowsAll.age_restriction_9feccd7', 'Age Restriction')
  case 'workflowsAll.minimum_age_limit_8be168e':
    return this.adminText('workflowsAll.minimum_age_limit_8be168e', 'Minimum age limit')
  case 'workflowsAll.yes_5397e05':
    return this.adminText('workflowsAll.yes_5397e05', 'Yes')
  case 'workflowsAll.no_816c52f':
    return this.adminText('workflowsAll.no_816c52f', 'No')
  case 'workflowsAll.entrance_for_children_under_certain_age_477aadc':
    return this.adminText('workflowsAll.entrance_for_children_under_certain_age_477aadc', 'Entrance for children under certain age')
  case 'workflowsAll.free_entrance_for_children_under_certain_age_cb64956':
    return this.adminText('workflowsAll.free_entrance_for_children_under_certain_age_cb64956', 'Free entrance for children under certain age')
  case 'workflowsAll.age_ff9f1ff':
    return this.adminText('workflowsAll.age_ff9f1ff', 'Age')
  case 'workflowsAll.table_reservation_2d8b77c':
    return this.adminText('workflowsAll.table_reservation_2d8b77c', 'Table reservation')
  case 'workflowsAll.category_name_ed3dc45':
    return this.adminText('workflowsAll.category_name_ed3dc45', 'Category name')
  case 'workflowsAll.color_1d0c830':
    return this.adminText('workflowsAll.color_1d0c830', 'Color')
  case 'workflowsAll.optional_b16c7ac':
    return this.adminText('workflowsAll.optional_b16c7ac', '(optional)')
  case 'workflowsAll.module_icon_c6118ef':
    return this.adminText('workflowsAll.module_icon_c6118ef', 'module icon')
  case 'workflowsAll.new_attendee_field_translation_e9ea8da':
    return this.adminText('workflowsAll.new_attendee_field_translation_e9ea8da', 'New attendee field translation')
  case 'workflowsAll.preview_unavailable_36d31d4':
    return this.adminText('workflowsAll.preview_unavailable_36d31d4', 'Preview unavailable')
  case 'workflowsAll.login_with_code_05344e0':
    return this.adminText('workflowsAll.login_with_code_05344e0', 'Login with code')
  case 'workflowsAll.login_with_qr_code_09fa829':
    return this.adminText('workflowsAll.login_with_qr_code_09fa829', 'Login with QR code')
  case 'workflowsAll.halls_bd734aa':
    return this.adminText('workflowsAll.halls_bd734aa', 'Halls')
  case 'workflowsAll.create_and_edit_halls_for_your_event_287fa4f':
    return this.adminText('workflowsAll.create_and_edit_halls_for_your_event_287fa4f', 'Create and edit halls for your event.')
  case 'workflowsAll.create_hall_f8c55d6':
    return this.adminText('workflowsAll.create_hall_f8c55d6', 'Create hall')
  case 'workflowsAll.name_709a232':
    return this.adminText('workflowsAll.name_709a232', 'Name')
  case 'workflowsAll.create_hall_7f9d058':
    return this.adminText('workflowsAll.create_hall_7f9d058', 'Create Hall')
  case 'workflowsAll.you_need_to_provide_information_about_your_ne_81605d8':
    return this.adminText('workflowsAll.you_need_to_provide_information_about_your_ne_81605d8', 'You need to provide information about your new hall.')
  case 'workflowsAll.update_hall_03a6368':
    return this.adminText('workflowsAll.update_hall_03a6368', 'Update hall')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_hall_thi_713d48d':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_hall_thi_713d48d', 'Are you sure you want to delete this hall? This operation cannot be undone.')
  case 'workflowsAll.remove_hall_6130ffc':
    return this.adminText('workflowsAll.remove_hall_6130ffc', 'Remove hall')
  case 'workflowsAll.hall_name_5ec324d':
    return this.adminText('workflowsAll.hall_name_5ec324d', 'Hall name')
  case 'workflowsAll.hall_color_9f372f9':
    return this.adminText('workflowsAll.hall_color_9f372f9', 'Hall color')
  case 'workflowsAll.export_attendees_70ca2c6':
    return this.adminText('workflowsAll.export_attendees_70ca2c6', 'Export attendees')
  case 'workflowsAll.you_can_export_your_attendees_and_all_of_thei_782cbb8':
    return this.adminText('workflowsAll.you_can_export_your_attendees_and_all_of_thei_782cbb8', 'You can export your attendees and all of their data here. Choose the appropriate format of the file depending on the purpose.')
  case 'workflowsAll.choose_format_f5deef5':
    return this.adminText('workflowsAll.choose_format_f5deef5', 'Choose format:')
  case 'workflowsAll.excel_a08e111':
    return this.adminText('workflowsAll.excel_a08e111', 'Excel')
  case 'workflowsAll.export_analytics_f28b149':
    return this.adminText('workflowsAll.export_analytics_f28b149', 'Export analytics')
  case 'workflowsAll.here_you_can_export_a_full_set_of_your_event__49b7bab':
    return this.adminText('workflowsAll.here_you_can_export_a_full_set_of_your_event__49b7bab', 'Here you can export a full set of your event\'s analytics data stored in an Excel file. Analytics contain data such as attendee names, fields, created_at, etc.')
  case 'workflowsAll.1_create_the_csv_file_78f6567':
    return this.adminText('workflowsAll.1_create_the_csv_file_78f6567', '1. Create the CSV file')
  case 'workflowsAll.first_you_need_to_download_the_official_csv_t_58bc94b':
    return this.adminText('workflowsAll.first_you_need_to_download_the_official_csv_t_58bc94b', 'First, you need to download the official CSV template file which contains all of the attendee fields you can fill out. Make sure you enter all of the required fields for all of your attendees to make it valid.')
  case 'workflowsAll.your_template_contains_following_fields_8cc62c3':
    return this.adminText('workflowsAll.your_template_contains_following_fields_8cc62c3', 'Your template contains following fields:')
  case 'workflowsAll.download_template_d268565':
    return this.adminText('workflowsAll.download_template_d268565', 'Download template')
  case 'workflowsAll.2_upload_the_csv_file_d3cf894':
    return this.adminText('workflowsAll.2_upload_the_csv_file_d3cf894', '2. Upload the CSV file')
  case 'workflowsAll.after_you_finish_adding_the_attendees_data_yo_f76061c':
    return this.adminText('workflowsAll.after_you_finish_adding_the_attendees_data_yo_f76061c', 'After you finish adding the attendees data, you can upload the file here. Don\'t worry, if something goes wrong, we will let you know.')
  case 'workflowsAll.upload_file_503a3d8':
    return this.adminText('workflowsAll.upload_file_503a3d8', 'Upload file')
  case 'workflowsAll.all_attendees_were_successfully_imported_2cae616':
    return this.adminText('workflowsAll.all_attendees_were_successfully_imported_2cae616', 'All attendees were successfully imported.')
  case 'workflowsAll.error_7f2f6a1':
    return this.adminText('workflowsAll.error_7f2f6a1', 'Error')
  case 'workflowsAll.we_encountered_errors_during_validation_proce_379150d':
    return this.adminText('workflowsAll.we_encountered_errors_during_validation_proce_379150d', 'We encountered errors during validation process.')
  case 'workflowsAll.importing_attendees_d087290':
    return this.adminText('workflowsAll.importing_attendees_d087290', 'Importing attendees...')
  case 'workflowsAll.import_export_c366dd1':
    return this.adminText('workflowsAll.import_export_c366dd1', 'Import/Export')
  case 'workflowsAll.quickly_import_attendees_and_all_of_their_dat_93109e0':
    return this.adminText('workflowsAll.quickly_import_attendees_and_all_of_their_dat_93109e0', 'Quickly import attendees and all of their data using a CSV template.')
  case 'workflowsAll.export_a_list_of_your_attendees_or_a_full_set_82345aa':
    return this.adminText('workflowsAll.export_a_list_of_your_attendees_or_a_full_set_82345aa', 'Export a list of your attendees or a full set of your event\'s analytics data.')
  case 'workflowsAll.import_icon_13b6584':
    return this.adminText('workflowsAll.import_icon_13b6584', 'Import icon')
  case 'workflowsAll.export_icon_1c4dcec':
    return this.adminText('workflowsAll.export_icon_1c4dcec', 'export icon')
  case 'workflowsAll.event_entries_e553cd1':
    return this.adminText('workflowsAll.event_entries_e553cd1', 'Event Entries')
  case 'workflowsAll.here_you_can_see_all_the_attendees_of_your_ev_5586dc5':
    return this.adminText('workflowsAll.here_you_can_see_all_the_attendees_of_your_ev_5586dc5', 'Here you can see all the attendees of your event which have checked in.')
  case 'workflowsAll.last_name_adec36a':
    return this.adminText('workflowsAll.last_name_adec36a', 'Last name')
  case 'workflowsAll.time_of_entry_0731cde':
    return this.adminText('workflowsAll.time_of_entry_0731cde', 'Time of entry')
  case 'workflowsAll.promote_container_4483e75':
    return this.adminText('workflowsAll.promote_container_4483e75', 'PROMOTE CONTAINER')
  case 'workflowsAll.my_referrals_2b42b2f':
    return this.adminText('workflowsAll.my_referrals_2b42b2f', 'My referrals')
  case 'workflowsAll.delete_referral_07956b5':
    return this.adminText('workflowsAll.delete_referral_07956b5', 'Delete referral')
  case 'workflowsAll.are_you_sure_you_want_to_delete_selected_refe_6b8f522':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_refe_6b8f522', 'Are you sure you want to delete selected referral? This operation cannot be undone.')
  case 'workflowsAll.referral_name_a363eb3':
    return this.adminText('workflowsAll.referral_name_a363eb3', 'Referral name')
  case 'workflowsAll.referral_1c6984f':
    return this.adminText('workflowsAll.referral_1c6984f', 'Referral')
  case 'workflowsAll.visits_6a4be2f':
    return this.adminText('workflowsAll.visits_6a4be2f', 'Visits')
  case 'workflowsAll.sponsors_82cebd0':
    return this.adminText('workflowsAll.sponsors_82cebd0', 'Sponsors')
  case 'workflowsAll.add_sponsor_581e2ac':
    return this.adminText('workflowsAll.add_sponsor_581e2ac', 'Add sponsor')
  case 'workflowsAll.add_the_sponsors_of_your_event_they_appear_in_a40a1e3':
    return this.adminText('workflowsAll.add_the_sponsors_of_your_event_they_appear_in_a40a1e3', 'Add the sponsors of your event. They appear in the attendee app in the order you add them, with their logo on a white tile.')
  case 'workflowsAll.no_sponsors_yet_1860085':
    return this.adminText('workflowsAll.no_sponsors_yet_1860085', 'No sponsors yet.')
  case 'workflowsAll.showcase_sponsors_with_their_logo_website_and_9923181':
    return this.adminText('workflowsAll.showcase_sponsors_with_their_logo_website_and_9923181', 'Showcase sponsors with their logo, website, and a short description in one consistent, easy-to-manage format.')
  case 'workflowsAll.delete_sponsor_0effb9e':
    return this.adminText('workflowsAll.delete_sponsor_0effb9e', 'Delete sponsor')
  case 'workflowsAll.will_be_removed_from_the_event_and_from_the_m_0f9160d':
    return this.adminText('workflowsAll.will_be_removed_from_the_event_and_from_the_m_0f9160d', ' will be removed from the event and from the mobile app.')
  case 'workflowsAll.upload_logo_a564e95':
    return this.adminText('workflowsAll.upload_logo_a564e95', 'Upload logo')
  case 'workflowsAll.jpg_and_png_formats_square_at_least_bcb9898':
    return this.adminText('workflowsAll.jpg_and_png_formats_square_at_least_bcb9898', 'JPG and PNG formats, square, at least')
  case 'workflowsAll.sponsor_logo_8a45ea1':
    return this.adminText('workflowsAll.sponsor_logo_8a45ea1', 'Sponsor logo')
  case 'workflowsAll.map_loading_6f502a5':
    return this.adminText('workflowsAll.map_loading_6f502a5', 'Map loading...')
  case 'workflowsAll.no_city_data_available_to_display_on_the_map_9314b38':
    return this.adminText('workflowsAll.no_city_data_available_to_display_on_the_map_9314b38', 'No city data available to display on the map.')
  case 'workflowsAll.floor_plan_overview_36d5a0f':
    return this.adminText('workflowsAll.floor_plan_overview_36d5a0f', 'Floor plan overview')
  case 'workflowsAll.this_event_does_not_have_a_floor_plan_a553e18':
    return this.adminText('workflowsAll.this_event_does_not_have_a_floor_plan_a553e18', 'This event does not have a floor plan.')
  case 'workflowsAll.select_tickets_to_highlight_6677788':
    return this.adminText('workflowsAll.select_tickets_to_highlight_6677788', 'Select tickets to highlight')
  case 'workflowsAll.remove_selected_ticket_330efef':
    return this.adminText('workflowsAll.remove_selected_ticket_330efef', 'Remove selected ticket')
  case 'workflowsAll.free_75f5271':
    return this.adminText('workflowsAll.free_75f5271', 'Free')
  case 'workflowsAll.cancelled_tickets_95d54ed':
    return this.adminText('workflowsAll.cancelled_tickets_95d54ed', 'Cancelled Tickets')
  case 'workflowsAll.number_of_cancelled_tickets_for_c8f54d7':
    return this.adminText('workflowsAll.number_of_cancelled_tickets_for_c8f54d7', 'Number of cancelled tickets for')
  case 'workflowsAll.more_data_will_be_displayed_tomorrow_8439250':
    return this.adminText('workflowsAll.more_data_will_be_displayed_tomorrow_8439250', 'More data will be displayed tomorrow.')
  case 'workflowsAll.no_data_to_display_statistics_will_be_availab_e649689':
    return this.adminText('workflowsAll.no_data_to_display_statistics_will_be_availab_e649689', 'No data to display. Statistics will be available when there are cancelled tickets.')
  case 'workflowsAll.cancelled_tickets_76648ab':
    return this.adminText('workflowsAll.cancelled_tickets_76648ab', 'Cancelled tickets')
  case 'workflowsAll.scanned_tickets_a6278d5':
    return this.adminText('workflowsAll.scanned_tickets_a6278d5', 'Scanned tickets')
  case 'workflowsAll.total_scanned_tickets_8f65e8a':
    return this.adminText('workflowsAll.total_scanned_tickets_8f65e8a', 'Total scanned tickets')
  case 'workflowsAll.previous_order_f0fa5df':
    return this.adminText('workflowsAll.previous_order_f0fa5df', 'Previous order')
  case 'workflowsAll.order_1d75774':
    return this.adminText('workflowsAll.order_1d75774', 'Order')
  case 'workflowsAll.next_order_a295df1':
    return this.adminText('workflowsAll.next_order_a295df1', 'Next order')
  case 'workflowsAll.location_d219c68':
    return this.adminText('workflowsAll.location_d219c68', 'Location')
  case 'workflowsAll.parter_328f837':
    return this.adminText('workflowsAll.parter_328f837', 'Parter')
  case 'workflowsAll.sold_tickets_9825f4d':
    return this.adminText('workflowsAll.sold_tickets_9825f4d', 'Sold tickets')
  case 'workflowsAll.section_f2c6b56':
    return this.adminText('workflowsAll.section_f2c6b56', 'Section')
  case 'workflowsAll.capacity_45bd908':
    return this.adminText('workflowsAll.capacity_45bd908', 'Capacity')
  case 'workflowsAll.buyer_info_eb8824e':
    return this.adminText('workflowsAll.buyer_info_eb8824e', 'Buyer info')
  case 'workflowsAll.used_promocodes_49deee9':
    return this.adminText('workflowsAll.used_promocodes_49deee9', 'Used promocodes')
  case 'workflowsAll.there_are_currently_no_tickets_sold_with_a_pr_9a53bc5':
    return this.adminText('workflowsAll.there_are_currently_no_tickets_sold_with_a_pr_9a53bc5', 'There are currently no tickets sold with a promo code.')
  case 'workflowsAll.unlimited_e1a6f0b':
    return this.adminText('workflowsAll.unlimited_e1a6f0b', 'unlimited')
  case 'workflowsAll.total_limited_available_promo_codes_2d4b6bd':
    return this.adminText('workflowsAll.total_limited_available_promo_codes_2d4b6bd', 'Total limited available promo codes')
  case 'workflowsAll.vrste_promo_kodova_eb04859':
    return this.adminText('workflowsAll.vrste_promo_kodova_eb04859', 'Vrste promo kodova')
  case 'workflowsAll.floor_plan_d5786d3':
    return this.adminText('workflowsAll.floor_plan_d5786d3', 'Floor plan')
  case 'workflowsAll.seats_05d560f':
    return this.adminText('workflowsAll.seats_05d560f', 'seats')
  case 'workflowsAll.rows_6c30d26':
    return this.adminText('workflowsAll.rows_6c30d26', 'rows')
  case 'workflowsAll.row_9bf7a8e':
    return this.adminText('workflowsAll.row_9bf7a8e', 'Row')
  case 'workflowsAll.sections_063b114':
    return this.adminText('workflowsAll.sections_063b114', 'sections')
  case 'workflowsAll.group_171a060':
    return this.adminText('workflowsAll.group_171a060', 'Group')
  case 'workflowsAll.r_ff65cdd':
    return this.adminText('workflowsAll.r_ff65cdd', 'R:')
  case 'workflowsAll.s_6d77ecf':
    return this.adminText('workflowsAll.s_6d77ecf', 'S:')
  case 'workflowsAll.info_4b631f6':
    return this.adminText('workflowsAll.info_4b631f6', 'Info')
  case 'workflowsAll.sold_e6560d9':
    return this.adminText('workflowsAll.sold_e6560d9', 'Sold')
  case 'workflowsAll.booked_13e7a65':
    return this.adminText('workflowsAll.booked_13e7a65', 'Booked')
  case 'workflowsAll.r_0657655':
    return this.adminText('workflowsAll.r_0657655', 'R')
  case 'workflowsAll.available_7c62a14':
    return this.adminText('workflowsAll.available_7c62a14', 'Available')
  case 'workflowsAll.unavailable_2c9c1f7':
    return this.adminText('workflowsAll.unavailable_2c9c1f7', 'Unavailable')
  case 'workflowsAll.mark_as_226d8fd':
    return this.adminText('workflowsAll.mark_as_226d8fd', 'Mark as')
  case 'workflowsAll.marked_as_fadf57d':
    return this.adminText('workflowsAll.marked_as_fadf57d', 'Marked as')
  case 'workflowsAll.only_seats_with_the_same_status_can_be_select_f7ca145':
    return this.adminText('workflowsAll.only_seats_with_the_same_status_can_be_select_f7ca145', 'Only seats with the same status can be selected.')
  case 'workflowsAll.ticket_statistics_21dec81':
    return this.adminText('workflowsAll.ticket_statistics_21dec81', 'Ticket statistics')
  case 'workflowsAll.sales_channels_07c6da3':
    return this.adminText('workflowsAll.sales_channels_07c6da3', 'Sales channels')
  case 'workflowsAll.promo_codes_2853dfe':
    return this.adminText('workflowsAll.promo_codes_2853dfe', 'Promo Codes')
  case 'workflowsAll.payment_type_f9fb949':
    return this.adminText('workflowsAll.payment_type_f9fb949', 'Payment type')
  case 'workflowsAll.total_visitors_6b30411':
    return this.adminText('workflowsAll.total_visitors_6b30411', 'Total visitors')
  case 'workflowsAll.pie_chart_icon_38e4120':
    return this.adminText('workflowsAll.pie_chart_icon_38e4120', 'Pie chart icon')
  case 'workflowsAll.active_subscriptions_aed0b1b':
    return this.adminText('workflowsAll.active_subscriptions_aed0b1b', 'Active subscriptions')
  case 'workflowsAll.total_tickets_sold_booked_890298c':
    return this.adminText('workflowsAll.total_tickets_sold_booked_890298c', 'Total tickets sold + Booked')
  case 'workflowsAll.total_earnings_0f37656':
    return this.adminText('workflowsAll.total_earnings_0f37656', 'Total earnings')
  case 'workflowsAll.tickets_sold_by_day_b9b78fb':
    return this.adminText('workflowsAll.tickets_sold_by_day_b9b78fb', 'Tickets sold by day')
  case 'workflowsAll.no_data_to_display_statistics_will_be_availab_e0ac8c7':
    return this.adminText('workflowsAll.no_data_to_display_statistics_will_be_availab_e0ac8c7', 'No data to display. Statistics will be available when someone buys a ticket.')
  case 'workflowsAll.no_data_to_display_for_selected_time_period_7ec19bb':
    return this.adminText('workflowsAll.no_data_to_display_for_selected_time_period_7ec19bb', 'No data to display for selected time period')
  case 'workflowsAll.sold_and_available_tickets_636354d':
    return this.adminText('workflowsAll.sold_and_available_tickets_636354d', 'Sold and available tickets')
  case 'workflowsAll.heatmap_for_average_ticket_purchases_bc1f3de':
    return this.adminText('workflowsAll.heatmap_for_average_ticket_purchases_bc1f3de', 'Heatmap for average ticket purchases')
  case 'workflowsAll.daily_cumulative_revenue_00231ae':
    return this.adminText('workflowsAll.daily_cumulative_revenue_00231ae', 'Daily cumulative revenue')
  case 'workflowsAll.revenue_for_6d9510d':
    return this.adminText('workflowsAll.revenue_for_6d9510d', 'Revenue for')
  case 'workflowsAll.earnings_by_day_d113a53':
    return this.adminText('workflowsAll.earnings_by_day_d113a53', 'Earnings by day')
  case 'workflowsAll.ticket_sales_by_city_ea99615':
    return this.adminText('workflowsAll.ticket_sales_by_city_ea99615', 'Ticket sales by city')
  case 'workflowsAll.city_sales_loading_b34dd68':
    return this.adminText('workflowsAll.city_sales_loading_b34dd68', 'City sales loading...')
  case 'workflowsAll.no_city_sales_data_available_58bda99':
    return this.adminText('workflowsAll.no_city_sales_data_available_58bda99', 'No city sales data available.')
  case 'workflowsAll.show_sales_557d819':
    return this.adminText('workflowsAll.show_sales_557d819', 'Show sales')
  case 'workflowsAll.as_you_start_selling_tickets_your_statistics__4d7d252':
    return this.adminText('workflowsAll.as_you_start_selling_tickets_your_statistics__4d7d252', 'As you start selling tickets, your statistics will appear here.')
  case 'workflowsAll.prodane_ulaznice_a4a7df8':
    return this.adminText('workflowsAll.prodane_ulaznice_a4a7df8', 'Prodane ulaznice')
  case 'workflowsAll.zarada_64f2729':
    return this.adminText('workflowsAll.zarada_64f2729', 'Zarada')
  case 'workflowsAll.revenue_eur_55628aa':
    return this.adminText('workflowsAll.revenue_eur_55628aa', 'Revenue EUR')
  case 'workflowsAll.visitors_number_0685a18':
    return this.adminText('workflowsAll.visitors_number_0685a18', 'Visitors number')
  case 'workflowsAll.total_tickets_sold_41fe770':
    return this.adminText('workflowsAll.total_tickets_sold_41fe770', 'Total tickets sold')
  case 'workflowsAll.free_fc819fb':
    return this.adminText('workflowsAll.free_fc819fb', 'free ·')
  case 'workflowsAll.paid_9e1f112':
    return this.adminText('workflowsAll.paid_9e1f112', 'paid')
  case 'workflowsAll.annual_tickets_be0d78e':
    return this.adminText('workflowsAll.annual_tickets_be0d78e', 'Annual tickets')
  case 'workflowsAll.type_of_tickets_sold_by_day_53d19fd':
    return this.adminText('workflowsAll.type_of_tickets_sold_by_day_53d19fd', 'Type of tickets sold by day')
  case 'workflowsAll.select_a_type_of_tickets_you_would_like_to_ge_3fd7b79':
    return this.adminText('workflowsAll.select_a_type_of_tickets_you_would_like_to_ge_3fd7b79', 'Select a type of tickets you would like to generate a statistic for:')
  case 'workflowsAll.regular_promo_cda2b89':
    return this.adminText('workflowsAll.regular_promo_cda2b89', 'Regular + Promo')
  case 'workflowsAll.promo_e0f4f87':
    return this.adminText('workflowsAll.promo_e0f4f87', 'Promo')
  case 'workflowsAll.gratis_00f5fed':
    return this.adminText('workflowsAll.gratis_00f5fed', 'Gratis')
  case 'workflowsAll.no_data_for_selected_period_37695c0':
    return this.adminText('workflowsAll.no_data_for_selected_period_37695c0', 'No data for selected period.')
  case 'workflowsAll.left_arrow_f85fc1e':
    return this.adminText('workflowsAll.left_arrow_f85fc1e', 'left arrow')
  case 'workflowsAll.vrste_ulaznica_4cc287d':
    return this.adminText('workflowsAll.vrste_ulaznica_4cc287d', 'Vrste ulaznica')
  case 'workflowsAll.visitor_statistics_d28c229':
    return this.adminText('workflowsAll.visitor_statistics_d28c229', 'Visitor statistics')
  case 'workflowsAll.visitors_by_location_201b261':
    return this.adminText('workflowsAll.visitors_by_location_201b261', 'Visitors by location')
  case 'workflowsAll.data_driven_from_google_analytics_7842570':
    return this.adminText('workflowsAll.data_driven_from_google_analytics_7842570', '*data driven from Google Analytics')
  case 'workflowsAll.visitors_by_age_and_gender_8661b4a':
    return this.adminText('workflowsAll.visitors_by_age_and_gender_8661b4a', 'Visitors by age and gender')
  case 'workflowsAll.f_e69f20e':
    return this.adminText('workflowsAll.f_e69f20e', 'F')
  case 'workflowsAll.m_c63ae6d':
    return this.adminText('workflowsAll.m_c63ae6d', 'M')
  case 'workflowsAll.visitors_by_traffic_sources_2b85840':
    return this.adminText('workflowsAll.visitors_by_traffic_sources_2b85840', 'Visitors by traffic sources')
  case 'workflowsAll.visitors_total_number_9bc818d':
    return this.adminText('workflowsAll.visitors_total_number_9bc818d', 'Visitors total number')
  case 'workflowsAll.back_to_reports_f709622':
    return this.adminText('workflowsAll.back_to_reports_f709622', 'Back to reports')
  case 'workflowsAll.sales_report_0f89ab2':
    return this.adminText('workflowsAll.sales_report_0f89ab2', 'Sales Report')
  case 'workflowsAll.select_a_e103f76':
    return this.adminText('workflowsAll.select_a_e103f76', 'Select a')
  case 'workflowsAll.you_want_to_generate_a_report_for_bc47693':
    return this.adminText('workflowsAll.you_want_to_generate_a_report_for_bc47693', 'you want to generate a report for:')
  case 'workflowsAll.select_a_1fec0e9':
    return this.adminText('workflowsAll.select_a_1fec0e9', 'Select a ')
  case 'workflowsAll.select_an_interval_you_want_to_generate_a_rep_79b81b0':
    return this.adminText('workflowsAll.select_an_interval_you_want_to_generate_a_rep_79b81b0', 'Select an interval you want to generate a report for:')
  case 'workflowsAll.from_c4d63e4':
    return this.adminText('workflowsAll.from_c4d63e4', 'From:')
  case 'workflowsAll.select_a_date_642b09c':
    return this.adminText('workflowsAll.select_a_date_642b09c', 'Select a date')
  case 'workflowsAll.to_7e7fbc8':
    return this.adminText('workflowsAll.to_7e7fbc8', 'To:')
  case 'workflowsAll.generate_569e9e1':
    return this.adminText('workflowsAll.generate_569e9e1', 'GENERATE')
  case 'workflowsAll.export_excele_f2cc414':
    return this.adminText('workflowsAll.export_excele_f2cc414', 'EXPORT EXCELE')
  case 'workflowsAll.reports_88bc3fe':
    return this.adminText('workflowsAll.reports_88bc3fe', 'Reports')
  case 'workflowsAll.daily_sales_report_8c52942':
    return this.adminText('workflowsAll.daily_sales_report_8c52942', 'Daily Sales Report')
  case 'workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_89e2d64':
    return this.adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_89e2d64', 'An overview of all ticket sales for a specific day')
  case 'workflowsAll.monthly_sales_report_9a40f09':
    return this.adminText('workflowsAll.monthly_sales_report_9a40f09', 'Monthly Sales Report')
  case 'workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_151744a':
    return this.adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_151744a', 'An overview of all ticket sales for a specific month')
  case 'workflowsAll.yearly_sales_report_82259bb':
    return this.adminText('workflowsAll.yearly_sales_report_82259bb', 'Yearly Sales Report')
  case 'workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_913e800':
    return this.adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_specifi_913e800', 'An overview of all ticket sales for a specific year')
  case 'workflowsAll.custom_sales_report_510eef6':
    return this.adminText('workflowsAll.custom_sales_report_510eef6', 'Custom Sales Report')
  case 'workflowsAll.an_overview_of_all_ticket_sales_for_a_custom__30202ce':
    return this.adminText('workflowsAll.an_overview_of_all_ticket_sales_for_a_custom__30202ce', 'An overview of all ticket sales for a custom period of time')
  case 'workflowsAll.back_to_orders_f02399a':
    return this.adminText('workflowsAll.back_to_orders_f02399a', 'Back to orders')
  case 'workflowsAll.order_f1e486f':
    return this.adminText('workflowsAll.order_f1e486f', 'Order #')
  case 'workflowsAll.proccessed_at_e8e02d4':
    return this.adminText('workflowsAll.proccessed_at_e8e02d4', 'Proccessed at')
  case 'workflowsAll.go_to_tickets_61fd0fb':
    return this.adminText('workflowsAll.go_to_tickets_61fd0fb', 'Go to tickets')
  case 'workflowsAll.go_to_button_afb193e':
    return this.adminText('workflowsAll.go_to_button_afb193e', 'Go to button')
  case 'workflowsAll.view_event_page_45f6c2c':
    return this.adminText('workflowsAll.view_event_page_45f6c2c', 'View event page')
  case 'workflowsAll.copy_67fba2f':
    return this.adminText('workflowsAll.copy_67fba2f', '×')
  case 'workflowsAll.vat_is_included_e9c65e8':
    return this.adminText('workflowsAll.vat_is_included_e9c65e8', 'VAT is included.')
  case 'workflowsAll.print_tickets_f99b47a':
    return this.adminText('workflowsAll.print_tickets_f99b47a', 'PRINT TICKETS')
  case 'workflowsAll.this_order_has_been_refunded_on_dae0295':
    return this.adminText('workflowsAll.this_order_has_been_refunded_on_dae0295', 'This order has been refunded on')
  case 'workflowsAll.confirm_refund_6038506':
    return this.adminText('workflowsAll.confirm_refund_6038506', 'Confirm refund')
  case 'workflowsAll.are_you_sure_you_want_to_refund_order_33186df':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_refund_order_33186df', 'Are you sure you want to refund order #')
  case 'workflowsAll.this_cannot_be_undone_0c7fd3f':
    return this.adminText('workflowsAll.this_cannot_be_undone_0c7fd3f', '? This cannot be undone.')
  case 'workflowsAll.refund_e17c8ad':
    return this.adminText('workflowsAll.refund_e17c8ad', 'Refund')
  case 'workflowsAll.something_went_wrong_while_processing_the_ref_23ba9e0':
    return this.adminText('workflowsAll.something_went_wrong_while_processing_the_ref_23ba9e0', 'Something went wrong while processing the refund.')
  case 'workflowsAll.something_went_wrong_while_requesting_the_ref_beaf39a':
    return this.adminText('workflowsAll.something_went_wrong_while_requesting_the_ref_beaf39a', 'Something went wrong while requesting the refund.')
  case 'workflowsAll.order_refunded_8b9b18c':
    return this.adminText('workflowsAll.order_refunded_8b9b18c', 'Order refunded.')
  case 'workflowsAll.refund_successfully_requested_24e7221':
    return this.adminText('workflowsAll.refund_successfully_requested_24e7221', 'Refund successfully requested.')
  case 'workflowsAll.orders_cded093':
    return this.adminText('workflowsAll.orders_cded093', 'Orders')
  case 'workflowsAll.search_orders_7ab3015':
    return this.adminText('workflowsAll.search_orders_7ab3015', 'Search orders')
  case 'workflowsAll.there_are_no_orders_made_yet_04511c9':
    return this.adminText('workflowsAll.there_are_no_orders_made_yet_04511c9', 'There are no orders made yet.')
  case 'workflowsAll.order_no_53a812f':
    return this.adminText('workflowsAll.order_no_53a812f', 'Order No.')
  case 'workflowsAll.order_date_121398e':
    return this.adminText('workflowsAll.order_date_121398e', 'Order date')
  case 'workflowsAll.event_date_8aa634d':
    return this.adminText('workflowsAll.event_date_8aa634d', 'Event date')
  case 'workflowsAll.total_price_a2a7c60':
    return this.adminText('workflowsAll.total_price_a2a7c60', 'Total Price')
  case 'workflowsAll.cash_register_report_dfee8e4':
    return this.adminText('workflowsAll.cash_register_report_dfee8e4', 'Cash register report')
  case 'workflowsAll.sales_report_d874919':
    return this.adminText('workflowsAll.sales_report_d874919', ' Sales Report')
  case 'workflowsAll.at_27e90df':
    return this.adminText('workflowsAll.at_27e90df', 'at')
  case 'workflowsAll.available_7b231a5':
    return this.adminText('workflowsAll.available_7b231a5', 'available')
  case 'workflowsAll.event_type_d5b2b91':
    return this.adminText('workflowsAll.event_type_d5b2b91', 'event-type')
  case 'workflowsAll.finalize_payment_and_details_8a34cfb':
    return this.adminText('workflowsAll.finalize_payment_and_details_8a34cfb', 'Finalize Payment and Details')
  case 'workflowsAll.payment_method_0e55fb3':
    return this.adminText('workflowsAll.payment_method_0e55fb3', 'Payment method')
  case 'workflowsAll.customer_should_pay_f2101af':
    return this.adminText('workflowsAll.customer_should_pay_f2101af', 'Customer should pay:')
  case 'workflowsAll.ticket_a7677e8':
    return this.adminText('workflowsAll.ticket_a7677e8', 'Ticket')
  case 'workflowsAll.first_name_3cba86b':
    return this.adminText('workflowsAll.first_name_3cba86b', 'First name*')
  case 'workflowsAll.last_name_b649dc9':
    return this.adminText('workflowsAll.last_name_b649dc9', 'Last name*')
  case 'workflowsAll.buyer_s_mail_optional_4ea60f1':
    return this.adminText('workflowsAll.buyer_s_mail_optional_4ea60f1', 'Buyer\'s mail (optional)')
  case 'workflowsAll.by_adding_the_buyer_s_email_there_will_be_a_c_3628276':
    return this.adminText('workflowsAll.by_adding_the_buyer_s_email_there_will_be_a_c_3628276', 'By adding the buyer\'s email, there will be a chance for CoreEvent to get in touch with the buyer in case of any changes.')
  case 'workflowsAll.additional_ticket_note_7c7ea9c':
    return this.adminText('workflowsAll.additional_ticket_note_7c7ea9c', 'Additional ticket note')
  case 'workflowsAll.available_characters_ca9295d':
    return this.adminText('workflowsAll.available_characters_ca9295d', 'Available characters: ')
  case 'workflowsAll.continue_2e02623':
    return this.adminText('workflowsAll.continue_2e02623', 'Continue')
  case 'workflowsAll.back_to_events_bd9a217':
    return this.adminText('workflowsAll.back_to_events_bd9a217', 'Back to events')
  case 'workflowsAll.ticket_sales_for_this_event_are_unavailable_8f6c8a5':
    return this.adminText('workflowsAll.ticket_sales_for_this_event_are_unavailable_8f6c8a5', 'Ticket sales for this event are unavailable.')
  case 'workflowsAll.dostupnost_ulaznica_ff56a5a':
    return this.adminText('workflowsAll.dostupnost_ulaznica_ff56a5a', 'Dostupnost ulaznica')
  case 'workflowsAll.order_summary_db14f49':
    return this.adminText('workflowsAll.order_summary_db14f49', 'Order summary')
  case 'workflowsAll.x_coreevent_fee_0baa216':
    return this.adminText('workflowsAll.x_coreevent_fee_0baa216', 'x CoreEvent fee')
  case 'workflowsAll.x_tisak_naknada_3c87c0e':
    return this.adminText('workflowsAll.x_tisak_naknada_3c87c0e', 'x Tisak naknada')
  case 'workflowsAll.no_tickets_selected_aa95d27':
    return this.adminText('workflowsAll.no_tickets_selected_aa95d27', 'No tickets selected.')
  case 'workflowsAll.finish_order_690c21b':
    return this.adminText('workflowsAll.finish_order_690c21b', 'FINISH ORDER')
  case 'workflowsAll.order_was_successful_but_ticket_availability__2728831':
    return this.adminText('workflowsAll.order_was_successful_but_ticket_availability__2728831', 'Order was successful, but ticket availability could not be refreshed.')
  case 'workflowsAll.order_successfully_processed_3956051':
    return this.adminText('workflowsAll.order_successfully_processed_3956051', 'Order Successfully Processed')
  case 'workflowsAll.your_order_has_been_successfully_processed_yo_86bf82b':
    return this.adminText('workflowsAll.your_order_has_been_successfully_processed_yo_86bf82b', 'Your order has been successfully processed. You can now print your tickets or review your order details.')
  case 'workflowsAll.view_order_0df2797':
    return this.adminText('workflowsAll.view_order_0df2797', 'View order')
  case 'workflowsAll.print_tickets_5f4b92f':
    return this.adminText('workflowsAll.print_tickets_5f4b92f', 'Print tickets')
  case 'workflowsAll.choose_the_event_you_want_to_sell_tickets_for_4d060cd':
    return this.adminText('workflowsAll.choose_the_event_you_want_to_sell_tickets_for_4d060cd', 'Choose the event you want to sell tickets for.')
  case 'workflowsAll.unfortunately_there_are_no_events_available_r_f029fd2':
    return this.adminText('workflowsAll.unfortunately_there_are_no_events_available_r_f029fd2', 'Unfortunately, there are no events available right now.')
  case 'workflowsAll.to_edit_your_seating_layout_choose_a_floor_pl_a32aba9':
    return this.adminText('workflowsAll.to_edit_your_seating_layout_choose_a_floor_pl_a32aba9', 'To edit your seating layout, choose a floor plan from the list below or upload your venue floor plan.')
  case 'workflowsAll.edit_floor_plan_a391b0b':
    return this.adminText('workflowsAll.edit_floor_plan_a391b0b', 'Edit floor plan')
  case 'workflowsAll.connect_your_tickets_to_seating_areas_click_t_8735a1a':
    return this.adminText('workflowsAll.connect_your_tickets_to_seating_areas_click_t_8735a1a', 'Connect your tickets to seating areas. Click to select a specific seat, drag to select seats, then choose a ticket you want to connect.')
  case 'workflowsAll.change_venue_efedb48':
    return this.adminText('workflowsAll.change_venue_efedb48', 'Change venue')
  case 'workflowsAll.are_you_sure_you_want_to_change_the_venue_thi_4b469fb':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_change_the_venue_thi_4b469fb', 'Are you sure you want to change the venue? This will permanently delete your current venue configuration.')
  case 'workflowsAll.change_64fbd99':
    return this.adminText('workflowsAll.change_64fbd99', 'Change')
  case 'workflowsAll.reset_995f2d9':
    return this.adminText('workflowsAll.reset_995f2d9', 'RESET')
  case 'workflowsAll.selected_sections_have_different_tickets_59d3232':
    return this.adminText('workflowsAll.selected_sections_have_different_tickets_59d3232', 'Selected sections have different tickets!')
  case 'workflowsAll.seats_that_are_not_selected_have_different_ti_8a0297a':
    return this.adminText('workflowsAll.seats_that_are_not_selected_have_different_ti_8a0297a', 'Seats that are not selected have different tickets!')
  case 'workflowsAll.elements_that_are_not_selected_are_different__4994dbb':
    return this.adminText('workflowsAll.elements_that_are_not_selected_are_different__4994dbb', 'Elements that are not selected are different types!')
  case 'workflowsAll.to_edit_your_floor_plan_and_seating_layouts_f_d48b002':
    return this.adminText('workflowsAll.to_edit_your_floor_plan_and_seating_layouts_f_d48b002', 'To edit your floor plan and seating layouts, first add tickets that will connect to seats.')
  case 'workflowsAll.color_6dd0fe8':
    return this.adminText('workflowsAll.color_6dd0fe8', 'color')
  case 'workflowsAll.select_0caa404':
    return this.adminText('workflowsAll.select_0caa404', 'Select ')
  case 'workflowsAll.color_8a59990':
    return this.adminText('workflowsAll.color_8a59990', ' color ')
  case 'workflowsAll.show_fewer_seat_colors_e0ec1a6':
    return this.adminText('workflowsAll.show_fewer_seat_colors_e0ec1a6', 'Show fewer seat colors')
  case 'workflowsAll.show_all_seat_colors_a7f17c8':
    return this.adminText('workflowsAll.show_all_seat_colors_a7f17c8', 'Show all seat colors')
  case 'workflowsAll.marked_99a8606':
    return this.adminText('workflowsAll.marked_99a8606', 'Marked')
  case 'workflowsAll.selected_9a976fc':
    return this.adminText('workflowsAll.selected_9a976fc', 'Selected')
  case 'workflowsAll.two_tickets_added_c0d33cd':
    return this.adminText('workflowsAll.two_tickets_added_c0d33cd', 'Two tickets added')
  case 'workflowsAll.booked_sold_e485ebd':
    return this.adminText('workflowsAll.booked_sold_e485ebd', 'Booked/Sold')
  case 'workflowsAll.connected_c2f9b7b':
    return this.adminText('workflowsAll.connected_c2f9b7b', 'Connected')
  case 'workflowsAll.additional_c897b99':
    return this.adminText('workflowsAll.additional_c897b99', 'Additional')
  case 'workflowsAll.parter_tickets_3278588':
    return this.adminText('workflowsAll.parter_tickets_3278588', 'Parter tickets')
  case 'workflowsAll.seating_tickets_1a18846':
    return this.adminText('workflowsAll.seating_tickets_1a18846', 'Seating tickets')
  case 'workflowsAll.table_tickets_5dcbcfe':
    return this.adminText('workflowsAll.table_tickets_5dcbcfe', 'Table tickets')
  case 'workflowsAll.create_gratis_ticket_a3c24cf':
    return this.adminText('workflowsAll.create_gratis_ticket_a3c24cf', 'Create gratis ticket')
  case 'workflowsAll.print_format_811ba19':
    return this.adminText('workflowsAll.print_format_811ba19', 'Print format')
  case 'workflowsAll.next_bc98198':
    return this.adminText('workflowsAll.next_bc98198', 'Next')
  case 'workflowsAll.create_download_tickets_4ed0c49':
    return this.adminText('workflowsAll.create_download_tickets_4ed0c49', 'Create & download tickets')
  case 'workflowsAll.number_of_selected_tickets_doesn_t_match_defi_28c1ebf':
    return this.adminText('workflowsAll.number_of_selected_tickets_doesn_t_match_defi_28c1ebf', 'Number of selected tickets doesn\'t match defined quantity')
  case 'workflowsAll.back_to_tickets_de31c24':
    return this.adminText('workflowsAll.back_to_tickets_de31c24', 'Back to tickets')
  case 'workflowsAll.gratis_tickets_a63f4c3':
    return this.adminText('workflowsAll.gratis_tickets_a63f4c3', 'Gratis tickets')
  case 'workflowsAll.add_and_manage_your_gratis_tickets_1b25d12':
    return this.adminText('workflowsAll.add_and_manage_your_gratis_tickets_1b25d12', 'Add and manage your gratis tickets.')
  case 'workflowsAll.new_gratis_ticket_4314039':
    return this.adminText('workflowsAll.new_gratis_ticket_4314039', 'New gratis ticket')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_gratis_t_5cf621b':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_gratis_t_5cf621b', 'Are you sure you want to delete this gratis ticket? This operation cannot be undone.')
  case 'workflowsAll.delete_gratis_ticket_68cfb47':
    return this.adminText('workflowsAll.delete_gratis_ticket_68cfb47', 'Delete gratis ticket')
  case 'workflowsAll.ticket_name_49f0db5':
    return this.adminText('workflowsAll.ticket_name_49f0db5', 'Ticket name')
  case 'workflowsAll.quantity_44f6af6':
    return this.adminText('workflowsAll.quantity_44f6af6', 'Quantity')
  case 'workflowsAll.price_3e8248e':
    return this.adminText('workflowsAll.price_3e8248e', 'Price')
  case 'workflowsAll.what_is_sale_status_8f92a03':
    return this.adminText('workflowsAll.what_is_sale_status_8f92a03', 'What is "Sale Status"?')
  case 'workflowsAll.the_ability_to_change_these_statuses_is_a_new_527dbfb':
    return this.adminText('workflowsAll.the_ability_to_change_these_statuses_is_a_new_527dbfb', 'The ability to change these statuses is a new feature to allow organizers quick and easy management.')
  case 'workflowsAll.on_hold_73fd29e':
    return this.adminText('workflowsAll.on_hold_73fd29e', 'On Hold')
  case 'workflowsAll.the_ticket_type_will_be_available_from_the_sp_3adc77f':
    return this.adminText('workflowsAll.the_ticket_type_will_be_available_from_the_sp_3adc77f', 'The ticket type will be available from the specified time. You can mark them as immediately available by clicking the toggle.')
  case 'workflowsAll.tickets_for_this_type_are_currently_available_5f1f2e1':
    return this.adminText('workflowsAll.tickets_for_this_type_are_currently_available_5f1f2e1', 'Tickets for this type are currently available for purchase.')
  case 'workflowsAll.sold_out_76fd560':
    return this.adminText('workflowsAll.sold_out_76fd560', 'Sold Out')
  case 'workflowsAll.all_tickets_for_this_type_have_been_sold_and__1a5a65a':
    return this.adminText('workflowsAll.all_tickets_for_this_type_have_been_sold_and__1a5a65a', 'All tickets for this type have been sold, and no more are available for purchase.')
  case 'workflowsAll.closed_88d86b7':
    return this.adminText('workflowsAll.closed_88d86b7', 'Closed')
  case 'workflowsAll.selling_for_this_ticket_type_is_closed_7436dd9':
    return this.adminText('workflowsAll.selling_for_this_ticket_type_is_closed_7436dd9', 'Selling for this ticket type is closed.')
  case 'workflowsAll.ok_9ce3bd4':
    return this.adminText('workflowsAll.ok_9ce3bd4', 'OK')
  case 'workflowsAll.create_ticket_3afcbed':
    return this.adminText('workflowsAll.create_ticket_3afcbed', 'Create ticket')
  case 'workflowsAll.update_ticket_8d31fa4':
    return this.adminText('workflowsAll.update_ticket_8d31fa4', 'Update Ticket')
  case 'workflowsAll.new_ticket_b8bf9c8':
    return this.adminText('workflowsAll.new_ticket_b8bf9c8', 'New ticket')
  case 'workflowsAll.gratis_ticket_88fb9bc':
    return this.adminText('workflowsAll.gratis_ticket_88fb9bc', 'Gratis Ticket')
  case 'workflowsAll.event_s_max_capacity_a03d189':
    return this.adminText('workflowsAll.event_s_max_capacity_a03d189', 'Event\'s max capacity')
  case 'workflowsAll.are_you_sure_you_want_to_delete_selected_tick_15cbb98':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_tick_15cbb98', 'Are you sure you want to delete selected tickets? This operation cannot be undone.')
  case 'workflowsAll.delete_tickets_aefe642':
    return this.adminText('workflowsAll.delete_tickets_aefe642', 'Delete tickets')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_ticket_t_e7236e0':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_ticket_t_e7236e0', 'Are you sure you want to delete this ticket type?')
  case 'workflowsAll.close_window_e3896a9':
    return this.adminText('workflowsAll.close_window_e3896a9', 'Close window')
  case 'workflowsAll.users_will_not_be_able_to_see_or_buy_this_tic_4b25906':
    return this.adminText('workflowsAll.users_will_not_be_able_to_see_or_buy_this_tic_4b25906', 'Users will not be able to see or buy this ticket type and all the data will be lost. If you just want to hide this ticket type, you can change the visibility setting in the edit section. If you still want to proceed, this action cannot be undone.')
  case 'workflowsAll.edit_ticket_fa35ddb':
    return this.adminText('workflowsAll.edit_ticket_fa35ddb', 'Edit ticket')
  case 'workflowsAll.choose_where_attendees_can_purchase_tickets_f_1980067':
    return this.adminText('workflowsAll.choose_where_attendees_can_purchase_tickets_f_1980067', 'Choose where attendees can purchase tickets for this event.')
  case 'workflowsAll.create_at_least_one_ticket_before_selecting_a_534e4ad':
    return this.adminText('workflowsAll.create_at_least_one_ticket_before_selecting_a_534e4ad', 'Create at least one ticket before selecting a sales channel.')
  case 'workflowsAll.sales_channel_2ec4e30':
    return this.adminText('workflowsAll.sales_channel_2ec4e30', 'Sales channel')
  case 'workflowsAll.select_outlets_f829de6':
    return this.adminText('workflowsAll.select_outlets_f829de6', 'Select outlets')
  case 'workflowsAll.tisak_outlets_will_charge_ticket_buyers_an_ad_4f02543':
    return this.adminText('workflowsAll.tisak_outlets_will_charge_ticket_buyers_an_ad_4f02543', 'TISAK outlets will charge ticket buyers an additional ticket fee.')
  case 'workflowsAll.save_sales_channels_0171ad1':
    return this.adminText('workflowsAll.save_sales_channels_0171ad1', 'Save sales channels')
  case 'workflowsAll.create_ticket_afe9a7a':
    return this.adminText('workflowsAll.create_ticket_afe9a7a', 'Create Ticket')
  case 'workflowsAll.this_ticket_type_cannot_be_deleted_41b425f':
    return this.adminText('workflowsAll.this_ticket_type_cannot_be_deleted_41b425f', 'This ticket type cannot be deleted')
  case 'workflowsAll.there_are_purchases_containing_this_ticket_ty_863bae0':
    return this.adminText('workflowsAll.there_are_purchases_containing_this_ticket_ty_863bae0', 'There are purchases containing this ticket type. If you want users to not be able to see or buy this ticket type, you can change the visibility setting in the edit section.')
  case 'workflowsAll.sales_channels_save_successfully_b9c2cd1':
    return this.adminText('workflowsAll.sales_channels_save_successfully_b9c2cd1', 'Sales channels save successfully.')
  case 'workflowsAll.event_s_max_capacity_successfully_updated_8946ee0':
    return this.adminText('workflowsAll.event_s_max_capacity_successfully_updated_8946ee0', 'Event\'s max capacity successfully updated.')
  case 'workflowsAll.update_gratis_ticket_8ea1c70':
    return this.adminText('workflowsAll.update_gratis_ticket_8ea1c70', 'Update Gratis Ticket')
  case 'workflowsAll.review_and_update_the_ticket_information_belo_a8da17a':
    return this.adminText('workflowsAll.review_and_update_the_ticket_information_belo_a8da17a', 'Review and update the ticket information below to ensure all details are accurate and reflect the latest status.')
  case 'workflowsAll.design_webshop_tickets_8a7e7d9':
    return this.adminText('workflowsAll.design_webshop_tickets_8a7e7d9', 'Design webshop tickets')
  case 'workflowsAll.customize_the_visual_elements_your_customers__4931b42':
    return this.adminText('workflowsAll.customize_the_visual_elements_your_customers__4931b42', 'Customize the visual elements your customers will see when buying tickets online.')
  case 'workflowsAll.1_main_image_0f84133':
    return this.adminText('workflowsAll.1_main_image_0f84133', '1 - Main image')
  case 'workflowsAll.reuse_event_cover_image_0f44157':
    return this.adminText('workflowsAll.reuse_event_cover_image_0f44157', 'Reuse event cover image')
  case 'workflowsAll.2_organizer_message_94ca6d1':
    return this.adminText('workflowsAll.2_organizer_message_94ca6d1', '2 - Organizer message')
  case 'workflowsAll.organizer_message_851e730':
    return this.adminText('workflowsAll.organizer_message_851e730', 'Organizer message')
  case 'workflowsAll.3_additional_visual_optional_df550bc':
    return this.adminText('workflowsAll.3_additional_visual_optional_df550bc', '3 – Additional visual (optional)')
  case 'workflowsAll.we_recommend_placing_the_logos_of_your_event__51f2470':
    return this.adminText('workflowsAll.we_recommend_placing_the_logos_of_your_event__51f2470', 'We recommend placing the logos of your event\'s partners/sponsors here or adding an extra branding touch to the event.')
  case 'workflowsAll.error_in_updating_data_c9e96a4':
    return this.adminText('workflowsAll.error_in_updating_data_c9e96a4', 'Error in updating data.')
  case 'workflowsAll.entry_with_this_ticket_is_restricted_by_date__e262725':
    return this.adminText('workflowsAll.entry_with_this_ticket_is_restricted_by_date__e262725', 'Entry with this ticket is restricted by date range')
  case 'workflowsAll.this_enables_you_to_limit_when_tickets_can_be_eabc89b':
    return this.adminText('workflowsAll.this_enables_you_to_limit_when_tickets_can_be_eabc89b', 'This enables you to limit when tickets can be scanned for entry to the event using the CoreEvent Scanner app. For example, for a festival with tickets for Friday and Saturday, enabling this ensures that Friday tickets can only be scanned on Friday, and Saturday tickets only on Saturday. The valid dates for each ticket will be printed on the ticket.')
  case 'workflowsAll.single_day_0af1a3d':
    return this.adminText('workflowsAll.single_day_0af1a3d', 'Single Day')
  case 'workflowsAll.multiple_days_2f4458c':
    return this.adminText('workflowsAll.multiple_days_2f4458c', 'Multiple Days')
  case 'workflowsAll.start_date_976276c':
    return this.adminText('workflowsAll.start_date_976276c', 'Start Date*')
  case 'workflowsAll.end_date_ab621d2':
    return this.adminText('workflowsAll.end_date_ab621d2', 'End Date*')
  case 'workflowsAll.edit_event_s_max_capacity_2ea872c':
    return this.adminText('workflowsAll.edit_event_s_max_capacity_2ea872c', 'Edit Event\'s max capacity')
  case 'workflowsAll.setting_the_event_s_capacity_determines_the_m_ca705e7':
    return this.adminText('workflowsAll.setting_the_event_s_capacity_determines_the_m_ca705e7', 'Setting the event\'s capacity determines the maximum number of tickets created. This limit might be removed later.')
  case 'workflowsAll.enabled_df174a3':
    return this.adminText('workflowsAll.enabled_df174a3', 'Enabled')
  case 'workflowsAll.disabled_f4f4473':
    return this.adminText('workflowsAll.disabled_f4f4473', 'Disabled')
  case 'workflowsAll.seats_692aab5':
    return this.adminText('workflowsAll.seats_692aab5', 'Seats')
  case 'workflowsAll.rows_52d0b35':
    return this.adminText('workflowsAll.rows_52d0b35', 'Rows')
  case 'workflowsAll.ticket_not_asssigned_disabled_4d8fbef':
    return this.adminText('workflowsAll.ticket_not_asssigned_disabled_4d8fbef', 'Ticket not asssigned / Disabled')
  case 'workflowsAll.ticket_type_74abc78':
    return this.adminText('workflowsAll.ticket_type_74abc78', 'Ticket type')
  case 'workflowsAll.ticket_name_cb5eb35':
    return this.adminText('workflowsAll.ticket_name_cb5eb35', 'Ticket name*')
  case 'workflowsAll.price_ebb41ba':
    return this.adminText('workflowsAll.price_ebb41ba', 'Price*')
  case 'workflowsAll.initial_quantity_42dcebf':
    return this.adminText('workflowsAll.initial_quantity_42dcebf', 'Initial quantity*')
  case 'workflowsAll.maximum_a8df2fe':
    return this.adminText('workflowsAll.maximum_a8df2fe', 'Maximum')
  case 'workflowsAll.gratis_tickets_per_creation_d64e87b':
    return this.adminText('workflowsAll.gratis_tickets_per_creation_d64e87b', 'gratis tickets per creation.')
  case 'workflowsAll.ticket_description_e0c73b5':
    return this.adminText('workflowsAll.ticket_description_e0c73b5', 'Ticket description')
  case 'workflowsAll.kiosk_terminal_locations_8c64ecc':
    return this.adminText('workflowsAll.kiosk_terminal_locations_8c64ecc', 'Kiosk terminal locations')
  case 'workflowsAll.we_re_actively_rolling_out_self_service_kiosk_bbc300f':
    return this.adminText('workflowsAll.we_re_actively_rolling_out_self_service_kiosk_bbc300f', 'We’re actively rolling out self-service kiosks in various locations. Here’s a list of the ones currently live and ready to use:')
  case 'workflowsAll.s_selected_bc2bcbd':
    return this.adminText('workflowsAll.s_selected_bc2bcbd', 's selected')
  case 'workflowsAll.gratis_6d65eea':
    return this.adminText('workflowsAll.gratis_6d65eea', 'GRATIS')
  case 'workflowsAll.vip_terms_and_conditions_c738faf':
    return this.adminText('workflowsAll.vip_terms_and_conditions_c738faf', 'VIP terms and conditions')
  case 'workflowsAll.read_less_80d817c':
    return this.adminText('workflowsAll.read_less_80d817c', 'READ LESS')
  case 'workflowsAll.read_more_78577db':
    return this.adminText('workflowsAll.read_more_78577db', 'READ MORE')
  case 'workflowsAll.sold_out_02ff659':
    return this.adminText('workflowsAll.sold_out_02ff659', 'Sold out')
  case 'workflowsAll.e_g_vip_ticket_regular_early_bird_etc_3805574':
    return this.adminText('workflowsAll.e_g_vip_ticket_regular_early_bird_etc_3805574', 'e.g. VIP Ticket, Regular, Early Bird, etc.')
  case 'workflowsAll.ticket_category_f351fd1':
    return this.adminText('workflowsAll.ticket_category_f351fd1', 'Ticket category')
  case 'workflowsAll.used_for_ticket_segmentation_we_recommend_mor_75ec608':
    return this.adminText('workflowsAll.used_for_ticket_segmentation_we_recommend_mor_75ec608', 'Used for ticket segmentation. We recommend more than 1 category.')
  case 'workflowsAll.create_category_61495a8':
    return this.adminText('workflowsAll.create_category_61495a8', 'Create category')
  case 'workflowsAll.price_cannot_be_changed_after_a_ticket_has_be_205dd4f':
    return this.adminText('workflowsAll.price_cannot_be_changed_after_a_ticket_has_be_205dd4f', 'Price cannot be changed after a ticket has been sold at least once.')
  case 'workflowsAll.ticket_valid_only_for_club_members_804c26b':
    return this.adminText('workflowsAll.ticket_valid_only_for_club_members_804c26b', 'Ticket valid only for club members.')
  case 'workflowsAll.per_order_min_2e89496':
    return this.adminText('workflowsAll.per_order_min_2e89496', 'Per order min*')
  case 'workflowsAll.minimum_of_tickets_a_customer_must_choose_whe_3edaa96':
    return this.adminText('workflowsAll.minimum_of_tickets_a_customer_must_choose_whe_3edaa96', 'Minimum of tickets a customer must choose when purchasing.')
  case 'workflowsAll.per_order_max_56f74fa':
    return this.adminText('workflowsAll.per_order_max_56f74fa', 'Per order max*')
  case 'workflowsAll.amount_of_tickets_that_will_be_available_for__17a6dad':
    return this.adminText('workflowsAll.amount_of_tickets_that_will_be_available_for__17a6dad', 'Amount of tickets that will be available for sale.')
  case 'workflowsAll.start_date_2fde03a':
    return this.adminText('workflowsAll.start_date_2fde03a', 'Start date*')
  case 'workflowsAll.start_date_of_sale_of_this_ticket_type_to_sta_9e45afe':
    return this.adminText('workflowsAll.start_date_of_sale_of_this_ticket_type_to_sta_9e45afe', 'Start date of sale of this ticket type. To start sale immediately, set it to current time.')
  case 'workflowsAll.end_date_dc7fcbd':
    return this.adminText('workflowsAll.end_date_dc7fcbd', 'End date*')
  case 'workflowsAll.end_date_of_sale_of_this_ticket_type_74495a9':
    return this.adminText('workflowsAll.end_date_of_sale_of_this_ticket_type_74495a9', 'End date of sale of this ticket type.')
  case 'workflowsAll.ticket_description_visible_to_customers_when__ac5dcc9':
    return this.adminText('workflowsAll.ticket_description_visible_to_customers_when__ac5dcc9', 'Ticket description visible to customers when buying a ticket.')
  case 'workflowsAll.digital_outlets_a32c9d9':
    return this.adminText('workflowsAll.digital_outlets_a32c9d9', 'Digital outlets')
  case 'workflowsAll.web_shop_edd5715':
    return this.adminText('workflowsAll.web_shop_edd5715', 'Web shop')
  case 'workflowsAll.kiosk_terminals_f893db7':
    return this.adminText('workflowsAll.kiosk_terminals_f893db7', 'Kiosk terminals')
  case 'workflowsAll.physical_outlets_be785a4':
    return this.adminText('workflowsAll.physical_outlets_be785a4', 'Physical outlets')
  case 'workflowsAll.shops_ac06f65':
    return this.adminText('workflowsAll.shops_ac06f65', 'Shops')
  case 'workflowsAll.select_outlets_c18d2bc':
    return this.adminText('workflowsAll.select_outlets_c18d2bc', 'Select Outlets')
  case 'workflowsAll.tisak_outlets_will_charge_ticket_buyers_an_ad_37235cd':
    return this.adminText('workflowsAll.tisak_outlets_will_charge_ticket_buyers_an_ad_37235cd', 'TISAK outlets will charge ticket buyers an additional ticket fee')
  case 'workflowsAll.select_all_86a599e':
    return this.adminText('workflowsAll.select_all_86a599e', 'Select All')
  case 'workflowsAll.the_price_of_the_ticket_must_be_greater_than__56600ce':
    return this.adminText('workflowsAll.the_price_of_the_ticket_must_be_greater_than__56600ce', 'The price of the ticket must be greater than 1 euro to be able to add ticket sellers.')
  case 'workflowsAll.display_the_ticket_in_the_store_if_sold_out_o_2956d04':
    return this.adminText('workflowsAll.display_the_ticket_in_the_store_if_sold_out_o_2956d04', 'Display the ticket in the store if sold out or has expired')
  case 'workflowsAll.ticket_access_code_2b3e938':
    return this.adminText('workflowsAll.ticket_access_code_2b3e938', 'Ticket Access Code')
  case 'workflowsAll.ticket_access_code_c686c08':
    return this.adminText('workflowsAll.ticket_access_code_c686c08', 'Ticket Access Code*')
  case 'workflowsAll.enter_code_4_8_characters_b8d9511':
    return this.adminText('workflowsAll.enter_code_4_8_characters_b8d9511', 'Enter code (4-8 characters)')
  case 'workflowsAll.the_code_must_be_between_4_and_8_characters_l_e37df01':
    return this.adminText('workflowsAll.the_code_must_be_between_4_and_8_characters_l_e37df01', 'The code must be between 4 and 8 characters long and can include letters and numbers.')
  case 'workflowsAll.category_successfully_created_c795b2d':
    return this.adminText('workflowsAll.category_successfully_created_c795b2d', 'Category successfully created!')
  case 'workflowsAll.create_workshop_0ab2f7c':
    return this.adminText('workflowsAll.create_workshop_0ab2f7c', 'Create Workshop')
  case 'workflowsAll.you_need_to_provide_information_about_your_ne_54962df':
    return this.adminText('workflowsAll.you_need_to_provide_information_about_your_ne_54962df', 'You need to provide information about your new workshop. You also need to set an attendance limit or mark it as unlimited. After creating this workshop, your potential attendees will be able to register to it while registering to your event.')
  case 'workflowsAll.update_workshop_75af3eb':
    return this.adminText('workflowsAll.update_workshop_75af3eb', 'Update Workshop')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_workshop_9aad8ee':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_workshop_9aad8ee', 'Are you sure you want to delete this workshop? This operation cannot be undone.')
  case 'workflowsAll.remove_workshop_05b5229':
    return this.adminText('workflowsAll.remove_workshop_05b5229', 'Remove workshop')
  case 'workflowsAll.create_workshop_ba855ec':
    return this.adminText('workflowsAll.create_workshop_ba855ec', 'Create workshop')
  case 'workflowsAll.you_can_add_or_edit_workshops_hosted_at_your__01972de':
    return this.adminText('workflowsAll.you_can_add_or_edit_workshops_hosted_at_your__01972de', 'You can add or edit workshops hosted at your event. You can also track current attendance quota uptake and manage attendees for every workshop.')
  case 'workflowsAll.select_a_hall_3f3689f':
    return this.adminText('workflowsAll.select_a_hall_3f3689f', 'Select a Hall')
  case 'workflowsAll.select_a_day_4fb18f9':
    return this.adminText('workflowsAll.select_a_day_4fb18f9', 'Select a Day')
  case 'workflowsAll.workshop_13b8fe3':
    return this.adminText('workflowsAll.workshop_13b8fe3', 'Workshop')
  case 'workflowsAll.break_7c9d6bf':
    return this.adminText('workflowsAll.break_7c9d6bf', 'Break')
  case 'workflowsAll.attendance_limit_25aa5e1':
    return this.adminText('workflowsAll.attendance_limit_25aa5e1', 'Attendance limit')
  case 'workflowsAll.start_date_ff99f5b':
    return this.adminText('workflowsAll.start_date_ff99f5b', 'Start date')
  case 'workflowsAll.end_date_89d10cd':
    return this.adminText('workflowsAll.end_date_89d10cd', 'End date')
  case 'workflowsAll.all_days_b4f794c':
    return this.adminText('workflowsAll.all_days_b4f794c', 'All days')
  case 'workflowsAll.delete_break_5430c06':
    return this.adminText('workflowsAll.delete_break_5430c06', 'Delete break')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_de38603':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_de38603', 'Are you sure you want to delete this')
  case 'workflowsAll.edit_break_b7d1881':
    return this.adminText('workflowsAll.edit_break_b7d1881', 'Edit Break')
  case 'workflowsAll.create_break_e1807d9':
    return this.adminText('workflowsAll.create_break_e1807d9', 'Create Break')
  case 'workflowsAll.set_the_details_for_this_break_09bf69b':
    return this.adminText('workflowsAll.set_the_details_for_this_break_09bf69b', 'Set the details for this break.')
  case 'workflowsAll.break_name_a2f3742':
    return this.adminText('workflowsAll.break_name_a2f3742', 'Break name')
  case 'workflowsAll.day_987b9ce':
    return this.adminText('workflowsAll.day_987b9ce', 'Day')
  case 'workflowsAll.starts_fc612a2':
    return this.adminText('workflowsAll.starts_fc612a2', 'Starts')
  case 'workflowsAll.ends_91856dc':
    return this.adminText('workflowsAll.ends_91856dc', 'Ends')
  case 'workflowsAll.hall_a3b092b':
    return this.adminText('workflowsAll.hall_a3b092b', 'Hall')
  case 'workflowsAll.add_break_fe87b9f':
    return this.adminText('workflowsAll.add_break_fe87b9f', 'Add break')
  case 'workflowsAll.attendees_078705a':
    return this.adminText('workflowsAll.attendees_078705a', 'attendees')
  case 'workflowsAll.export_workshop_attendees_csv_3c11298':
    return this.adminText('workflowsAll.export_workshop_attendees_csv_3c11298', 'Export workshop attendees - CSV')
  case 'workflowsAll.export_workshop_attendees_excel_801a823':
    return this.adminText('workflowsAll.export_workshop_attendees_excel_801a823', 'Export workshop attendees - EXCEL')
  case 'workflowsAll.attendees_a45a096':
    return this.adminText('workflowsAll.attendees_a45a096', 'Attendees')
  case 'workflowsAll.you_currently_have_no_attendees_for_this_work_b4c04a7':
    return this.adminText('workflowsAll.you_currently_have_no_attendees_for_this_work_b4c04a7', 'You currently have no attendees for this workshop')
  case 'workflowsAll.are_you_sure_you_want_to_remove_attendee_from_f614506':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_remove_attendee_from_f614506', 'Are you sure you want to remove attendee from this workshop? This operation cannot be undone.')
  case 'workflowsAll.remove_attendee_0882d81':
    return this.adminText('workflowsAll.remove_attendee_0882d81', 'Remove attendee')
  case 'workflowsAll.feedback_ef15f48':
    return this.adminText('workflowsAll.feedback_ef15f48', 'feedback')
  case 'workflowsAll.review_attendee_ratings_and_feedback_to_under_f335c6d':
    return this.adminText('workflowsAll.review_attendee_ratings_and_feedback_to_under_f335c6d', 'Review attendee ratings and feedback to understand how the session was received and identify opportunities for improvement.')
  case 'workflowsAll.reviews_b83c4cd':
    return this.adminText('workflowsAll.reviews_b83c4cd', 'Reviews')
  case 'workflowsAll.workshop_name_5397223':
    return this.adminText('workflowsAll.workshop_name_5397223', 'Workshop name')
  case 'workflowsAll.lecturers_34e6562':
    return this.adminText('workflowsAll.lecturers_34e6562', 'Lecturers')
  case 'workflowsAll.start_typing_attendee_name_8b03f2c':
    return this.adminText('workflowsAll.start_typing_attendee_name_8b03f2c', 'Start typing attendee name...')
  case 'workflowsAll.no_data_d802d23':
    return this.adminText('workflowsAll.no_data_d802d23', 'No data')
  case 'workflowsAll.workshops_s_attendance_is_unlimited_ef10178':
    return this.adminText('workflowsAll.workshops_s_attendance_is_unlimited_ef10178', 'Workshops\'s attendance is unlimited')
  case 'workflowsAll.get_feedback_from_the_conference_app_2ed7548':
    return this.adminText('workflowsAll.get_feedback_from_the_conference_app_2ed7548', 'Get feedback from the conference app')
  case 'workflowsAll.see_all_the_feedback_2c5dd2a':
    return this.adminText('workflowsAll.see_all_the_feedback_2c5dd2a', 'See all the feedback')
  case 'workflowsAll.regular_4ff1814':
    return this.adminText('workflowsAll.regular_4ff1814', 'Regular')
  case 'workflowsAll.booked_tickets_88e434c':
    return this.adminText('workflowsAll.booked_tickets_88e434c', 'Booked tickets')
  case 'workflowsAll.available_tickets_3d70760':
    return this.adminText('workflowsAll.available_tickets_3d70760', 'Available tickets')
  case 'workflowsAll.table_details_820ea2c':
    return this.adminText('workflowsAll.table_details_820ea2c', 'Table details')
  case 'workflowsAll.parter_details_4ee9960':
    return this.adminText('workflowsAll.parter_details_4ee9960', 'Parter details')
  case 'workflowsAll.seat_details_a69b6fa':
    return this.adminText('workflowsAll.seat_details_a69b6fa', 'Seat details')
  case 'workflowsAll.to_finalize_the_order_select_a_payment_method_4db8533':
    return this.adminText('workflowsAll.to_finalize_the_order_select_a_payment_method_4db8533', 'To finalize the order, select a payment method. Email is optional but recommended for event updates.')
  case 'workflowsAll.table_ecd31c8':
    return this.adminText('workflowsAll.table_ecd31c8', 'Table')
  case 'workflowsAll.to_finalize_the_order_select_a_payment_method_e1347a9':
    return this.adminText('workflowsAll.to_finalize_the_order_select_a_payment_method_e1347a9', 'To finalize the order, select a payment method. The organizer requires ticket personalization with each ticket\'s first and last name. Email is optional but recommended for event updates.')
  case 'workflowsAll.field_name':
    return this.adminText('workflowsAll.field_name', 'Name')
  case 'workflowsAll.field_email':
    return this.adminText('workflowsAll.field_email', 'Email')
  case 'workflowsAll.field_member_id_no_':
    return this.adminText('workflowsAll.field_member_id_no_', 'Member ID No.')
  case 'workflowsAll.field_membership':
    return this.adminText('workflowsAll.field_membership', 'Membership')
  case 'workflowsAll.field_created':
    return this.adminText('workflowsAll.field_created', 'Created')
  case 'workflowsAll.field_expires':
    return this.adminText('workflowsAll.field_expires', 'Expires')
  case 'workflowsAll.field_plan':
    return this.adminText('workflowsAll.field_plan', 'Plan')
  case 'workflowsAll.field_duration':
    return this.adminText('workflowsAll.field_duration', 'Duration')
  case 'workflowsAll.field_code':
    return this.adminText('workflowsAll.field_code', 'Code')
  case 'workflowsAll.field_plan_name':
    return this.adminText('workflowsAll.field_plan_name', 'Plan name')
  case 'workflowsAll.field_event_name':
    return this.adminText('workflowsAll.field_event_name', 'Event name')
  case 'workflowsAll.field_date':
    return this.adminText('workflowsAll.field_date', 'Date')
  case 'workflowsAll.field_ticket_name':
    return this.adminText('workflowsAll.field_ticket_name', 'Ticket name')
  case 'workflowsAll.field_sold_quantity':
    return this.adminText('workflowsAll.field_sold_quantity', 'Sold quantity')
  case 'workflowsAll.field_discount':
    return this.adminText('workflowsAll.field_discount', 'Discount')
  case 'workflowsAll.field_start_date':
    return this.adminText('workflowsAll.field_start_date', 'Start date')
  case 'workflowsAll.field_end_date':
    return this.adminText('workflowsAll.field_end_date', 'End date')
  case 'workflowsAll.field_season':
    return this.adminText('workflowsAll.field_season', 'Season')
  case 'workflowsAll.field_subscription_plan':
    return this.adminText('workflowsAll.field_subscription_plan', 'Subscription Plan')
  case 'workflowsAll.field_package_plan':
    return this.adminText('workflowsAll.field_package_plan', 'Package Plan')
  case 'workflowsAll.field_package_status':
    return this.adminText('workflowsAll.field_package_status', 'Package status')
  case 'workflowsAll.field_ticket_category_name':
    return this.adminText('workflowsAll.field_ticket_category_name', 'Ticket category name')
  case 'workflowsAll.field_color':
    return this.adminText('workflowsAll.field_color', 'Color')
  case 'workflowsAll.field_priority':
    return this.adminText('workflowsAll.field_priority', 'Priority')
  case 'workflowsAll.field_ticket_type':
    return this.adminText('workflowsAll.field_ticket_type', 'Ticket type')
  case 'workflowsAll.field_odeum':
    return this.adminText('workflowsAll.field_odeum', 'Odeum')
  case 'workflowsAll.field_price':
    return this.adminText('workflowsAll.field_price', 'Price')
  case 'workflowsAll.field_e_mail':
    return this.adminText('workflowsAll.field_e_mail', 'E-mail')
  case 'workflowsAll.field_status':
    return this.adminText('workflowsAll.field_status', 'Status')
  case 'workflowsAll.field_type':
    return this.adminText('workflowsAll.field_type', 'Type')
  case 'workflowsAll.field_category':
    return this.adminText('workflowsAll.field_category', 'Category')
  case 'workflowsAll.field_last_name':
    return this.adminText('workflowsAll.field_last_name', 'Last name')
  case 'workflowsAll.expired_9d19c04':
    return this.adminText('workflowsAll.expired_9d19c04', 'Expired')
  case 'workflowsAll.scanned_3cffd14':
    return this.adminText('workflowsAll.scanned_3cffd14', 'Scanned')
  case 'workflowsAll.not_scanned_ed7b58c':
    return this.adminText('workflowsAll.not_scanned_ed7b58c', 'Not scanned')
  case 'workflowsAll.ticket_data_ef19c51':
    return this.adminText('workflowsAll.ticket_data_ef19c51', 'Ticket data')
  case 'workflowsAll.tickets_sold_032746d':
    return this.adminText('workflowsAll.tickets_sold_032746d', 'Tickets sold: ')
  case 'workflowsAll.regular_13e25f1':
    return this.adminText('workflowsAll.regular_13e25f1', '|Regular: ')
  case 'workflowsAll.booked_9ddf9ee':
    return this.adminText('workflowsAll.booked_9ddf9ee', '|Booked: ')
  case 'workflowsAll.with_promo_8859bda':
    return this.adminText('workflowsAll.with_promo_8859bda', '|With Promo: ')
  case 'workflowsAll.in_total_78f1fae':
    return this.adminText('workflowsAll.in_total_78f1fae', '||IN TOTAL: ')
  case 'workflowsAll.gratis_56d7951':
    return this.adminText('workflowsAll.gratis_56d7951', '|Gratis: ')
  case 'workflowsAll.could_not_update_the_skidata_arena_setting_24745e1':
    return this.adminText('workflowsAll.could_not_update_the_skidata_arena_setting_24745e1', 'Could not update the SKIDATA Arena setting.')
  case 'workflowsAll.enabled_55b28e8':
    return this.adminText('workflowsAll.enabled_55b28e8', 'enabled')
  case 'workflowsAll.disabled_57e2379':
    return this.adminText('workflowsAll.disabled_57e2379', 'disabled')
  case 'workflowsAll.must_be_before_end_date_65ba806':
    return this.adminText('workflowsAll.must_be_before_end_date_65ba806', 'Must be before end date.')
  case 'workflowsAll.must_be_after_start_date_efcfa6b':
    return this.adminText('workflowsAll.must_be_after_start_date_efcfa6b', 'Must be after start date.')
  case 'workflowsAll.per_order_min_82dda70':
    return this.adminText('workflowsAll.per_order_min_82dda70', 'Per order min')
  case 'workflowsAll.per_order_max_959bb27':
    return this.adminText('workflowsAll.per_order_max_959bb27', 'Per order max')
  case 'workflowsAll.maximum_of_tickets_a_customer_can_choose_when_39e34b3':
    return this.adminText('workflowsAll.maximum_of_tickets_a_customer_can_choose_when_39e34b3', 'Maximum of tickets a customer can choose when purchasing. Maximum limit can be set to 10.')
  case 'workflowsAll.spremi_promjene_d866cf5':
    return this.adminText('workflowsAll.spremi_promjene_d866cf5', 'SPREMI PROMJENE')
  case 'workflowsAll.membership_is_applied_ce9cff3':
    return this.adminText('workflowsAll.membership_is_applied_ce9cff3', 'Membership is applied.')
  case 'workflowsAll.promo_code_is_applied_134ad40':
    return this.adminText('workflowsAll.promo_code_is_applied_134ad40', 'Promo code is applied.')
  case 'workflowsAll.access_code_is_applied_11d60f0':
    return this.adminText('workflowsAll.access_code_is_applied_11d60f0', 'Access code is applied.')
  case 'workflowsAll.subscription_f2250c2':
    return this.adminText('workflowsAll.subscription_f2250c2', 'Subscription')
  case 'workflowsAll.is_applied_7a32b6b':
    return this.adminText('workflowsAll.is_applied_7a32b6b', 'is applied.')
  case 'workflowsAll.remove_bd5d9aa':
    return this.adminText('workflowsAll.remove_bd5d9aa', 'REMOVE')
  case 'workflowsAll.nedostupno_vec_iskoristeno_b15979c':
    return this.adminText('workflowsAll.nedostupno_vec_iskoristeno_b15979c', 'Nedostupno, već iskorišteno:')
  case 'workflowsAll.customer_invitePageLinkDescription':
    return this.adminText('workflowsAll.customer_invitePageLinkDescription', 'The provided link allows users to directly access the ticket purchase page.')
  case 'workflowsAll.customer_invitePageQrCodeDescription':
    return this.adminText('workflowsAll.customer_invitePageQrCodeDescription', 'Download the QR code that leads to ticket purchase and place it on your poster.')
  case 'workflowsAll.customer_createEmail':
    return this.adminText('workflowsAll.customer_createEmail', 'Create e-mail')
  case 'workflowsAll.customer_ticketQuantityError':
    return this.adminText('workflowsAll.customer_ticketQuantityError', 'The amount of tickets made is less than the number of places it connects to! Please increase the amount of the selected ticket or choose a smaller amount of seats.')
  case 'workflowsAll.customer_downloadTickets':
    return this.adminText('workflowsAll.customer_downloadTickets', 'Download tickets')
  case 'workflowsAll.customer_buyATicket':
    return this.adminText('workflowsAll.customer_buyATicket', 'Buy a ticket')
  case 'workflowsAll.customer_eventCanceled':
    return this.adminText('workflowsAll.customer_eventCanceled', 'Event canceled')
  case 'workflowsAll.customer_ticketSoldOut':
    return this.adminText('workflowsAll.customer_ticketSoldOut', 'Tickets are sold out.')
  case 'workflowsAll.customer_ticketUnavailable':
    return this.adminText('workflowsAll.customer_ticketUnavailable', 'Tickets are currently not available')
  case 'workflowsAll.customer_eventCanceledDescription':
    return this.adminText('workflowsAll.customer_eventCanceledDescription', 'For tickets purchased through the webshop, you will receive an automatic refund.')
  case 'workflowsAll.customer_ticketSoldOutDescription':
    return this.adminText('workflowsAll.customer_ticketSoldOutDescription', 'Unfortunately, all tickets for this event are sold out.')
  case 'workflowsAll.customer_ticketUnavailableDescription':
    return this.adminText('workflowsAll.customer_ticketUnavailableDescription', 'For information about ticket availability, please contact the event organizer.')
  case 'workflowsAll.customer_requiredSeatError':
    return this.adminText('workflowsAll.customer_requiredSeatError', 'Please select neighboring locations. It is not allowed to leave it blank.')
  case 'workflowsAll.customer_chooseMinimum':
    return this.adminText('workflowsAll.customer_chooseMinimum', 'Choose minimum')
  case 'workflowsAll.customer_tickets1':
    return this.adminText('workflowsAll.customer_tickets1', 'tickets')
  case 'workflowsAll.customer_tickets2':
    return this.adminText('workflowsAll.customer_tickets2', 'tickets')
  case 'workflowsAll.customer_seatMaxLimitReached':
    return this.adminText('workflowsAll.customer_seatMaxLimitReached', 'Maximum number of tickets for this ticket type has been reached.')
  case 'workflowsAll.customer_buyATicketZkm':
    return this.adminText('workflowsAll.customer_buyATicketZkm', 'Buy a ticket')
  case 'workflowsAll.customer_backToEvent':
    return this.adminText('workflowsAll.customer_backToEvent', 'Back to Event')
  case 'workflowsAll.customer_chooseTicketCategory':
    return this.adminText('workflowsAll.customer_chooseTicketCategory', 'Choose ticket category')
  case 'workflowsAll.customer_remainingSeats':
    return this.adminText('workflowsAll.customer_remainingSeats', 'Remaining seats:')
  case 'workflowsAll.customer_accessibleTicketInfo':
    return this.adminText('workflowsAll.customer_accessibleTicketInfo', 'If you need additional accommodation or more flexibility, feel free to contact the organizer directly by phone or e-mail to make a reservation.')
  case 'workflowsAll.customer_selectLocation':
    return this.adminText('workflowsAll.customer_selectLocation', 'Select location')
  case 'workflowsAll.customer_bundleOfferChooseMore':
    return this.adminText('workflowsAll.customer_bundleOfferChooseMore', 'Choose')
  case 'workflowsAll.customer_unavailableSeat':
    return this.adminText('workflowsAll.customer_unavailableSeat', 'Unavailable seat')
  case 'workflowsAll.customer_unavailable':
    return this.adminText('workflowsAll.customer_unavailable', 'Unavailable')
  case 'workflowsAll.customer_selectedSeat':
    return this.adminText('workflowsAll.customer_selectedSeat', 'Selected seat')
  case 'workflowsAll.customer_selected':
    return this.adminText('workflowsAll.customer_selected', 'Selected')
  case 'workflowsAll.customer_unselectedSector':
    return this.adminText('workflowsAll.customer_unselectedSector', 'Unselected sector')
  case 'workflowsAll.customer_ticketTypes':
    return this.adminText('workflowsAll.customer_ticketTypes', 'Ticket types')
  case 'workflowsAll.customer_tableNumber':
    return this.adminText('workflowsAll.customer_tableNumber', 'Table number')
  case 'workflowsAll.customer_capacity':
    return this.adminText('workflowsAll.customer_capacity', 'Capacity')
  case 'workflowsAll.customer_section':
    return this.adminText('workflowsAll.customer_section', 'Section')
  case 'workflowsAll.customer_row':
    return this.adminText('workflowsAll.customer_row', 'Row')
  case 'workflowsAll.customer_seat':
    return this.adminText('workflowsAll.customer_seat', 'Seat')
  case 'workflowsAll.customer_details':
    return this.adminText('workflowsAll.customer_details', 'Details')
  case 'workflowsAll.customer_readLess':
    return this.adminText('workflowsAll.customer_readLess', 'READ LESS')
  case 'workflowsAll.customer_readMore':
    return this.adminText('workflowsAll.customer_readMore', 'READ MORE')
  case 'workflowsAll.customer_escortQuestion':
    return this.adminText('workflowsAll.customer_escortQuestion', 'Will you have an escort (a person accompanying you)?')
  case 'workflowsAll.customer_escortYes':
    return this.adminText('workflowsAll.customer_escortYes', 'Yes')
  case 'workflowsAll.customer_escortNo':
    return this.adminText('workflowsAll.customer_escortNo', 'No')
  case 'workflowsAll.customer_close':
    return this.adminText('workflowsAll.customer_close', 'Close')
  case 'workflowsAll.customer_cancel':
    return this.adminText('workflowsAll.customer_cancel', 'Cancel')
  case 'workflowsAll.customer_addedToCart':
    return this.adminText('workflowsAll.customer_addedToCart', 'Added to cart')
  case 'workflowsAll.customer_add':
    return this.adminText('workflowsAll.customer_add', 'Add')
  case 'workflowsAll.customer_sharedTableChoosePackage':
    return this.adminText('workflowsAll.customer_sharedTableChoosePackage', 'Choose one of the available table packages.')
  case 'workflowsAll.customer_sharedTableNoAvailablePackages':
    return this.adminText('workflowsAll.customer_sharedTableNoAvailablePackages', 'There are currently no available packages for this table.')
  case 'workflowsAll.customer_sharedTableTicketSingular':
    return this.adminText('workflowsAll.customer_sharedTableTicketSingular', 'ticket')
  case 'workflowsAll.customer_sharedTableTicketPlural':
    return this.adminText('workflowsAll.customer_sharedTableTicketPlural', 'tickets')
  case 'workflowsAll.customer_disableSportMembershipTicket':
    return this.adminText('workflowsAll.customer_disableSportMembershipTicket', 'For members')
  case 'workflowsAll.customer_cinehillPackageNoTicketsRemaining':
    return this.adminText('workflowsAll.customer_cinehillPackageNoTicketsRemaining', 'All tickets from this promo code have already been redeemed.')
  case 'workflowsAll.customer_insertPromoCode':
    return this.adminText('workflowsAll.customer_insertPromoCode', 'Enter promo code (optional)')
  case 'workflowsAll.customer_activate':
    return this.adminText('workflowsAll.customer_activate', 'activate')
  case 'workflowsAll.date_e1a56a6':
    return this.adminText('workflowsAll.date_e1a56a6', 'date')
  case 'workflowsAll.month_ce7005f':
    return this.adminText('workflowsAll.month_ce7005f', 'month')
  case 'workflowsAll.year_adc467d':
    return this.adminText('workflowsAll.year_adc467d', 'year')
  case 'workflowsAll.today_470358f':
    return this.adminText('workflowsAll.today_470358f', 'Today')
  case 'workflowsAll.yesterday_35aa466':
    return this.adminText('workflowsAll.yesterday_35aa466', 'Yesterday')
  case 'workflowsAll.other_date_ddb46c5':
    return this.adminText('workflowsAll.other_date_ddb46c5', 'Other date')
  case 'workflowsAll.this_month_3e2ca9c':
    return this.adminText('workflowsAll.this_month_3e2ca9c', 'This month')
  case 'workflowsAll.last_month_5b5de11':
    return this.adminText('workflowsAll.last_month_5b5de11', 'Last month')
  case 'workflowsAll.other_month_6d9979a':
    return this.adminText('workflowsAll.other_month_6d9979a', 'Other month')
  case 'workflowsAll.this_year_683a2d9':
    return this.adminText('workflowsAll.this_year_683a2d9', 'This year')
  case 'workflowsAll.last_year_5f6fc8f':
    return this.adminText('workflowsAll.last_year_5f6fc8f', 'Last year')
  case 'workflowsAll.other_year_6611b32':
    return this.adminText('workflowsAll.other_year_6611b32', 'Other year')
  case 'workflowsAll.select_a_month_474efd2':
    return this.adminText('workflowsAll.select_a_month_474efd2', 'Select a month')
  case 'workflowsAll.select_a_year_5d9a021':
    return this.adminText('workflowsAll.select_a_year_5d9a021', 'Select a year')
  case 'workflowsAll.cash_fac448c':
    return this.adminText('workflowsAll.cash_fac448c', 'Cash')
  case 'workflowsAll.card_158096b':
    return this.adminText('workflowsAll.card_158096b', 'Card')
  case 'workflowsAll.other_e08d9ea':
    return this.adminText('workflowsAll.other_e08d9ea', 'Other')
  case 'workflowsAll.cash_20_popusta_2394f3f':
    return this.adminText('workflowsAll.cash_20_popusta_2394f3f', 'Cash - 20% popusta')
  case 'workflowsAll.card_20_popusta_e0ab2a1':
    return this.adminText('workflowsAll.card_20_popusta_e0ab2a1', 'Card - 20% popusta')
  case 'workflowsAll.cash_50_popusta_8775261':
    return this.adminText('workflowsAll.cash_50_popusta_8775261', 'Cash - 50% popusta')
  case 'workflowsAll.card_50_popusta_7914648':
    return this.adminText('workflowsAll.card_50_popusta_7914648', 'Card - 50% popusta')
  case 'workflowsAll.keks_10_2253461':
    return this.adminText('workflowsAll.keks_10_2253461', 'KEKS - 10%')
  case 'workflowsAll.popust_20_a38f39e':
    return this.adminText('workflowsAll.popust_20_a38f39e', 'Popust 20%')
  case 'workflowsAll.telegram_20_f7c5dcc':
    return this.adminText('workflowsAll.telegram_20_f7c5dcc', 'TELEGRAM - 20%')
  case 'workflowsAll.popust_40_7df37df':
    return this.adminText('workflowsAll.popust_40_7df37df', 'Popust 40%')
  case 'workflowsAll.popust_50_eeece1c':
    return this.adminText('workflowsAll.popust_50_eeece1c', 'Popust 50%')
  case 'workflowsAll.promo_code_has_already_been_used_e132537':
    return this.adminText('workflowsAll.promo_code_has_already_been_used_e132537', 'Promo code has already been used!')
  case 'workflowsAll.promo_code_is_outdated_bc2862e':
    return this.adminText('workflowsAll.promo_code_is_outdated_bc2862e', 'Promo code is outdated!')
  case 'workflowsAll.new_attendee_field_a78bce4':
    return this.adminText('workflowsAll.new_attendee_field_a78bce4', 'New attendee field')
  case 'workflowsAll.update_attendee_field_591e724':
    return this.adminText('workflowsAll.update_attendee_field_591e724', 'Update attendee field')
  case 'workflowsAll.add_sponsors_aa09d70':
    return this.adminText('workflowsAll.add_sponsors_aa09d70', 'Add sponsors')
  case 'workflowsAll.update_sponsor_50b5dce':
    return this.adminText('workflowsAll.update_sponsor_50b5dce', 'Update sponsor')
  case 'workflowsAll.standing_3f31ee4':
    return this.adminText('workflowsAll.standing_3f31ee4', 'Standing')
  case 'workflowsAll.maximum_of_tickets_a_customer_can_choose_when_7c341ec':
    return this.adminText('workflowsAll.maximum_of_tickets_a_customer_can_choose_when_7c341ec', 'Maximum of tickets a customer can choose when purchasing.')
  case 'workflowsAll.maximum_limit_can_be_set_to_10_a920146':
    return this.adminText('workflowsAll.maximum_limit_can_be_set_to_10_a920146', ' Maximum limit can be set to 10.')
  case 'workflowsAll.this_ticket_is_excluded_from_the_floor_plan_c687b5c':
    return this.adminText('workflowsAll.this_ticket_is_excluded_from_the_floor_plan_c687b5c', 'This ticket is excluded from the floor plan')
  case 'workflowsAll.and_will_appear_only_as_an_additional_ticket__e2672c1':
    return this.adminText('workflowsAll.and_will_appear_only_as_an_additional_ticket__e2672c1', 'and will appear only as an additional ticket option.')
  case 'workflowsAll.this_ticket_will_only_be_visible_to_users_who_c81ecde':
    return this.adminText('workflowsAll.this_ticket_will_only_be_visible_to_users_who_c81ecde', 'This ticket will only be visible to users who enter the correct access code.')
  case 'workflowsAll.availability_is_limited_to_sales_through_the__91a5c4e':
    return this.adminText('workflowsAll.availability_is_limited_to_sales_through_the__91a5c4e', 'Availability is limited to sales through the CoreEvent webshop.')
  case 'workflowsAll.enable_skidata_arena_for_this_event_eb993d3':
    return this.adminText('workflowsAll.enable_skidata_arena_for_this_event_eb993d3', 'Enable SKIDATA Arena for this event?')
  case 'workflowsAll.disable_skidata_arena_9338161':
    return this.adminText('workflowsAll.disable_skidata_arena_9338161', 'Disable SKIDATA Arena?')
  case 'workflowsAll.this_immediately_queues_an_initial_resync_exi_ade1373':
    return this.adminText('workflowsAll.this_immediately_queues_an_initial_resync_exi_ade1373', 'This immediately queues an initial resync. Existing eligible tickets may be sent to SKIDATA.')
  case 'workflowsAll.disabling_can_be_rejected_after_a_successful__0809b58':
    return this.adminText('workflowsAll.disabling_can_be_rejected_after_a_successful__0809b58', 'Disabling can be rejected after a successful remote sync until Arena cleanup is confirmed.')
  case 'workflowsAll.enable_skidata_b32fcb1':
    return this.adminText('workflowsAll.enable_skidata_b32fcb1', 'Enable SKIDATA')
  case 'workflowsAll.disable_skidata_946c857':
    return this.adminText('workflowsAll.disable_skidata_946c857', 'Disable SKIDATA')
  case 'workflowsAll.create_a_new_password_30ebd65':
    return this.adminText('workflowsAll.create_a_new_password_30ebd65', 'Create a new Password')
  case 'workflowsAll.access_for_this_performance_has_already_been__42ac991':
    return this.adminText('workflowsAll.access_for_this_performance_has_already_been__42ac991', 'Access for this performance has already been removed.')
  case 'workflowsAll.access_can_only_be_removed_while_the_accredit_d47d436':
    return this.adminText('workflowsAll.access_can_only_be_removed_while_the_accredit_d47d436', 'Access can only be removed while the accreditation is active.')
  case 'workflowsAll.access_cannot_be_removed_after_the_performanc_8c5edf8':
    return this.adminText('workflowsAll.access_cannot_be_removed_after_the_performanc_8c5edf8', 'Access cannot be removed after the performance has ended.')
  case 'workflowsAll.access_revoked_cf70976':
    return this.adminText('workflowsAll.access_revoked_cf70976', 'Access revoked')
  case 'workflowsAll.revoke_access_4230a95':
    return this.adminText('workflowsAll.revoke_access_4230a95', 'Revoke access')
  case 'workflowsAll.filters_c4614aa':
    return this.adminText('workflowsAll.filters_c4614aa', 'Filters')
  case 'workflowsAll.1_filter_eca49d9':
    return this.adminText('workflowsAll.1_filter_eca49d9', '1 Filter')
  case 'workflowsAll.event_details_saved_and_will_be_live_in_20_mi_fafed0f':
    return this.adminText('workflowsAll.event_details_saved_and_will_be_live_in_20_mi_fafed0f', 'Event details saved and will be live in 20 minutes.')
  case 'workflowsAll.event_details_saved_7e804fe':
    return this.adminText('workflowsAll.event_details_saved_7e804fe', 'Event details saved.')
  case 'workflowsAll.minimum_value_is_0_a8f2787':
    return this.adminText('workflowsAll.minimum_value_is_0_a8f2787', 'Minimum value is 0.')
  case 'workflowsAll.minimum_value_is_1_c0195ad':
    return this.adminText('workflowsAll.minimum_value_is_1_c0195ad', 'Minimum value is 1.')
  case 'workflowsAll.maximum_value_is_10_8206df3':
    return this.adminText('workflowsAll.maximum_value_is_10_8206df3', 'Maximum value is 10.')
  case 'workflowsAll.min_must_be_lower_than_or_equal_to_max_413910d':
    return this.adminText('workflowsAll.min_must_be_lower_than_or_equal_to_max_413910d', 'Min must be lower than or equal to max.')
  case 'workflowsAll.max_must_be_greater_than_or_equal_to_min_8852fa8':
    return this.adminText('workflowsAll.max_must_be_greater_than_or_equal_to_min_8852fa8', 'Max must be greater than or equal to min.')
  case 'workflowsAll.end_date_must_be_after_start_date_f5bdfd1':
    return this.adminText('workflowsAll.end_date_must_be_after_start_date_f5bdfd1', 'End date must be after start date.')
  case 'workflowsAll.all_halls_6a9fe6f':
    return this.adminText('workflowsAll.all_halls_6a9fe6f', 'All halls')
  case 'workflowsAll.request_a_refund_db34663':
    return this.adminText('workflowsAll.request_a_refund_db34663', 'REQUEST A REFUND')
  case 'workflowsAll.make_a_refund_481dd29':
    return this.adminText('workflowsAll.make_a_refund_481dd29', 'MAKE A REFUND')
  case 'workflowsAll.refund_requested_76b1f27':
    return this.adminText('workflowsAll.refund_requested_76b1f27', 'REFUND REQUESTED')
  case 'workflowsAll.please_add_the_subscriber_s_name_and_email_so_c145896':
    return this.adminText('workflowsAll.please_add_the_subscriber_s_name_and_email_so_c145896', 'Please add the subscriber’s name and email so the user knows which subscription the response is for.')
  case 'workflowsAll.this_field_should_be_between_1_and_10_128340b':
    return this.adminText('workflowsAll.this_field_should_be_between_1_and_10_128340b', 'This field should be between 1 and 10')
  case 'workflowsAll.this_field_is_required_2ab7886':
    return this.adminText('workflowsAll.this_field_is_required_2ab7886', 'This field is required.')
  case 'workflowsAll.title_is_limited_to_120_characters_426459b':
    return this.adminText('workflowsAll.title_is_limited_to_120_characters_426459b', 'Title is limited to 120 characters.')
  case 'workflowsAll.start_date_must_be_a_future_date_fd9430e':
    return this.adminText('workflowsAll.start_date_must_be_a_future_date_fd9430e', 'Start date must be a future date')
  case 'workflowsAll.start_date_should_be_before_the_end_of_the_ev_ec2ed4d':
    return this.adminText('workflowsAll.start_date_should_be_before_the_end_of_the_ev_ec2ed4d', 'Start date should be before the end of the event')
  case 'workflowsAll.end_date_should_not_be_before_the_start_of_th_019643c':
    return this.adminText('workflowsAll.end_date_should_not_be_before_the_start_of_th_019643c', 'End date should not be before the start of the event')
  case 'workflowsAll.organizer_message_is_limited_to_500_character_e58d15d':
    return this.adminText('workflowsAll.organizer_message_is_limited_to_500_character_e58d15d', 'Organizer message is limited to 500 characters.')
  case 'workflowsAll.value_must_be_positive_number_2a18187':
    return this.adminText('workflowsAll.value_must_be_positive_number_2a18187', 'Value must be positive number.')
  case 'workflowsAll.value_must_be_higher_than_0_2fc081a':
    return this.adminText('workflowsAll.value_must_be_higher_than_0_2fc081a', 'Value must be higher than 0.')
  case 'workflowsAll.you_cannot_add_any_new_tickets_because_total__38330e9':
    return this.adminText('workflowsAll.you_cannot_add_any_new_tickets_because_total__38330e9', 'You cannot add any new tickets because total tickets number already exceeded event capacity.')
  case 'workflowsAll.quantity_must_be_higher_than_0_979e8d5':
    return this.adminText('workflowsAll.quantity_must_be_higher_than_0_979e8d5', 'Quantity must be higher than 0.')
  case 'workflowsAll.name_can_t_be_more_than_170_characters_dacd64a':
    return this.adminText('workflowsAll.name_can_t_be_more_than_170_characters_dacd64a', 'Name can’t be more than 170 characters')
  case 'workflowsAll.price_must_be_higher_than_0_a3c4110':
    return this.adminText('workflowsAll.price_must_be_higher_than_0_a3c4110', 'Price must be higher than 0.')
  case 'workflowsAll.quantity_must_be_bigger_than_number_of_alread_78c69fd':
    return this.adminText('workflowsAll.quantity_must_be_bigger_than_number_of_alread_78c69fd', 'Quantity must be bigger than number of already sold tickets!')
  case 'workflowsAll.access_code_can_only_contain_letters_and_numb_96dc695':
    return this.adminText('workflowsAll.access_code_can_only_contain_letters_and_numb_96dc695', 'Access code can only contain letters and numbers.')
  case 'workflowsAll.access_code_must_be_at_least_4_characters_lon_31f78a5':
    return this.adminText('workflowsAll.access_code_must_be_at_least_4_characters_lon_31f78a5', 'Access code must be at least 4 characters long.')
  case 'workflowsAll.the_access_code_can_be_no_more_than_8_charact_7671b64':
    return this.adminText('workflowsAll.the_access_code_can_be_no_more_than_8_charact_7671b64', 'The access code can be no more than 8 characters long.')
  case 'workflowsAll.end_time_must_be_after_the_start_time_1ea125d':
    return this.adminText('workflowsAll.end_time_must_be_after_the_start_time_1ea125d', 'End time must be after the start time')
  case 'workflowsAll.start_date_must_be_after_the_start_of_the_eve_759b82f':
    return this.adminText('workflowsAll.start_date_must_be_after_the_start_of_the_eve_759b82f', 'Start date must be after the start of the event')
  case 'workflowsAll.start_date_should_be_before_the_end_of_the_ev_806a045':
    return this.adminText('workflowsAll.start_date_should_be_before_the_end_of_the_ev_806a045', 'Start date should be before the end of the event or workshop')
  case 'workflowsAll.end_date_must_be_after_the_start_of_the_event_219ed61':
    return this.adminText('workflowsAll.end_date_must_be_after_the_start_of_the_event_219ed61', 'End date must be after the start of the event or workshop')
  case 'workflowsAll.end_date_must_be_before_the_end_of_the_event_97e993e':
    return this.adminText('workflowsAll.end_date_must_be_before_the_end_of_the_event_97e993e', 'End date must be before the end of the event')
  case 'workflowsAll.maximum_30_characters_allowed_3c36a8f':
    return this.adminText('workflowsAll.maximum_30_characters_allowed_3c36a8f', 'Maximum 30 characters allowed.')
  case 'workflowsAll.enter_at_least_5_characters':
    return this.adminText('workflowsAll.enter_at_least_5_characters', 'Enter at least 5 characters.')
  case 'workflowsAll.enter_at_least_6_characters_bf7b03e':
    return this.adminText('workflowsAll.enter_at_least_6_characters_bf7b03e', 'Enter at least 6 characters.')
  case 'workflowsAll.tickets_130mm_x_74_25mm_f26d393':
    return this.adminText('workflowsAll.tickets_130mm_x_74_25mm_f26d393', 'Tickets (130mm x 74.25mm)')
  case 'workflowsAll.business_card_86mm_x_54mm_5d99b43':
    return this.adminText('workflowsAll.business_card_86mm_x_54mm_5d99b43', 'Business card (86mm x 54mm)')
  case 'workflowsAll.country_code_25fc029':
    return this.adminText('workflowsAll.country_code_25fc029', 'Country code')
  case 'workflowsAll.upisite_promo_kod_a8f66cc':
    return this.adminText('workflowsAll.upisite_promo_kod_a8f66cc', 'Upišite promo kod')
  case 'workflowsAll.molimo_obavezno_navedite_email_0c30239':
    return this.adminText('workflowsAll.molimo_obavezno_navedite_email_0c30239', 'Molimo obavezno navedite email')
  case 'workflowsAll.this_field_must_be_an_email_ededd72':
    return this.adminText('workflowsAll.this_field_must_be_an_email_ededd72', 'This field must be an email')
  case 'workflowsAll.ovo_polje_je_obavezno_e25488b':
    return this.adminText('workflowsAll.ovo_polje_je_obavezno_e25488b', 'Ovo polje je obavezno')
  case 'workflowsAll.this_field_is_required_8aa9bf0':
    return this.adminText('workflowsAll.this_field_is_required_8aa9bf0', 'This field is required')
  case 'workflowsAll.molimo_skratite_naziv_na_32_znakova_npr_minis_a92b099':
    return this.adminText('workflowsAll.molimo_skratite_naziv_na_32_znakova_npr_minis_a92b099', 'Molimo skratite naziv na 32 znakova (npr. Ministarstvo regionalnog razvoja i fondova Europske unije upisati kao MRRFEU).')
  case 'workflowsAll.this_field_should_contain_less_values_f6d7a59':
    return this.adminText('workflowsAll.this_field_should_contain_less_values_f6d7a59', 'This field should contain less values')
  case 'workflowsAll.canceled_d96e4ff':
    return this.adminText('workflowsAll.canceled_d96e4ff', 'Canceled')
  case 'workflowsAll.sales_closed_49ddcd4':
    return this.adminText('workflowsAll.sales_closed_49ddcd4', 'Sales closed')
  case 'workflowsAll.tickets_sent_successfully_2778e08':
    return this.adminText('workflowsAll.tickets_sent_successfully_2778e08', 'Tickets sent successfully.')
  case 'workflowsAll.ticket_sent_successfully_309afda':
    return this.adminText('workflowsAll.ticket_sent_successfully_309afda', 'Ticket sent successfully.')
  case 'workflowsAll.we_have_sent_you_an_email_with_your_accredita_83f8889':
    return this.adminText('workflowsAll.we_have_sent_you_an_email_with_your_accredita_83f8889', 'We have sent you an email with your accreditations')
  case 'workflowsAll.order_cancelled_successfully_5d1b522':
    return this.adminText('workflowsAll.order_cancelled_successfully_5d1b522', 'Order cancelled successfully.')
  case 'workflowsAll.accreditation_updated_successfully_c1ef348':
    return this.adminText('workflowsAll.accreditation_updated_successfully_c1ef348', 'Accreditation updated successfully.')
  case 'workflowsAll.unable_to_update_accreditation_d38672e':
    return this.adminText('workflowsAll.unable_to_update_accreditation_d38672e', 'Unable to update accreditation.')
  case 'workflowsAll.please_fill_in_all_required_ticket_owner_fiel_05c2f36':
    return this.adminText('workflowsAll.please_fill_in_all_required_ticket_owner_fiel_05c2f36', 'Please fill in all required ticket owner fields.')
  case 'workflowsAll.ticket_owners_updated_successfully_8fc6889':
    return this.adminText('workflowsAll.ticket_owners_updated_successfully_8fc6889', 'Ticket owners updated successfully.')
  case 'workflowsAll.unable_to_update_ticket_owners_271a889':
    return this.adminText('workflowsAll.unable_to_update_ticket_owners_271a889', 'Unable to update ticket owners.')
  case 'workflowsAll.unable_to_cancel_order_c6b0d92':
    return this.adminText('workflowsAll.unable_to_cancel_order_c6b0d92', 'Unable to cancel order.')
  case 'workflowsAll.unable_to_load_accreditation_details_cb8fb00':
    return this.adminText('workflowsAll.unable_to_load_accreditation_details_cb8fb00', 'Unable to load accreditation details.')
  case 'workflowsAll.unable_to_load_accreditation_order_details_26a5d30':
    return this.adminText('workflowsAll.unable_to_load_accreditation_order_details_26a5d30', 'Unable to load accreditation order details.')
  case 'workflowsAll.unable_to_download_subscription_pass_8298151':
    return this.adminText('workflowsAll.unable_to_download_subscription_pass_8298151', 'Unable to download subscription pass.')
  case 'workflowsAll.subscription_pass_sent_successfully_9aa993d':
    return this.adminText('workflowsAll.subscription_pass_sent_successfully_9aa993d', 'Subscription pass sent successfully.')
  case 'workflowsAll.unable_to_send_subscription_pass_fe7efbf':
    return this.adminText('workflowsAll.unable_to_send_subscription_pass_fe7efbf', 'Unable to send subscription pass.')
  case 'workflowsAll.access_for_the_selected_performance_has_been__3cafe56':
    return this.adminText('workflowsAll.access_for_the_selected_performance_has_been__3cafe56', 'Access for the selected performance has been removed.')
  case 'workflowsAll.unable_to_remove_access_4e5c97c':
    return this.adminText('workflowsAll.unable_to_remove_access_4e5c97c', 'Unable to remove access.')
  case 'workflowsAll.unable_to_load_subscription_pass_details_a331446':
    return this.adminText('workflowsAll.unable_to_load_subscription_pass_details_a331446', 'Unable to load subscription pass details.')
  case 'workflowsAll.select_ticket_before_sending_27cc812':
    return this.adminText('workflowsAll.select_ticket_before_sending_27cc812', 'Select ticket before sending.')
  case 'workflowsAll.the_selected_subscriber_is_unavailable_for_me_6add57a':
    return this.adminText('workflowsAll.the_selected_subscriber_is_unavailable_for_me_6add57a', 'The selected subscriber is unavailable for messaging.')
  case 'workflowsAll.subscribers_could_not_be_loaded_refresh_the_p_5046800':
    return this.adminText('workflowsAll.subscribers_could_not_be_loaded_refresh_the_p_5046800', 'Subscribers could not be loaded. Refresh the page and try again.')
  case 'workflowsAll.failed_to_generate_payout_documents_04e5c40':
    return this.adminText('workflowsAll.failed_to_generate_payout_documents_04e5c40', 'Failed to generate payout documents.')
  case 'workflowsAll.failed_to_download_invoice_1b5173f':
    return this.adminText('workflowsAll.failed_to_download_invoice_1b5173f', 'Failed to download invoice.')
  case 'workflowsAll.delete_successful_49bdd4c':
    return this.adminText('workflowsAll.delete_successful_49bdd4c', 'Delete successful')
  case 'workflowsAll.unable_to_load_city_sales_data_at_the_moment_b3724d9':
    return this.adminText('workflowsAll.unable_to_load_city_sales_data_at_the_moment_b3724d9', 'Unable to load city sales data at the moment.')
  case 'workflowsAll.oops_something_went_wrong_try_again_later_or__3450c90':
    return this.adminText('workflowsAll.oops_something_went_wrong_try_again_later_or__3450c90', 'Oops, something went wrong! Try again later, or contact the administration.')
  case 'workflowsAll.oops_your_purchase_failed_try_again_later_or__33e6cf6':
    return this.adminText('workflowsAll.oops_your_purchase_failed_try_again_later_or__33e6cf6', 'Oops, your purchase failed! Try again later, or contact the administration.')
  case 'workflowsAll.purchase_failed_not_enough_tickets_available__b5a264e':
    return this.adminText('workflowsAll.purchase_failed_not_enough_tickets_available__b5a264e', 'Purchase failed. Not enough tickets available to finish the purchase.')
  case 'workflowsAll.owner_first_name_is_required_b467815':
    return this.adminText('workflowsAll.owner_first_name_is_required_b467815', 'Owner first name is required.')
  case 'workflowsAll.owner_last_name_is_required_95e1d22':
    return this.adminText('workflowsAll.owner_last_name_is_required_95e1d22', 'Owner last name is required.')
  case 'workflowsAll.owner_email_is_required_242f423':
    return this.adminText('workflowsAll.owner_email_is_required_242f423', 'Owner email is required.')
  case 'workflowsAll.enter_a_valid_email_address_e2cf2c9':
    return this.adminText('workflowsAll.enter_a_valid_email_address_e2cf2c9', 'Enter a valid email address.')
  case 'workflowsAll.sponsor_saved_f889f5e':
    return this.adminText('workflowsAll.sponsor_saved_f889f5e', 'Sponsor saved')
  case 'workflowsAll.sponsor_deleted_71f56c0':
    return this.adminText('workflowsAll.sponsor_deleted_71f56c0', 'Sponsor deleted')
  case 'workflowsAll.are_you_sure_you_want_to_delete_this_translat_e9f69a9':
    return this.adminText('workflowsAll.are_you_sure_you_want_to_delete_this_translat_e9f69a9', 'Are you sure you want to delete this translation?')
  case 'workflowsAll.all_performances_8787585':
    return this.adminText('workflowsAll.all_performances_8787585', 'All performances')
  case 'workflowsAll.standing_ticket_449e418':
    return this.adminText('workflowsAll.standing_ticket_449e418', 'STANDING TICKET')
  case 'workflowsAll.seating_ticket_7447f4a':
    return this.adminText('workflowsAll.seating_ticket_7447f4a', 'SEATING TICKET')
  case 'workflowsAll.table_ticket_14d8a43':
    return this.adminText('workflowsAll.table_ticket_14d8a43', 'TABLE TICKET')
  case 'workflowsAll.all_plans_3d65514':
    return this.adminText('workflowsAll.all_plans_3d65514', 'All plans')
  case 'workflowsAll.this_sponsor_da19fd2':
    return this.adminText('workflowsAll.this_sponsor_da19fd2', 'This sponsor')
  case 'workflowsAll.new_accreditation_05b5013':
    return this.adminText('workflowsAll.new_accreditation_05b5013', 'New Accreditation')
  case 'workflowsAll.new_invitee_ce26347':
    return this.adminText('workflowsAll.new_invitee_ce26347', 'New Invitee')
  case 'workflowsAll.import_invitees_ba49380':
    return this.adminText('workflowsAll.import_invitees_ba49380', 'Import invitees')
  case 'workflowsAll.import_attendees_6d17e83':
    return this.adminText('workflowsAll.import_attendees_6d17e83', 'Import attendees')
  case 'workflowsAll.all_subscribers_1ee3bf4':
    return this.adminText('workflowsAll.all_subscribers_1ee3bf4', 'All subscribers')
  case 'workflowsAll.specific_subscribers_94602d8':
    return this.adminText('workflowsAll.specific_subscribers_94602d8', 'Specific subscribers')
  case 'workflowsAll.required_11893d2':
    return this.adminText('workflowsAll.required_11893d2', '(required)')
  case 'workflowsAll.required_eg_1_2_3_8655fdd':
    return this.adminText('workflowsAll.required_eg_1_2_3_8655fdd', '(required) - eg. 1-2-3')
  case 'workflowsAll.all_97096ee':
    return this.adminText('workflowsAll.all_97096ee', 'All')
  case 'workflowsAll.web_format_2f34443':
    return this.adminText('workflowsAll.web_format_2f34443', 'Web format')
  case 'workflowsAll.ticket_seller_format_827b457':
    return this.adminText('workflowsAll.ticket_seller_format_827b457', 'Ticket seller format')
  case 'workflowsAll.parter_ticket_80b2cda':
    return this.adminText('workflowsAll.parter_ticket_80b2cda', 'Parter ticket')
  case 'workflowsAll.floor_plan_68fa6c5':
    return this.adminText('workflowsAll.floor_plan_68fa6c5', 'Floor Plan')
  case 'workflowsAll.specific_outlets_online_b54bdfd':
    return this.adminText('workflowsAll.specific_outlets_online_b54bdfd', 'Specific Outlets + online')
  case 'workflowsAll.all_outlets_online_4b24c08':
    return this.adminText('workflowsAll.all_outlets_online_4b24c08', 'All Outlets + online')
  case 'workflowsAll.unknown_attendee_e946a3a':
    return this.adminText('workflowsAll.unknown_attendee_e946a3a', 'Unknown attendee')
  case 'workflowsAll.unknown_ticket_b4bcf61':
    return this.adminText('workflowsAll.unknown_ticket_b4bcf61', 'Unknown ticket')
  case 'workflowsAll.free_4455fad':
    return this.adminText('workflowsAll.free_4455fad', 'Free')
  case 'workflowsAll.legacy_first_name':
    return this.adminText('workflowsAll.legacy_first_name', 'Ime')
  case 'workflowsAll.legacy_last_name':
    return this.adminText('workflowsAll.legacy_last_name', 'Prezime')
  case 'workflowsAll.all_events_34f96ca':
    return this.adminText('workflowsAll.all_events_34f96ca', 'All events')
  case 'workflowsAll.all_ticket_types_4b9bb0a':
    return this.adminText('workflowsAll.all_ticket_types_4b9bb0a', 'All ticket types')
  case 'workflowsAll.all_sales_channels_5f8b16d':
    return this.adminText('workflowsAll.all_sales_channels_5f8b16d', 'All sales channels')
  case 'workflowsAll.all_promo_codes_5e02ac5':
    return this.adminText('workflowsAll.all_promo_codes_5e02ac5', 'All promo codes')
  case 'workflowsAll.first_name_35780e2':
    return this.adminText('workflowsAll.first_name_35780e2', 'First name')
  case 'workflowsAll.address_66dd4d4':
    return this.adminText('workflowsAll.address_66dd4d4', 'Address')
  case 'workflowsAll.city_64c5c29':
    return this.adminText('workflowsAll.city_64c5c29', 'City')
  case 'workflowsAll.country_d9d2d25':
    return this.adminText('workflowsAll.country_d9d2d25', 'Country')
  case 'workflowsAll.postal_code_ba4a944':
    return this.adminText('workflowsAll.postal_code_ba4a944', 'Postal code')
  default:
    return value
  }
}

export default {
  mixins: [AdminContext],
  computed: { workflowLocale() { return this.isAdminLocalization ? this.$adminLocale() : null } },
  methods: {
    workflowLabel,
    workflowCustomerLabel(key, params = {}, original) {
      if (!this.isAdminLocalization) return original === undefined ? this.$t(key, params) : original
      switch (key) {
      case 'invitePageLinkDescription':
        return this.adminText('workflowsAll.customer_invitePageLinkDescription', 'The provided link allows users to directly access the ticket purchase page.')
      case 'invitePageQrCodeDescription':
        return this.adminText('workflowsAll.customer_invitePageQrCodeDescription', 'Download the QR code that leads to ticket purchase and place it on your poster.')
      case 'createEmail':
        return this.adminText('workflowsAll.customer_createEmail', 'Create e-mail')
      case 'ticketQuantityError':
        return this.adminText('workflowsAll.customer_ticketQuantityError', 'The amount of tickets made is less than the number of places it connects to! Please increase the amount of the selected ticket or choose a smaller amount of seats.')
      case 'downloadTickets':
        return this.adminText('workflowsAll.customer_downloadTickets', 'Download tickets')
      case 'buyATicket':
        return this.adminText('workflowsAll.customer_buyATicket', 'Buy a ticket')
      case 'eventCanceled':
        return this.adminText('workflowsAll.customer_eventCanceled', 'Event canceled')
      case 'ticketSoldOut':
        return this.adminText('workflowsAll.customer_ticketSoldOut', 'Tickets are sold out.')
      case 'ticketUnavailable':
        return this.adminText('workflowsAll.customer_ticketUnavailable', 'Tickets are currently not available')
      case 'eventCanceledDescription':
        return this.adminText('workflowsAll.customer_eventCanceledDescription', 'For tickets purchased through the webshop, you will receive an automatic refund.')
      case 'ticketSoldOutDescription':
        return this.adminText('workflowsAll.customer_ticketSoldOutDescription', 'Unfortunately, all tickets for this event are sold out.')
      case 'ticketUnavailableDescription':
        return this.adminText('workflowsAll.customer_ticketUnavailableDescription', 'For information about ticket availability, please contact the event organizer.')
      case 'bundleOfferFixExcessGratis':
        return this.adminText('workflowsAll.customer_bundleOfferFixExcessGratis', 'Choose {{count}} more ticket(s) to reactivate the free ticket, or remove the free seat.', { count: params.count })
      case 'bundleOfferChooseMoreGratis':
        return this.adminText('workflowsAll.customer_bundleOfferChooseMoreGratis', 'Choose {{count}} more free ticket(s).', { count: params.count })
      case 'bundleOfferGratisAdded':
        return this.adminText('workflowsAll.customer_bundleOfferGratisAdded', 'You got {{count}} free ticket(s).', { count: params.count })
      case 'requiredSeatError':
        return this.adminText('workflowsAll.customer_requiredSeatError', 'Please select neighboring locations. It is not allowed to leave it blank.')
      case 'chooseMinimum':
        return this.adminText('workflowsAll.customer_chooseMinimum', 'Choose minimum')
      case 'tickets1':
        return this.adminText('workflowsAll.customer_tickets1', 'tickets')
      case 'tickets2':
        return this.adminText('workflowsAll.customer_tickets2', 'tickets')
      case 'seatMaxLimitReached':
        return this.adminText('workflowsAll.customer_seatMaxLimitReached', 'Maximum number of tickets for this ticket type has been reached.')
      case 'buyATicketZkm':
        return this.adminText('workflowsAll.customer_buyATicketZkm', 'Buy a ticket')
      case 'backToEvent':
        return this.adminText('workflowsAll.customer_backToEvent', 'Back to Event')
      case 'chooseTicketCategory':
        return this.adminText('workflowsAll.customer_chooseTicketCategory', 'Choose ticket category')
      case 'chooseFloorPlanTicket':
        return this.adminText('workflowsAll.customer_chooseFloorPlanTicket', 'Choose a ticket')
      case 'allFloorPlanTicketTypes':
        return this.adminText('workflowsAll.customer_allFloorPlanTicketTypes', 'All ticket types')
      case 'floorPlanZoomIn':
        return this.adminText('workflowsAll.customer_floorPlanZoomIn', 'Zoom in')
      case 'floorPlanZoomOut':
        return this.adminText('workflowsAll.customer_floorPlanZoomOut', 'Zoom out')
      case 'floorPlanResetView':
        return this.adminText('workflowsAll.customer_floorPlanResetView', 'Reset view')
      case 'remainingSeats':
        return this.adminText('workflowsAll.customer_remainingSeats', 'Remaining seats:')
      case 'accessibleTicketInfo':
        return this.adminText('workflowsAll.customer_accessibleTicketInfo', 'If you need additional accommodation or more flexibility, feel free to contact the organizer directly by phone or e-mail to make a reservation.')
      case 'selectLocation':
        return this.adminText('workflowsAll.customer_selectLocation', 'Select location')
      case 'bundleOfferChooseMore':
        return this.adminText('workflowsAll.customer_bundleOfferChooseMore', 'Choose')
      case 'bundleOfferChooseMoreGratisCount':
        return this.adminText('workflowsAll.customer_bundleOfferChooseMoreGratisCount', '{{count}} free', { count: params.count })
      case 'unavailableSeat':
        return this.adminText('workflowsAll.customer_unavailableSeat', 'Unavailable seat')
      case 'unavailable':
        return this.adminText('workflowsAll.customer_unavailable', 'Unavailable')
      case 'selectedSeat':
        return this.adminText('workflowsAll.customer_selectedSeat', 'Selected seat')
      case 'selected':
        return this.adminText('workflowsAll.customer_selected', 'Selected')
      case 'unselectedSector':
        return this.adminText('workflowsAll.customer_unselectedSector', 'Unselected sector')
      case 'ticketTypes':
        return this.adminText('workflowsAll.customer_ticketTypes', 'Ticket types')
      case 'tableNumber':
        return this.adminText('workflowsAll.customer_tableNumber', 'Table number')
      case 'capacity':
        return this.adminText('workflowsAll.customer_capacity', 'Capacity')
      case 'section':
        return this.adminText('workflowsAll.customer_section', 'Section')
      case 'row':
        return this.adminText('workflowsAll.customer_row', 'Row')
      case 'seat':
        return this.adminText('workflowsAll.customer_seat', 'Seat')
      case 'details':
        return this.adminText('workflowsAll.customer_details', 'Details')
      case 'readLess':
        return this.adminText('workflowsAll.customer_readLess', 'READ LESS')
      case 'readMore':
        return this.adminText('workflowsAll.customer_readMore', 'READ MORE')
      case 'escortQuestion':
        return this.adminText('workflowsAll.customer_escortQuestion', 'Will you have an escort (a person accompanying you)?')
      case 'escortYes':
        return this.adminText('workflowsAll.customer_escortYes', 'Yes')
      case 'escortNo':
        return this.adminText('workflowsAll.customer_escortNo', 'No')
      case 'close':
        return this.adminText('workflowsAll.customer_close', 'Close')
      case 'cancel':
        return this.adminText('workflowsAll.customer_cancel', 'Cancel')
      case 'addedToCart':
        return this.adminText('workflowsAll.customer_addedToCart', 'Added to cart')
      case 'add':
        return this.adminText('workflowsAll.customer_add', 'Add')
      case 'sharedTableChoosePackage':
        return this.adminText('workflowsAll.customer_sharedTableChoosePackage', 'Choose one of the available table packages.')
      case 'sharedTableNoAvailablePackages':
        return this.adminText('workflowsAll.customer_sharedTableNoAvailablePackages', 'There are currently no available packages for this table.')
      case 'floorPlanHelperMaxOnly':
        return this.adminText('workflowsAll.customer_floorPlanHelperMaxOnly', 'Max. {{max}} tickets', { max: params.max })
      case 'floorPlanHelperRange':
        return this.adminText('workflowsAll.customer_floorPlanHelperRange', 'Choose {{min}}-{{max}} tickets', { min: params.min, max: params.max })
      case 'sharedTableTicketSingular':
        return this.adminText('workflowsAll.customer_sharedTableTicketSingular', 'ticket')
      case 'sharedTableTicketPlural':
        return this.adminText('workflowsAll.customer_sharedTableTicketPlural', 'tickets')
      case 'disableSportMembershipTicket':
        return this.adminText('workflowsAll.customer_disableSportMembershipTicket', 'For members')
      case 'cinehillPackageNoTicketsRemaining':
        return this.adminText('workflowsAll.customer_cinehillPackageNoTicketsRemaining', 'All tickets from this promo code have already been redeemed.')
      case 'insertPromoCode':
        return this.adminText('workflowsAll.customer_insertPromoCode', 'Enter promo code (optional)')
      case 'activate':
        return this.adminText('workflowsAll.customer_activate', 'activate')
      default:
        return original
      }
    },

    workflowExpiry(value) {
      if (!this.isAdminLocalization) return value
      if (value === 'Expired') return this.adminText('workflowsAll.expired_9d19c04', 'Expired')

      return value.replace(/(\d+)(min|y|m|d|h)/g, (match, count, unit) => {
        switch (unit) {
        case 'y':
          return this.adminText('workflowsAll.expiry_y', '{{count}}y', { count })
        case 'm':
          return this.adminText('workflowsAll.expiry_m', '{{count}}m', { count })
        case 'd':
          return this.adminText('workflowsAll.expiry_d', '{{count}}d', { count })
        case 'h':
          return this.adminText('workflowsAll.expiry_h', '{{count}}h', { count })
        case 'min':
          return this.adminText('workflowsAll.expiry_min', '{{count}}min', { count })
        default:
          return match
        }
      })
    },

    workflowPlanOptionLabel(plan) {
      switch (plan && plan.id === null ? plan.name : '') {
      case 'All plans':
        return this.adminText('workflowsAll.all_plans_3d65514', 'All plans')
      default:
        return plan && plan.name
      }
    },

    workflowTicketTypeLabel(value) {
      switch (value) {
      case 'STANDING TICKET':
        return this.adminText('workflowsAll.standing_ticket_449e418', 'STANDING TICKET')
      case 'SEATING TICKET':
        return this.adminText('workflowsAll.seating_ticket_7447f4a', 'SEATING TICKET')
      case 'TABLE TICKET':
        return this.adminText('workflowsAll.table_ticket_14d8a43', 'TABLE TICKET')
      default:
        return value
      }
    },

    workflowPerformanceOption(item, allId = null, withTimeWord = true) {
      switch (item && item.id === allId ? item.from : '') {
      case 'All performances':
        return this.adminText('workflowsAll.all_performances_8787585', 'All performances')
      }
      if (!item) return ''
      if (!withTimeWord) return this.workflowDate(item.from, 'DD.MM.YYYY HH:mm')
      if (!this.isAdminLocalization) return moment(item.from).format('DD.MM.YYYY u HH:mm')

      return this.workflowDate(item.from, 'DD.MM.YYYY [at] HH:mm')
    },

    workflowScreenTitle(value) {
      switch (value) {
      case 'New Accreditation':
        return this.adminText('workflowsAll.new_accreditation_05b5013', 'New Accreditation')
      case 'New Invitee':
        return this.adminText('workflowsAll.new_invitee_ce26347', 'New Invitee')
      case 'Import invitees':
        return this.adminText('workflowsAll.import_invitees_ba49380', 'Import invitees')
      case 'Import attendees':
        return this.adminText('workflowsAll.import_attendees_6d17e83', 'Import attendees')
      default:
        return value
      }
    },

    workflowRecipientOption(value) {
      switch (value) {
      case 'All subscribers':
        return this.adminText('workflowsAll.all_subscribers_1ee3bf4', 'All subscribers')
      case 'Specific subscribers':
        return this.adminText('workflowsAll.specific_subscribers_94602d8', 'Specific subscribers')
      default:
        return value
      }
    },

    workflowImportRequirement(value) {
      switch (value) {
      case '(required)':
        return this.adminText('workflowsAll.required_11893d2', '(required)')
      case '(required) - eg. 1-2-3':
        return this.adminText('workflowsAll.required_eg_1_2_3_8655fdd', '(required) - eg. 1-2-3')
      default:
        return value
      }
    },

    workflowPageSizeOption(value) {
      switch (value) {
      case 'All':
        return this.adminText('workflowsAll.all_97096ee', 'All')
      default:
        return value
      }
    },

    workflowPrintFormatOption(value) {
      switch (value) {
      case 'Web format':
        return this.adminText('workflowsAll.web_format_2f34443', 'Web format')
      case 'Ticket seller format':
        return this.adminText('workflowsAll.ticket_seller_format_827b457', 'Ticket seller format')
      default:
        return value
      }
    },

    workflowGratisTicketOption(value) {
      switch (value) {
      case 'Parter ticket':
        return this.adminText('workflowsAll.parter_ticket_80b2cda', 'Parter ticket')
      case 'Floor Plan':
        return this.adminText('workflowsAll.floor_plan_68fa6c5', 'Floor Plan')
      default:
        return value
      }
    },

    workflowSalesChannelOption(value) {
      switch (value) {
      case 'Specific Outlets + online':
        return this.adminText('workflowsAll.specific_outlets_online_b54bdfd', 'Specific Outlets + online')
      case 'All Outlets + online':
        return this.adminText('workflowsAll.all_outlets_online_4b24c08', 'All Outlets + online')
      default:
        return value
      }
    },

    workflowTicketRowTable() { return this.adminText('workflowsAll.table_ecd31c8', 'Table') },
    workflowTicketRowSeat() { return this.adminText('workflowsAll.seat_b90b325', 'Seat') },
    workflowTicketRowParter() { return this.adminText('workflowsAll.parter_328f837', 'Parter') },
    workflowTicketCell(item, field) {
      if (field === 'Type' && item && item.adminTicketRow) {
        switch (item.Type || item.type) {
        case 'Table': return this.workflowTicketRowTable()
        case 'Seat': return this.workflowTicketRowSeat()
        case 'Parter': return this.workflowTicketRowParter()
        }
      }

      return this.workflowLabel(item && item[field])
    },

    workflowSchemaFieldLabel(field) {
      const source = adminValidationSource(field.errorMessages)
      if (this.isAdminLocalization && source && ['First name', 'Last name', 'Email', 'Address', 'City', 'Country', 'postalCode', 'Postal code'].includes(field.key)) return this.workflowFieldLabel(field.key)
      if (field.key === 'First name' && field.label === 'Ime') return this.adminText('workflowsAll.legacy_first_name', 'Ime')
      if (field.key === 'Last name' && field.label === 'Prezime') return this.adminText('workflowsAll.legacy_last_name', 'Prezime')

      return field.label
    },

    workflowEventOptionLabel(event) {
      if (event && event.id === null && event.name === 'All events') return this.adminText('workflowsAll.all_events_34f96ca', 'All events')

      return event && event.name
    },

    workflowStatsOption(item) {
      if (item && (item.id === null || item.id === 'all')) {
        switch (item.name) {
        case 'All': return this.adminText('workflowsAll.all_97096ee', 'All')
        case 'All ticket types': return this.adminText('workflowsAll.all_ticket_types_4b9bb0a', 'All ticket types')
        case 'All sales channels': return this.adminText('workflowsAll.all_sales_channels_5f8b16d', 'All sales channels')
        case 'All promo codes': return this.adminText('workflowsAll.all_promo_codes_5e02ac5', 'All promo codes')
        }
      }
      if (item && item.type === 'theaterSubscription') return this.adminText('workflowsAll.name_subscription_e6913fb', '{{name}} (Subscription)', { name: item.name })

      return item && item.name
    },

    workflowDate(date, format) {
      const instance = moment(date)
      if (this.isAdminLocalization) instance.locale(this.$adminLocale())
      const displayFormat = this.isAdminLocalization && this.$adminLocale() === 'hr' ? format.replace(/\[at\]/g, '[u]') : format

      return instance.format(displayFormat)
    },

    workflowBuilderFormatLabel(format) {
      switch (format && format.name) {
      case 'T1':
        return this.adminText('workflowsAll.tickets_130mm_x_74_25mm_f26d393', 'Tickets (130mm x 74.25mm)')
      case 'BC1':
        return this.adminText('workflowsAll.business_card_86mm_x_54mm_5d99b43', 'Business card (86mm x 54mm)')
      default:
        return format && format.label
      }
    },
    workflowBuilderPlaceholder(item) {
      if (item.subtype === 'computed' && item.placeholder === 'Full name') return this.adminText('workflowsAll.full_name_eeb6920', 'Full name')
      if (item.subtype === 'country-code' && item.placeholder === 'Country code') return this.adminText('workflowsAll.country_code_25fc029', 'Country code')
      if (item.subtype === 'country-name' && item.placeholder === 'Country name') return this.adminText('workflowsAll.country_name_e0c9676', 'Country name')
      if (item.type === 'category' && item.placeholder === 'Category') return this.adminText('workflowsAll.category_a3c686e', 'Category')

      return item.placeholder
    },

    workflowFieldLabel(value) {
      switch (value) {
      case 'postalCode':
      case 'Postal code':
        return this.adminText('workflowsAll.postal_code_ba4a944', 'Postal code')
      case 'Country':
        return this.adminText('workflowsAll.country_d9d2d25', 'Country')
      case 'City':
        return this.adminText('workflowsAll.city_64c5c29', 'City')
      case 'Address':
        return this.adminText('workflowsAll.address_66dd4d4', 'Address')
      case 'First name':
        return this.adminText('workflowsAll.first_name_35780e2', 'First name')
      case 'Name':
        return this.adminText('workflowsAll.field_name', 'Name')
      case 'Email':
        return this.adminText('workflowsAll.field_email', 'Email')
      case 'Member ID No.':
        return this.adminText('workflowsAll.field_member_id_no_', 'Member ID No.')
      case 'Membership':
        return this.adminText('workflowsAll.field_membership', 'Membership')
      case 'Created':
        return this.adminText('workflowsAll.field_created', 'Created')
      case 'Expires':
        return this.adminText('workflowsAll.field_expires', 'Expires')
      case 'Plan':
        return this.adminText('workflowsAll.field_plan', 'Plan')
      case 'Duration':
        return this.adminText('workflowsAll.field_duration', 'Duration')
      case 'Code':
        return this.adminText('workflowsAll.field_code', 'Code')
      case 'Plan name':
        return this.adminText('workflowsAll.field_plan_name', 'Plan name')
      case 'Event name':
        return this.adminText('workflowsAll.field_event_name', 'Event name')
      case 'Date':
        return this.adminText('workflowsAll.field_date', 'Date')
      case 'Ticket name':
        return this.adminText('workflowsAll.field_ticket_name', 'Ticket name')
      case 'Sold quantity':
        return this.adminText('workflowsAll.field_sold_quantity', 'Sold quantity')
      case 'Discount':
        return this.adminText('workflowsAll.field_discount', 'Discount')
      case 'Start date':
        return this.adminText('workflowsAll.field_start_date', 'Start date')
      case 'End date':
        return this.adminText('workflowsAll.field_end_date', 'End date')
      case 'Season':
        return this.adminText('workflowsAll.field_season', 'Season')
      case 'Subscription Plan':
        return this.adminText('workflowsAll.field_subscription_plan', 'Subscription Plan')
      case 'Package Plan':
        return this.adminText('workflowsAll.field_package_plan', 'Package Plan')
      case 'Package status':
        return this.adminText('workflowsAll.field_package_status', 'Package status')
      case 'Ticket category name':
        return this.adminText('workflowsAll.field_ticket_category_name', 'Ticket category name')
      case 'Color':
        return this.adminText('workflowsAll.field_color', 'Color')
      case 'Priority':
        return this.adminText('workflowsAll.field_priority', 'Priority')
      case 'Ticket type':
        return this.adminText('workflowsAll.field_ticket_type', 'Ticket type')
      case 'Odeum':
        return this.adminText('workflowsAll.field_odeum', 'Odeum')
      case 'Price':
        return this.adminText('workflowsAll.field_price', 'Price')
      case 'E-mail':
        return this.adminText('workflowsAll.field_e_mail', 'E-mail')
      case 'Status':
        return this.adminText('workflowsAll.field_status', 'Status')
      case 'Type':
        return this.adminText('workflowsAll.field_type', 'Type')
      case 'Category':
        return this.adminText('workflowsAll.field_category', 'Category')
      case 'Last name':
        return this.adminText('workflowsAll.field_last_name', 'Last name')
      default:
        return value
      }
    },

    workflowUi(value) {
      if (typeof value === 'string') return this.workflowLabel(value)
      if (value && (Array.isArray(value.workflowParts) || value.workflowCustomer)) return this.workflowLabel(value)
      if (Array.isArray(value)) {
        const copy = value.map(item => this.workflowUi(item))

        return copy.every((item, index) => item === value[index]) ? value : copy
      }
      if (!value || typeof value !== 'object' || Object.getPrototypeOf(value) !== Object.prototype) return value
      const copy = {}
      let changed = false
      for (const key of Object.keys(value)) {
        copy[key] = this.workflowUi(value[key])
        changed = changed || copy[key] !== value[key]
      }

      return changed ? copy : value
    },
  },
}
